/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum TelemetryStatus {
	Success = 1,
	Failure = 2,
}

/** @format int32 */
export enum TelemetryLogType {
	SystemStats = 1,
	SoftwareUpdaterLogs = 2,
	ControllerParameters = 3,
}

export enum TaskType {
	FollowBehindHarvester = "follow_behind_harvester",
	SendToTruck = "send_to_truck",
	StageCart = "stage_cart",
	UnloadToCart = "unload_to_cart",
	TillageCoverage = "tillage_coverage",
	TillageService = "tillage_service",
}

/** @format int32 */
export enum TaskStateType {
	Created = 0,
	Accepted = 1,
	Rejected = 2,
	CancelPending = 3,
	CancelAck = 4,
	Cancelled = 5,
	Completed = 6,
	Failed = 7,
}

/** @format int32 */
export enum SpeedChangeFeedback {
	Success = 0,
	Failure = 1,
	OutOfOrderReject = 2,
	WrongCartReject = 3,
	NoTaskRunning = 4,
}

/** @format int32 */
export enum SpeedChangeDispatchStatus {
	Updated = 0,
	Busy = 1,
	Rejected = 2,
	TimedOut = 3,
}

export enum SoftwareClient {
	ROS = "ROS",
	FlightPath = "FlightPath",
}

export enum SimulatorState {
	Ready = "ready",
	Busy = "busy",
	Offline = "offline",
	Error = "error",
	NotAvailable = "not_available",
}

/** @format int32 */
export enum RosTaskStatus {
	Undefined = 0,
	Scheduled = 1,
	Running = 2,
	Cancelled = 3,
	Failed = 4,
	Completed = 5,
}

/** @format int32 */
export enum RosSubState {
	SystemNotActive = 0,
	Stop = 1,
	StopKillEngine = 2,
	Standby = 3,
	StandbyAutoReady = 4,
	StandbyAutoPending = 5,
	AutoMotionReady = 6,
	AutoMotionPending = 7,
	AutoMotionActive = 8,
	AutoMotionStopping = 9,
	MachineCalibration = 10,
	AutoCalibration = 11,
}

/** @format int32 */
export enum RosState {
	Error = 0,
	Standby = 1,
	Auto = 2,
	Calibration = 3,
}

/** @format int32 */
export enum RosControlType {
	Inactive = 0,
	ParallelPid = 1,
	MachineFollower = 2,
}

/** @format int32 */
export enum RosAutoExitReasons {
	None = 0,
	MasterSwitchIsOff = 1,
	EstopIsOn = 2,
	CriticalAlarmIsActive = 3,
	EngineIsOff = 4,
	StandbyRequested = 5,
	WarningAlarmActive = 6,
	NoActiveMission = 7,
	SpeedControlDisabled = 8,
	BrakeControlDisabled = 9,
	SteeringControlDisabled = 10,
	SpeedIsZero = 11,
	MotionNotRequested = 12,
	Unknown = 13,
}

/** @format int32 */
export enum RosApplicationType {
	None = 0,
	Harvest = 1,
	Tillage = 2,
}

/** @format int32 */
export enum PointOfInterestType {
	ServicePoint = 1,
	TruckZone = 2,
}

/** @format int32 */
export enum PersonDetectionRecoveryOutcome {
	MissionResumed = 0,
	LeftAutoByUserDecision = 1,
	LeftAutoBeforeUserDecision = 2,
	DecisionRejected = 3,
}

/** @format int32 */
export enum PersonDetectionRecoveryDecision {
	ResumeMission = 0,
	DoNotResume = 1,
}

export enum PathRecordingPolygonType {
	Obstacle = "obstacle",
}

/** @format int32 */
export enum PathRecordingEventType {
	Pause = 1,
	Resume = 2,
	ObstacleStart = 3,
	ObstacleEnd = 4,
}

/** @format int32 */
export enum MissionType {
	Tillage = 0,
	Harvest = 1,
}

/** @format int32 */
export enum MissionEventType {
	StartMission = 0,
	StopMission = 1,
	ResumeMission = 2,
	StartJob = 3,
	StopJob = 4,
	ResumeJob = 5,
}

/** @format int32 */
export enum MachineType {
	Unknown = 1,
	Harvester = 2,
	GrainCart = 3,
}

/** @format int32 */
export enum MachineAssignmentStatus {
	Pending = 0,
	Joined = 1,
	Rejected = 2,
	Left = 3,
}

/** @format int32 */
export enum LineFeatureType {
	GuidanceLine = 1,
}

/** @format int32 */
export enum InstanceState {
	Pending = 0,
	Running = 1,
	Stopping = 2,
	Stopped = 3,
	ShuttingDown = 4,
	Terminated = 5,
	Unknown = 6,
}

/** @format int32 */
export enum ImplementType {
	Tiller = 0,
	CombineHeader = 1,
	Spreader = 2,
	GrainCart = 3,
}

/** @format int32 */
export enum ImplementTimingCalibrationStep {
	StartCalibrationRoutine = 1,
	StopCalibrationRoutine = 2,
}

/** @format int32 */
export enum ImplementSensorCalibrationStep {
	StartSensorCalibration = 1,
	SetGroundPosition = 2,
	SetZeroPosition = 3,
	StartDynamicCalibrationSequence = 4,
	StopCalibrationRoutine = 5,
}

/** @format int32 */
export enum ImplementPosition {
	Invalid = 0,
	Lowered = 1,
	Raised = 2,
	InTransition = 3,
}

/** @format int32 */
export enum ImplementAction {
	TurnOn = 0,
	TurnOff = 1,
}

/** @format int32 */
export enum GnssMethod {
	NoGps = 0,
	GnssFix = 1,
	DgnssFix = 2,
	PreciseGnss = 3,
	RtkFixedInteger = 4,
	RtkFloat = 5,
	EstimatedMode = 6,
	ManualInput = 7,
	SimulateMode = 8,
	Error = 9,
	Undefined = 10,
}

/** @format int32 */
export enum DeployedSinglePathMissionCloudState {
	LaunchRequest = 0,
	Pending = 1,
	DeployedRunning = 2,
	Canceled = 3,
	ConfirmedCompleted = 4,
}

/** @format int32 */
export enum ConnectorType {
	TractorDrawBar = 0,
	ThreePointHitchMounted = 1,
}

export enum CompatibilityIssueCode {
	ValueMismatch = "value_mismatch",
	PlannedPropertyMissing = "planned_property_missing",
	CurrentPropertyMissing = "current_property_missing",
	PlannedImplementNotFound = "planned_implement_not_found",
	CurrentImplementNotFound = "current_implement_not_found",
	CalibrationNotFound = "calibration_not_found",
	TurningRadiusUnavailable = "turning_radius_unavailable",
	PlannedPathNotFound = "planned_path_not_found",
	ImplementNotAssigned = "implement_not_assigned",
}

/** @format int32 */
export enum BoundaryType {
	Field = 1,
	Coverage = 2,
	WorkArea = 3,
	SpeedZone = 4,
	NoCoverageZone = 5,
	NoGoZone = 6,
	InnerField = 7,
	Road = 8,
	Geofence = 9,
}

/** @format int32 */
export enum AppNotificationType {
	Unknown = 0,
	HumanAvoidable = 1,
	HumanImminent = 2,
	NonHumanAvoidable = 3,
	NonHumanImminent = 4,
	PerceptionMinorFault = 5,
	PerceptionMajorFault = 6,
	ImplementExceededMaxAngle = 7,
	ImplementUnresponsive = 8,
	LowFuel = 10,
	LowDef = 11,
	AutoState = 12,
	EStop = 13,
	WarnAlarmCheck = 14,
	CriticalAlarmCheck = 15,
	LeftGnssSystemCheck = 16,
	LeftGnssCorrectionCheck = 17,
	LeftGnssFixCheck = 18,
	LeftGnssImuCheck = 19,
	RightGnssSystemCheck = 20,
	RightGnssCorrectionCheck = 21,
	RightGnssFixCheck = 22,
	RightGnssImuCheck = 23,
	SafetySystemInterruption = 24,
	FastFollowPathPositionErrorCheck = 25,
	SlowFollowPathPositionErrorCheck = 26,
	MachineFollowerPositionErrorCheck = 27,
	MachineFollowerSpeedCheck = 28,
	UnloadTargetPositionValidCheck = 29,
	ProximityConnectionLostWhileUnloading = 30,
	FrontStagingCollisionPath = 31,
	WheelSlip = 32,
	MotionMonitorCrossTrackErrorExceeded = 33,
}

export enum AcceptMissionResult {
	Accepted = "Accepted",
	DualDeployTimeout = "DualDeployTimeout",
	AlreadyRejected = "AlreadyRejected",
}

export type MetricsUpdateMessage = BaseMetricsUpdateMessage &
	(
		| BaseMetricsUpdateMessageTypeMapping<"gps", GpsMetricsMessage>
		| BaseMetricsUpdateMessageTypeMapping<
				"machine_data",
				MachineDataMetricsMessage
		  >
		| BaseMetricsUpdateMessageTypeMapping<
				"mission_event",
				MissionEventMessage
		  >
		| BaseMetricsUpdateMessageTypeMapping<"task_event", TaskEventMessage>
		| BaseMetricsUpdateMessageTypeMapping<
				"ros_state_event",
				RosStateEventMessage
		  >
		| BaseMetricsUpdateMessageTypeMapping<
				"implement_control",
				ImplementControlMetricsMessage
		  >
		| BaseMetricsUpdateMessageTypeMapping<
				"implement_calibration",
				ImplementCalibrationMetricsMessage
		  >
	);

export type JohnDeereGuidanceLineObjectDto =
	BaseJohnDeereGuidanceLineObjectDto &
		(
			| BaseJohnDeereGuidanceLineObjectDtoTypeMapping<
					"ABLine",
					JohnDeereAbLineDto
			  >
			| BaseJohnDeereGuidanceLineObjectDtoTypeMapping<
					"CircleTrack",
					JohnDeereCircleTrackDto
			  >
			| BaseJohnDeereGuidanceLineObjectDtoTypeMapping<
					"ABCurve",
					JohnDeereAbCurveDto
			  >
		);

export interface AcceptMissionResponse {
	Result: AcceptMissionResult;
	Reason?: string | null;
}

export interface AccountDto {
	/** @format uuid */
	id: string;
	name: string;
	description: string;
	isEngOrg: boolean;
	isActive: boolean;
	/** @format uuid */
	dealerId?: string | null;
	address: string;
	city: string;
	state: string;
	countryId: string;
	countryName?: string | null;
	zipCode: string;
	phone: string;
	/** @format uuid */
	organizationOwnerUserId?: string | null;
	organizationOwnerUserEmail: string;
	organizationOwnerName?: string | null;
}

export interface ActiveImplementCalibrationMessage {
	/** @format int32 */
	TurnOnTimeMs: number;
	/** @format int32 */
	TurnOffTimeMs: number;
	Source: string | null;
}

export interface AddAutoHarvestPathFileRequest {
	/** @minLength 1 */
	FileBase64: string;
}

export interface AppNotificationBanner {
	/** @format uuid */
	CustomerId: string;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	DeployedMissionId: string;
	/** @format date-time */
	Stamp: string;
	/** @format double */
	Latitude: number;
	/** @format double */
	Longitude: number;
	NotificationMessage?: string | null;
	NotificationType: AppNotificationType;
}

export interface AssignedMissionResponse {
	Mission?: Mission;
	Status?: MachineAssignmentStatus;
	/** @format uuid */
	MissionId: string;
}

export interface AttachIotPolicyRequest {
	CognitoIdentityId: string;
}

export interface AttachIotPolicyResponse {
	Attached: boolean;
}

export interface AutonomousTask {
	/** @format uuid */
	Id: string;
	TaskType: TaskType;
	TaskStatus: TaskStateType;
	/** @format uuid */
	SourceMachineId?: string | null;
	/** @format uuid */
	TargetMachineId: string;
	/** GeoJSON LineString */
	Path?: LineString;
	ClothoidPath?: ClothoidPath;
	/** @format uuid */
	PathId?: string | null;
	/** GeoJSON Point */
	TargetPoint?: Point;
	/** @format int32 */
	TargetWaypointIndex?: number | null;
	/** @format double */
	TargetBearing?: number | null;
	/** @format double */
	TargetSpeed?: number | null;
	/** @format double */
	ApproachSpeed?: number | null;
	/** @format double */
	TurningSpeed?: number | null;
	/** @format int32 */
	Reason?: number | null;
	/** @format uuid */
	DeployedBy?: string | null;
	DeployedByEmail?: string | null;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
}

export interface AutonomyTaskData {
	/** GeoJSON LineString */
	Path: LineString;
	TaskType: string;
	/** @format date-time */
	StartedAt: string;
}

export interface AutonomyTaskPath {
	/** @format uuid */
	MissionId: string;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	TaskId: string;
	/** GeoJSON LineString */
	Path: LineString;
	TaskType: string | null;
	/** @format date-time */
	StartTime: string;
}

export interface BinDto {
	/** @format int32 */
	readonly ElementIndex: number;
	/** @format int32 */
	readonly ParentIndex: number;
	/** @format int32 */
	PhysicalSetPointTimeLatencyMilliseconds: number;
	ActualCulturalPractice?: string | null;
}

export interface BoomDto {
	/** @format int32 */
	readonly ElementIndex: number;
	/** @format int32 */
	readonly ParentIndex: number;
	/** @format int32 */
	SectionControlTurnOnMilliseconds: number;
	/** @format int32 */
	SectionControlTurnOffMilliseconds: number;
	/** @format double */
	SetPointRate: number;
	/** @format double */
	SectionControlOverlapThreshold: number;
	LeaveImplementDownOnTurns: boolean;
}

export interface Boundary {
	/** @format uuid */
	id: string;
	type: BoundaryType;
	/** GeoJSON Geometry */
	geometry: Geometry;
	/** @format date-time */
	created: string;
	/** @format date-time */
	updated: string;
	/** @format double */
	SpeedLimit?: number | null;
	/** @maxLength 255 */
	name?: string | null;
}

export interface BoundaryGeofence {
	/** GeoJSON Geometry */
	geometry?: Geometry;
	/** GeoJSON Geometry */
	bufferedGeometry?: Geometry;
}

export interface BoundaryParameters {
	/** @format double */
	SpeedLimit?: number | null;
}

export interface BoundarySummary {
	/** @format uuid */
	id: string;
	type: BoundaryType;
	/** @format date-time */
	created: string;
	/** @format date-time */
	updated: string;
	/** @format double */
	areaM2: number;
	/** GeoJSON Polygon */
	bbox: Polygon;
	/** @format double */
	SpeedLimit?: number | null;
	/** @maxLength 255 */
	name?: string | null;
}

export interface BoundaryUpdate {
	/** @format uuid */
	id: string;
	type: BoundaryType;
	/** GeoJSON Geometry */
	geometry: Geometry;
	/** @format double */
	SpeedLimit?: number | null;
	/** @maxLength 255 */
	name?: string | null;
}

export interface ChannelDto {
	/** @format uuid */
	AccountId: string;
	/** @format uuid */
	MachineId: string;
	ChannelName: string;
	CameraName: string;
	ChannelArn: string;
}

export interface ClothoidPath {
	Metadata?: PathMetadata;
	Origin?: PathOrigin;
	Segments?: ClothoidSegment[] | null;
	Type?: string | null;
}

export interface ClothoidSegment {
	/** @format double */
	CurvatureRate: number;
	/** @format double */
	InitialCurvature: number;
	/** @format double */
	InitialHeading: number;
	/** @format double */
	North: number;
	/** @format double */
	East: number;
	/** @format double */
	Up: number;
	/** @format double */
	Length: number;
	/**
	 * @deprecated
	 * @format double
	 */
	MaxSpeedKph: number;
	/** @format double */
	MaxSpeed: number;
	SegmentMetadata?: string | null;
	SegmentType?: string | null;
}

export interface CloudJobNotification {
	/** @format uuid */
	JobId: string;
	/**
	 * @deprecated
	 * @format uuid
	 */
	ImplementId?: string | null;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	AccountId: string;
	Message?: string | null;
}

export interface CombinedMetricSample {
	/** @format date-time */
	Timestamp: string;
	/** @format date-time */
	GpsTimestamp?: string | null;
	/** GeoJSON Point */
	Location?: Point;
	/** @format int32 */
	SegmentId?: number | null;
	/** @format double */
	Bearing?: number | null;
	/** @format double */
	Speed?: number | null;
	/** @format int32 */
	GpsFix?: number | null;
	State: RosState;
	SubState: RosSubState;
	/** @format double */
	CoolantTemp?: number | null;
	/** @format double */
	EngineLoad?: number | null;
	/** @format double */
	EngineRpm?: number | null;
	/** @format double */
	FuelLevel?: number | null;
	ImplementPosition?: ImplementPosition;
	/** @format double */
	CrossTrackError?: number | null;
	/** @format double */
	SideSlip?: number | null;
	/** @format double */
	DefLevel?: number | null;
	PositionAutoReady?: boolean | null;
	EngineRunning?: boolean | null;
	MasterSwitchActive?: boolean | null;
	NoActiveCriticalAlarms?: boolean | null;
	NoActiveWarningAlarms?: boolean | null;
	ControlType?: RosControlType;
	/** @format double */
	WheelSlipPercent?: number | null;
}

export interface CombinedMetricsPage {
	Data: CombinedMetricSample[];
	HasMore: boolean;
	/** @format int64 */
	TotalCount?: number | null;
}

export interface CompressedDrivenPathSegment {
	/** @format date-time */
	StartTime: string;
	/** @format date-time */
	EndTime: string;
	CompressedSegment: string;
}

export interface ConfigurationCompatibilityIssue {
	Code: CompatibilityIssueCode;
	PropertyPath: string;
}

export interface ConfirmRefreshLookAheadsRequest {
	Successful: boolean;
	ErrorMessage?: string | null;
}

export interface ContentResult {
	Content?: string | null;
	ContentType?: string | null;
	/** @format int32 */
	StatusCode?: number | null;
}

export interface Country {
	id: string;
	name?: string | null;
}

export interface CoverageGenerationState {
	/** GeoJSON MultiPolygon */
	Coverage: MultiPolygon;
	DrivenPath: Record<string, Point[]>;
	ImplementState?: ImplementState;
	PrevMetric?: GpsMetrics;
}

export interface CoverageUpdateMessageBase {
	/** @format uuid */
	JobId: string;
	/** @format date-time */
	GpsTime: string;
}

export interface CreateEnumOptionRequest {
	Value: string;
	Label: string;
	/** @format int32 */
	SortOrder: number;
}

export interface CreateFeatureFlagKeyRequest {
	KeyName: string;
	DisplayName: string;
	Description?: string | null;
	ValueType: string;
	AdminOnly: boolean;
	EnumOptions?: NewFeatureFlagEnumOption[] | null;
	GlobalDefault?: string | null;
}

export interface CreateFoxgloveDevice {
	name: string;
	properties: FoxgloveDeviceProperties;
}

export interface CreateObstacleRequest {
	/** @format uuid */
	MachineId: string;
	/** GeoJSON Point */
	LocationCenter: Point;
	/** GeoJSON Point */
	LocationLeft: Point;
	/** GeoJSON Point */
	LocationRight: Point;
	/** @format date-time */
	GpsTime: string;
}

export interface CreatePathRecordingEventRequest {
	EventType: PathRecordingEventType;
	/** GeoJSON Point */
	LocationCenter?: Point;
	/** GeoJSON Point */
	LocationLeft?: Point;
	/** GeoJSON Point */
	LocationRight?: Point;
	/** @format date-time */
	GpsTime?: string | null;
}

export interface CreatePlannedPathRequest {
	/** @minItems 2 */
	Path: SimplePoint[];
	/** @format uuid */
	MachineId?: string | null;
	/** @format uuid */
	ImplementId?: string | null;
	/** @format double */
	TurningRadiusMeters?: number | null;
	PlanningParameters?: any;
}

export interface CreateUmcUserRequest {
	email: string;
	name?: string | null;
}

export interface DealerDto {
	/** @format uuid */
	id: string;
	name: string;
	accountManager: string;
	specialist: string;
	address: string;
	city: string;
	state: string;
	countryId: string;
	countryName?: string | null;
	zipCode: string;
	phone: string;
	email: string;
	isActive?: boolean | null;
	/** @format uuid */
	dealerOwnerUserId?: string | null;
	dealerOwnerUserEmail?: string | null;
	dealerOwnerName?: string | null;
	/** @format date-time */
	createdAt?: string | null;
}

export interface DealerKinesisCredentialsRequest {
	accountId: string;
	channelName: string;
	region: string;
}

export interface DealerKinesisCredentialsResponse {
	accessKeyId: string;
	secretAccessKey: string;
	sessionToken: string;
	/** @format date-time */
	expiration: string;
	region: string;
	channelName: string;
}

export interface DealerUserDto {
	/** @format uuid */
	userId: string;
	userEmail: string;
	name?: string | null;
	userStatus: string;
	isUserEnabled: boolean;
	isEmailVerified: boolean;
	userGroups?: string[] | null;
	/** @format uuid */
	dealerId: string;
	dealerName: string;
}

export interface DeletePathRecordingEventsRequest {
	EventIds: string[];
}

export interface DrivenPathSegment {
	/** @format date-time */
	EndTime: string;
	/** @format date-time */
	StartTime: string;
	/** GeoJSON LineString */
	Points: LineString;
	/** @format int32 */
	SegmentId?: number | null;
}

export interface Ecu {
	Name: string;
	Version: string;
}

export interface EventBaseModel {
	/** @format uuid */
	EventId: string;
	EventType: string;
	/** @format date-time */
	StartTime: string;
	/** @format date-time */
	EndTime: string;
	/** @format uuid */
	AccountId: string;
	/** @format uuid */
	MachineId: string;
	/** @format date-time */
	RosbagUploadCompletedTime?: string | null;
	BagName?: string | null;
	/** @format uuid */
	SnapshotId?: string | null;
	Reason?: string | null;
}

export interface EventBaseModelPageResponse {
	Data: EventBaseModel[];
	/** @format int32 */
	Page: number;
	/** @format int32 */
	PageSize: number;
	/** @format int32 */
	TotalCount: number;
	/** @format int32 */
	TotalPages: number;
	HasNextPage: boolean;
}

export interface EventDetailsModel {
	/** @format uuid */
	EventId: string;
	EventType: string;
	/** @format date-time */
	StartTime: string;
	/** @format date-time */
	EndTime: string;
	/** @format uuid */
	AccountId: string;
	/** @format uuid */
	MachineId: string;
	/** @format date-time */
	RosbagUploadCompletedTime?: string | null;
	BagName?: string | null;
	/** @format uuid */
	SnapshotId?: string | null;
	Reason?: string | null;
	/** @format uuid */
	MissionId?: string | null;
	/** @format uuid */
	SessionId: string;
	/** @format uuid */
	TaskId?: string | null;
	TaskType?: string | null;
	StreamName: string;
	JobId?: string | null;
	SoftwareVersion: string;
	/** @format date-time */
	LastUpdated: string;
	Images?: StillImage[] | null;
}

export interface FarmDto {
	/** @format uuid */
	id: string;
	name: string;
	archived: boolean;
}

export interface FarmEngageBoundaryDto {
	/** @format uuid */
	id: string;
	name: string;
	/** @format uuid */
	fieldId: string;
	isRetired: boolean;
	/** @format date-time */
	modifiedAt: string;
	links: FarmEngageResourceLinkDto[];
	/** GeoJSON Geometry */
	geometry?: Geometry;
}

export interface FarmEngageFieldDto {
	/** @format uuid */
	id: string;
	name?: string | null;
	/** @format uuid */
	farmId?: string | null;
	farm?: string | null;
	/** @format double */
	area?: number | null;
	origin?: string | null;
	isRetired: boolean;
	/** @format date-time */
	modifiedAt: string;
	links?: FarmEngageResourceLinkDto[] | null;
}

export interface FarmEngageFieldExtentDto {
	/** GeoJSON Geometry */
	geography?: Geometry;
	links?: FarmEngageResourceLinkDto[] | null;
}

export interface FarmEngageGuidanceLineArrayItemDto {
	/** @format uuid */
	id: string;
	name?: string | null;
	/** @format uuid */
	fieldId?: string | null;
	isRetired: boolean;
	/** @format date-time */
	modifiedAt: string;
	links?: FarmEngageResourceLinkDto[] | null;
}

export interface FarmEngageGuidanceLineDetailDto {
	/** @format uuid */
	id: string;
	name?: string | null;
	/** @format uuid */
	fieldId?: string | null;
	isRetired: boolean;
	/** @format date-time */
	modifiedAt: string;
	links?: FarmEngageResourceLinkDto[] | null;
	/** GeoJSON Geometry */
	geometry?: Geometry;
	type?: string | null;
	/** GeoJSON Geometry */
	origin?: Geometry;
	/** @format uuid */
	infillId?: string | null;
	/** @format int32 */
	numberOfSwaths?: number | null;
}

export interface FarmEngageGuidanceLineListDto {
	result: FarmEngageGuidanceLineArrayItemDto[];
	bookmark?: string | null;
}

export interface FarmEngageOrganizationDto {
	/** @format uuid */
	id: string;
	name: string;
	timezoneName?: string | null;
	currencyCode?: string | null;
	isMetric: boolean;
	links: FarmEngageResourceLinkDto[];
}

export interface FarmEngageResourceLinkDto {
	href: string;
	rel: string;
	method: string;
}

export interface FeatureFlagAdminDto {
	Username: string;
	Email: string;
}

export interface FeatureFlagAuditEntry {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	FeatureFlagKeyId: string;
	/** @format uuid */
	FeatureFlagValueId?: string | null;
	Action: string;
	ScopeLevel?: string | null;
	/** @format uuid */
	OrganizationId?: string | null;
	/** @format uuid */
	MachineId?: string | null;
	OldValue?: string | null;
	NewValue?: string | null;
	/** @format uuid */
	UserId: string;
	UserEmail?: string | null;
	/** @format date-time */
	CreatedAt: string;
}

export interface FeatureFlagEnumOption {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	FeatureFlagKeyId: string;
	Value: string;
	Label: string;
	/** @format int32 */
	SortOrder: number;
}

export interface FeatureFlagKey {
	/** @format uuid */
	Id: string;
	KeyName: string;
	DisplayName: string;
	Description?: string | null;
	ValueType: string;
	AdminOnly: boolean;
	IsActive: boolean;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
}

export interface FeatureFlagKeyDetail {
	Key: FeatureFlagKey;
	EnumOptions: FeatureFlagEnumOption[];
}

export interface FeatureFlagValue {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	FeatureFlagKeyId: string;
	ScopeLevel: string;
	/** @format uuid */
	OrganizationId?: string | null;
	/** @format uuid */
	MachineId?: string | null;
	Value: string;
	IsActive: boolean;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
}

export interface Field {
	/** @format uuid */
	id: string;
	/** @minLength 1 */
	name: string;
	/** @format date-time */
	created: string;
	/** @format date-time */
	updated: string;
}

export interface FieldBoundaryDto {
	/** @format uuid */
	farmId: string;
	/** @format uuid */
	fieldId: string;
	/** GeoJSON Geometry */
	geometry: Geometry;
}

export interface FieldDto {
	/** @format uuid */
	fieldId: string;
	name: string;
	archived: boolean;
	/** @format date-time */
	lastModifiedUtc: string;
}

export interface FieldInfo {
	/** @format uuid */
	Id: string;
	Name: string;
	/** @format date-time */
	Created: string;
	/** @format date-time */
	Updated: string;
	BoundaryThumbnail: string;
	Boundaries: BoundarySummary[];
	/** @format double */
	AreaM2: number;
	/** @format date-time */
	LastWorkedOn: string | null;
	MissionIds: string[];
}

export interface FieldUpdate {
	/** @format uuid */
	id: string;
	/** @minLength 1 */
	name: string;
}

export interface FoxgloveDevice {
	id: string;
	name?: string | null;
	"project-id"?: string | null;
	properties?: FoxgloveDeviceProperties;
	enabled?: boolean | null;
}

export interface FoxgloveDeviceProperties {
	"machine-name"?: string | null;
	"machine-make"?: string | null;
	"machine-model"?: string | null;
	"machine-year"?: string | null;
	"kit-serial-number"?: string | null;
}

export type FullCoverageUpdateMessage = CoverageUpdateMessageBase & {
	CompressedCoverage?: string | null;
};

export interface FullDrivenPathCoverageCombinedUncompressed {
	/** GeoJSON MultiPolygon */
	Coverage: MultiPolygon;
	DrivenPath: DrivenPathSegment[];
	/** @format uuid */
	MachineId: string;
}

export interface FullDrivenPathCoverageCombinedUpdateMessage {
	/** @format uuid */
	JobId: string;
	/** @format date-time */
	GpsTime: string;
	CompressedCoverage: string;
	CompressedDrivenPath: CompressedDrivenPathSegment[];
}

export interface FullDrivenPathUpdateMessage {
	/** @format uuid */
	JobId: string;
	/** @format date-time */
	GpsTime: string;
	CompressedDrivenPath: CompressedDrivenPathSegment[];
}

export interface GeneratedCoverageResponse {
	/** GeoJSON MultiPolygon */
	Coverage: MultiPolygon;
	/** GeoJSON MultiLineString */
	DrivenPath: MultiLineString;
}

/** GeoJSON Geometry */
export type Geometry =
	| Point
	| MultiPoint
	| LineString
	| MultiLineString
	| Polygon
	| MultiPolygon;

export interface GetStageResponse {
	/** @minLength 1 */
	stage: string;
}

export interface GpsLocation {
	/** @format double */
	Longitude: number;
	/** @format double */
	Latitude: number;
	/** @format double */
	Bearing: number;
	/** @format double */
	Speed: number;
	/** @format float */
	Hdop: number;
	/** @format float */
	Pdop: number;
	/** @format int32 */
	NumberOfSVs: number;
	/** @format date-time */
	TimeStamp: string;
	/** @format int32 */
	MilisecondCount?: number | null;
	/** @format double */
	Elevation: number;
	/** @format double */
	RelativeElevation: number;
	Method: GnssMethod;
}

export interface GpsMetrics {
	/** @format date-time */
	Timestamp: string;
	/** GeoJSON Point */
	Location: Point;
	/** @format int32 */
	SegmentId: number;
	/** @format double */
	Bearing: number;
	/** @format double */
	Speed: number;
	/** @format int32 */
	GpsFix: number;
}

export type GpsMetricsMessage = BaseMetricsUpdateMessage & {
	/** GeoJSON Point */
	point: Point;
	/** @format double */
	speed: number;
	/** @format double */
	bearing: number;
	/** @format int32 */
	gps_fix: number;
	/** @format int32 */
	gpsFix?: number | null;
	/** @format double */
	roll?: number | null;
	/** @format double */
	pitch?: number | null;
};

export interface GpsMetricsPagedMetricsResponse {
	Data: GpsMetrics[];
	/** @format int32 */
	Page: number;
	/** @format int32 */
	PageSize: number;
	/** @format int32 */
	TotalCount?: number | null;
	/** @format int32 */
	TotalPages?: number | null;
	HasNextPage?: boolean | null;
}

export interface HarvesterOffsets {
	/** @format uuid */
	MachineId: string;
	/** @format double */
	CenterCombineToCenterGps: number;
	/** @format double */
	TopGpsToBottomCombine: number;
	/** @format double */
	FrontAxleToCenterGps: number;
	/** @format double */
	WheelBase: number;
	LeftOfCenter: boolean;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
}

export interface ImageVersions {
	Ros?: string | null;
	Sim?: string | null;
	Flightpath?: string | null;
	App?: string | null;
	Pgsql?: string | null;
	Mqtt?: string | null;
}

export interface ImplementActiveLookaheadMessage {
	/** @format int32 */
	TurnOnTimeMs: number;
	/** @format int32 */
	TurnOffTimeMs: number;
	/** @format date-time */
	Timestamp: string;
}

export interface ImplementAssignmentDetails {
	/** @format uuid */
	ImplementId: string;
	/** @format uuid */
	MachineId: string;
	/** @format date-time */
	StartAt: string;
	/** @format date-time */
	EndAt?: string | null;
}

export type ImplementCalibrationMetricsMessage = BaseMetricsUpdateMessage & {
	/** @format uuid */
	implement_id: string;
	/** @format int32 */
	measurement_milliseconds: number;
	action: ImplementAction;
};

export interface ImplementCalibrationRequest {
	/** @format int32 */
	implement_up_time: number;
	/** @format int32 */
	implement_down_time: number;
	Message?: string | null;
}

export interface ImplementConnectorDto {
	/** @format int32 */
	ParentIndex: number;
	ConnectorType: ConnectorType;
}

export type ImplementControlMetricsMessage = BaseMetricsUpdateMessage & {
	/** @format uuid */
	implement_id: string;
	action: ImplementAction;
	/** @format int32 */
	section_index: number;
};

export interface ImplementMachineCalibration {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	ImplementId: string;
	/** @format double */
	TurningRadiusMeters: number;
	/** @format int32 */
	ImplementOnTimeMs?: number | null;
	/** @format int32 */
	ImplementOffTimeMs?: number | null;
	/** @format uuid */
	CalibrationJobId?: string | null;
	/** @format date-time */
	LastCalibrationTime?: string | null;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
}

export interface ImplementState {
	TractorCenter: GpsLocation;
	ImplementCenter: GpsLocation;
	HitchLocation: GpsLocation;
	/** @format double */
	HitchAngleDegrees: number;
}

export interface ImplementV2Model {
	/** @format uuid */
	ImplementId: string;
	ImplementName: string;
	/** @format uuid */
	CustomerId: string;
	Bins: BinDto[];
	Booms: BoomDto[];
	Sections: SectionDto[];
	Connectors: ImplementConnectorDto[];
	ImplementType?: ImplementType;
	NavigationReferencePoint: ReferencePoint3D;
	ConnectorReferencePointTractor: ReferencePoint2D;
	ConnectorReferencePointImplement: ReferencePoint2D;
	ApplicationParameters: string;
}

export interface InterruptionsPer100AcresResult {
	/** @format double */
	InterruptionsPer100Acres?: number | null;
	/** @format int64 */
	InterruptionCount: number;
	/** @format double */
	TotalAutonomousAcres: number;
}

export interface InterruptionsPerAreaResult {
	/** @format double */
	InterruptionsPerArea?: number | null;
	/** @format int64 */
	InterruptionCount: number;
	/** @format double */
	TotalAutonomousArea: number;
}

export interface JobInfo {
	/** @format uuid */
	JobId: string;
	/** @format uuid */
	ImplementId: string;
}

export type JohnDeereAbCurveDto = BaseJohnDeereGuidanceLineObjectDto & {
	/** @format double */
	heading?: number | null;
	aPoint?: JohnDeerePointDto;
	bPoint?: JohnDeerePointDto;
	eastShift?: JohnDeereMeasurementAsDoubleDto;
	northShift?: JohnDeereMeasurementAsDoubleDto;
	/** @format double */
	tramOffset?: number | null;
	/** @format int32 */
	tramSpacing?: number | null;
	extent?: JohnDeereGuidanceExtentDto;
	signalType?: string | null;
	shapes?: JohnDeereMultiPointDto[] | null;
	saveMethod?: string | null;
	spatialProjection?: JohnDeereSpatialProjectionDto;
	fieldUri?: string | null;
};

export type JohnDeereAbLineDto = BaseJohnDeereGuidanceLineObjectDto & {
	/** @format double */
	heading?: number | null;
	aPoint?: JohnDeerePointDto;
	bPoint?: JohnDeerePointDto;
	eastShift?: JohnDeereMeasurementAsDoubleDto;
	northShift?: JohnDeereMeasurementAsDoubleDto;
	/** @format double */
	tramOffset?: number | null;
	/** @format int32 */
	tramSpacing?: number | null;
	saveMethod?: string | null;
	spatialProjection?: JohnDeereSpatialProjectionDto;
	fieldUri?: string | null;
};

export interface JohnDeereBoundaryDto {
	"@type": string;
	name?: string | null;
	sourceType?: string | null;
	/** @format date-time */
	createdTime?: string | null;
	/** @format date-time */
	modifiedTime?: string | null;
	area?: JohnDeereBoundaryMeasurementDto;
	workableArea?: JohnDeereBoundaryMeasurementDto;
	multipolygons?: JohnDeereBoundaryPolygonDto[] | null;
	extent?: JohnDeereBoundaryExtentDto;
	centroid?: JohnDeerePointDto;
	archived: boolean;
	signalType?: string | null;
	id?: string | null;
	links?: JohnDeereLinkDto[] | null;
	active?: boolean | null;
	irrigated?: boolean | null;
}

export interface JohnDeereBoundaryExtentDto {
	"@type": string;
	topLeft?: JohnDeerePointDto;
	bottomRight?: JohnDeerePointDto;
}

export interface JohnDeereBoundaryListDto {
	links?: JohnDeereLinkDto[] | null;
	/** @format int32 */
	total: number;
	values: JohnDeereBoundaryDto[];
}

export interface JohnDeereBoundaryMeasurementDto {
	"@type": string;
	/** @format double */
	valueAsDouble: number;
	unit?: string | null;
}

export interface JohnDeereBoundaryPolygonDto {
	"@type": string;
	rings?: JohnDeereBoundaryRingDto[] | null;
}

export interface JohnDeereBoundaryRingDto {
	"@type": string;
	points?: JohnDeerePointDto[] | null;
	/** @format int32 */
	id?: number | null;
	headlands?: any[] | null;
	creationMethod?: string | null;
	type?: string | null;
	passable?: boolean | null;
	name?: string | null;
}

export type JohnDeereCircleTrackDto = BaseJohnDeereGuidanceLineObjectDto & {
	/** @format double */
	radialHeading?: number | null;
	centerPoint?: JohnDeerePointDto;
	circleEdgeRadius?: JohnDeereMeasurementAsDoubleDto;
	radiusOffset?: JohnDeereMeasurementAsDoubleDto;
	radialShift?: JohnDeereMeasurementAsDoubleDto;
	/** @format double */
	tramOffset?: number | null;
	/** @format int32 */
	tramSpacing?: number | null;
	saveMethod?: string | null;
	spatialProjection?: JohnDeereSpatialProjectionDto;
	fieldUri?: string | null;
};

export interface JohnDeereGuidanceExtentDto {
	"@type": string;
	topLeft?: JohnDeerePointDto;
	bottomRight?: JohnDeerePointDto;
}

export interface JohnDeereLinkDto {
	"@type": string;
	rel: string;
	uri: string;
}

export interface JohnDeereMeasurementAsDoubleDto {
	"@type": string;
	/** @format double */
	valueAsDouble: number;
	vrDomainId: string;
	unit: string;
}

export interface JohnDeereMultiPointDto {
	"@type": string;
	points?: JohnDeerePointDto[] | null;
}

export interface JohnDeerePointDto {
	"@type": string;
	/** @format double */
	lat: number;
	/** @format double */
	lon: number;
}

export interface JohnDeereSpatialProjectionDto {
	"@type": string;
	projectionType: string;
	elevation?: JohnDeereMeasurementAsDoubleDto;
}

export interface LeaveMissionResponse {
	/** @format uuid */
	MissionId: string;
	Warning?: string | null;
}

export interface LineFeature {
	/** @format uuid */
	id: string;
	type: LineFeatureType;
	/** GeoJSON Geometry */
	geometry: Geometry;
	/** @format date-time */
	created: string;
	/** @format date-time */
	updated: string;
	/** @format date-time */
	inactiveAt?: string | null;
}

/** GeoJSON LineString */
export interface LineString {
	type?: "LineString";
	coordinates?: Position[];
}

export interface ListCertsResponse {
	harvesters: string[];
	carts: string[];
}

export type MachineDataMetricsMessage = BaseMetricsUpdateMessage & {
	state: RosState;
	substate: RosSubState;
	active_big_obstacle?: boolean | null;
	active_person?: boolean | null;
	control_type?: RosControlType;
	/** @format double */
	coolant_temp?: number | null;
	/** @format double */
	cross_track_error?: number | null;
	/** @format int32 */
	current_waypoint?: number | null;
	/** @format double */
	def_level?: number | null;
	/** @format double */
	engine_load?: number | null;
	/** @format double */
	engine_rpm?: number | null;
	engine_running?: boolean | null;
	/** @format double */
	fuel_level?: number | null;
	implement_position?: ImplementPosition;
	hitch_position?: string | null;
	master_switch_active?: boolean | null;
	/** @format double */
	mission_completion_percentage?: number | null;
	no_active_critical_alarms?: boolean | null;
	no_active_warning_alarms?: boolean | null;
	perception_faulted?: boolean | null;
	position_auto_ready?: boolean | null;
	/** @format double */
	side_slip?: number | null;
	/** @format double */
	speed_limit?: number | null;
	/** @format double */
	target_speed?: number | null;
	/** @format double */
	big_object_detector_target_speed?: number | null;
	/** @format double */
	person_detector_target_speed?: number | null;
	/** @format double */
	implement_responsiveness_target_speed?: number | null;
	/** @format double */
	implement_angle_target_speed?: number | null;
	/** @format double */
	parallel_pid_target_speed?: number | null;
	/** @format double */
	driver_control_target_speed?: number | null;
	/** @format double */
	guidance_feedback_speed?: number | null;
	task_availability?: Record<string, TaskAvailability>;
	/** @format uuid */
	task_id?: string | null;
	task_status?: string | null;
	task_type?: string | null;
	application_type?: RosApplicationType;
	/** @format double */
	wheel_slip_percent?: number | null;
};

export interface MachineFeatureFlagReport {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	OrganizationId: string;
	/** @format date-time */
	ReportedAt: string;
	/** @format date-time */
	CreatedAt: string;
	FeatureFlags: ReportedMachineFeatureFlag[];
}

export interface MachineMake {
	Code: string;
	Description: string;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
	/** @format uuid */
	ChangedBy?: string | null;
	ChangedByEmail?: string | null;
	IsActive: boolean;
}

export interface MachineMakeDto {
	code: string;
	description: string;
}

export interface MachineMakeDtoPageResponse {
	Data: MachineMakeDto[];
	/** @format int32 */
	Page: number;
	/** @format int32 */
	PageSize: number;
	/** @format int32 */
	TotalCount: number;
	/** @format int32 */
	TotalPages: number;
	HasNextPage: boolean;
}

export interface MachineMakePageResponse {
	Data: MachineMake[];
	/** @format int32 */
	Page: number;
	/** @format int32 */
	PageSize: number;
	/** @format int32 */
	TotalCount: number;
	/** @format int32 */
	TotalPages: number;
	HasNextPage: boolean;
}

export interface MachineMetrics {
	/** GeoJSON Point */
	Location?: Point;
	/** @format int32 */
	SegmentId?: number | null;
	State: RosState;
	SubState: RosSubState;
	/** @format date-time */
	Timestamp: string;
	/** @format double */
	CoolantTemp?: number | null;
	/** @format double */
	EngineLoad?: number | null;
	/** @format double */
	EngineRpm?: number | null;
	/** @format double */
	FuelLevel?: number | null;
	ImplementPosition?: ImplementPosition;
	/** @format double */
	CrossTrackError?: number | null;
	/** @format double */
	SideSlip?: number | null;
	/** @format double */
	DefLevel?: number | null;
	PositionAutoReady?: boolean | null;
	EngineRunning?: boolean | null;
	MasterSwitchActive?: boolean | null;
	NoActiveCriticalAlarms?: boolean | null;
	NoActiveWarningAlarms?: boolean | null;
	ControlType?: RosControlType;
	/** @format double */
	WheelSlipPercent?: number | null;
}

export interface MachineMetricsPagedMetricsResponse {
	Data: MachineMetrics[];
	/** @format int32 */
	Page: number;
	/** @format int32 */
	PageSize: number;
	/** @format int32 */
	TotalCount?: number | null;
	/** @format int32 */
	TotalPages?: number | null;
	HasNextPage?: boolean | null;
}

export interface MachineModel {
	/** @format uuid */
	MachineId: string;
	MachineName?: string | null;
	NavigationReferencePoint: ReferencePoint3D;
	ConnectorReferencePointTractor: ReferencePoint2D;
}

export interface MachineNoteCreateDto {
	/** @format uuid */
	machineId: string;
	noteText: string;
}

export interface MachineNoteUpdateDto {
	/** @format uuid */
	id: string;
	noteText: string;
}

export interface MachineNotesDto {
	/** @format uuid */
	id: string;
	/** @format uuid */
	machineId: string;
	/** @format date-time */
	createdAt: string | null;
	/** @format date-time */
	updatedAt: string | null;
	noteText: string;
	/** @format uuid */
	createdBy: string;
	createdByEmail: string;
	createdByName?: string | null;
}

export interface MachinePlatform {
	Code: string;
	Description: string;
	MachineMake: string;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
	/** @format uuid */
	ChangedBy?: string | null;
	ChangedByEmail?: string | null;
	IsActive: boolean;
}

export interface MachinePlatformDto {
	code: string;
	description: string;
	machineMake: string;
}

export interface MachinePlatformDtoPageResponse {
	Data: MachinePlatformDto[];
	/** @format int32 */
	Page: number;
	/** @format int32 */
	PageSize: number;
	/** @format int32 */
	TotalCount: number;
	/** @format int32 */
	TotalPages: number;
	HasNextPage: boolean;
}

export interface MachinePlatformPageResponse {
	Data: MachinePlatform[];
	/** @format int32 */
	Page: number;
	/** @format int32 */
	PageSize: number;
	/** @format int32 */
	TotalCount: number;
	/** @format int32 */
	TotalPages: number;
	HasNextPage: boolean;
}

export interface MachineUploadQueueStatusModel {
	/** @format date-time */
	received_at_utc: string;
	/** @format int32 */
	total_items_in_queue: number;
	/** @format int32 */
	total_items_to_be_uploaded: number;
	/** @format int32 */
	uploading_items: number;
	/** @format int32 */
	completed_items: number;
	/** @format int32 */
	failed_items: number;
	/** @format int64 */
	total_size_bytes: number;
	/** @format double */
	overall_progress_percentage: number;
	paused: boolean;
	currently_uploading_files: string[];
	/** @format int64 */
	currently_uploading_files_size: number;
	/** @format int64 */
	currently_uploading_files_progress: number;
	current_queue_order: UploadFilePriorityModel[];
	failed_files: UploadFilePriorityModel[];
}

export interface MeanTimeInAutoResult {
	/** @format double */
	MeanTimeInAutoSeconds?: number | null;
	/** @format double */
	TotalAutoSeconds: number;
	/** @format int64 */
	ActivationCount: number;
}

export interface MetricsAverages {
	/** @format double */
	AverageGroundSpeed: number;
	/** @format double */
	AverageEngineSpeed: number;
	/** @format double */
	AverageFuelConsumption: number;
	/** @format double */
	AverageEngineLoad: number;
	/** @format double */
	AverageSlideSlip: number;
	/** @format double */
	AverageCrosstrackError: number;
}

export interface Mission {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	AccountId: string;
	/** @format uuid */
	Field?: string | null;
	MissionType?: MissionType;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
	State: DeployedSinglePathMissionCloudState;
	Name: string;
	/** @deprecated */
	Machines?: string[] | null;
	Parameters: MissionParameters;
	ApplicationParameters?: string | null;
}

export interface MissionCompatibilityConfiguration {
	Implement?: ImplementV2Model;
	/** @format uuid */
	MachineId?: string | null;
	/** @format uuid */
	ImplementId?: string | null;
	/** @format uuid */
	PlannedPathId?: string | null;
	/** @format uuid */
	JobImplementId?: string | null;
	/** @format double */
	TurningRadiusMeters?: number | null;
}

export interface MissionCompatibilityFailure {
	Issues: ConfigurationCompatibilityIssue[];
	Planned?: MissionCompatibilityConfiguration;
	Current?: MissionCompatibilityConfiguration;
	readonly Code: string;
}

export type MissionEventMessage = BaseMetricsUpdateMessage & {
	event_type: MissionEventType;
	/** @format uuid */
	event_id: string;
};

export interface MissionParameters {
	/** @format double */
	TargetSpeedKph?: number | null;
	/** @format double */
	TurningSpeedKph?: number | null;
	/** @format double */
	ApproachSpeedKph?: number | null;
	/** @format double */
	CoveredMetersSquared?: number | null;
	/** @format double */
	PercentageComplete?: number | null;
	UsesInnerField?: boolean | null;
	/** @format uuid */
	DeployerUserID?: string | null;
}

export interface MissionPersistenceMessage {
	mission_id?: string | null;
	/** @format int64 */
	waypoint_index: number;
	/** GeoJSON Point */
	resume_point?: Point;
	/** @format double */
	resume_bearing: number;
	/** @format double */
	mission_progress: number;
	Topic?: string | null;
}

export interface MissionResumePointRequest {
	/** @format double */
	mission_progress: number;
	/** @format double */
	resume_bearing: number;
	resume_bounds?: any;
	resume_point: RosMissionResumePoint;
	/** @format int32 */
	waypoint_index: number;
}

export interface MissionServicePointRequest {
	/** @format double */
	latitude: number;
	/** @format double */
	longitude: number;
	/** @format double */
	heading: number;
}

export interface MissionSummary {
	/** @format uuid */
	Id: string;
	Name: string;
	MissionType?: MissionType;
	Machines?: string[] | null;
	Boundaries?: BoundarySummary[] | null;
	BoundaryThumbnail?: string | null;
	/** @format uuid */
	Field?: string | null;
	/** @format double */
	FieldAreaM2?: number | null;
	ImplementName?: string | null;
	/** @format uuid */
	ImplementId?: string | null;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
}

export interface MissionUpdate {
	/** @format uuid */
	Id: string;
	State: DeployedSinglePathMissionCloudState;
	Name: string;
	/** @deprecated */
	Machines?: string[] | null;
	Boundaries?: string[] | null;
	PointsOfInterest?: string[] | null;
	/** @format uuid */
	Field?: string | null;
	/** @format uuid */
	Implement?: string | null;
	Parameters?: MissionParameters;
	ApplicationParameters?: string | null;
}

/** GeoJSON MultiLineString */
export interface MultiLineString {
	type?: "MultiLineString";
	coordinates?: LineString[];
}

/** GeoJSON MultiPoint */
export interface MultiPoint {
	type?: "MultiPoint";
	coordinates?: Position[];
}

/** GeoJSON MultiPolygon */
export interface MultiPolygon {
	type?: "MultiPolygon";
	coordinates?: Position[][][];
}

export interface NewBoundary {
	type: BoundaryType;
	/** GeoJSON Geometry */
	geometry: Geometry;
	/** @format double */
	SpeedLimit?: number | null;
	/** GeoJSON Geometry */
	innerField?: Geometry;
	IsRtkRecorded?: boolean | null;
	/** @maxLength 255 */
	name?: string | null;
}

export interface NewFeatureFlagEnumOption {
	Value: string;
	Label: string;
	/** @format int32 */
	SortOrder: number;
}

export interface NewField {
	/** @minLength 1 */
	name: string;
}

export interface NewFieldBoundary {
	/** @minLength 1 */
	FieldName: string;
	type: BoundaryType;
	/** GeoJSON Geometry */
	geometry: Geometry;
	/** @format double */
	SpeedLimit?: number | null;
	/** GeoJSON Geometry */
	innerField?: Geometry;
	IsRtkRecorded?: boolean | null;
}

export interface NewImplementMachineCalibration {
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	ImplementId: string;
	/** @format double */
	TurningRadiusMeters: number;
	/** @format uuid */
	CalibrationJobId?: string | null;
	/** @format date-time */
	LastCalibrationTime?: string | null;
}

export interface NewLineFeature {
	type: LineFeatureType;
	/** GeoJSON Geometry */
	geometry: Geometry;
}

export interface NewMission {
	Name: string;
	/** @deprecated */
	Machines?: string[] | null;
	Boundaries?: string[] | null;
	PointsOfInterest?: string[] | null;
	Paths?: string[] | null;
	/**
	 * @deprecated
	 * @format uuid
	 */
	Implement?: string | null;
	/** @format uuid */
	Field?: string | null;
	Parameters: MissionParameters;
	ApplicationParameters?: string | null;
	State?: DeployedSinglePathMissionCloudState;
	MissionType?: MissionType;
}

export interface NewPointOfInterest {
	type: PointOfInterestType;
	/** GeoJSON Point */
	location: Point;
	/** @format double */
	bearing?: number | null;
	parameters?: PointOfInterestParameters;
}

export interface NewRosSteeringCalibration {
	/** @format uuid */
	MachineId: string;
	/** @format double */
	MinTurningRadiusMeters: number;
	/** @format double */
	CurvatureLookaheadSeconds: number;
	/** @format double */
	SpeedLookaheadSeconds: number;
	/** @format double */
	CurvatureFeedForward: number;
	/** @format double */
	MaxYawRateRadPerSec: number;
}

export interface NewTask {
	TaskType: TaskType;
	TaskStatus: TaskStateType;
	/** @format uuid */
	SourceMachineId?: string | null;
	/** @format uuid */
	TargetMachineId: string;
	/** GeoJSON LineString */
	Path?: LineString;
	ClothoidPath?: ClothoidPath;
	/** @format uuid */
	PathId?: string | null;
	/** GeoJSON Point */
	TargetPoint?: Point;
	/** @format double */
	TargetBearing?: number | null;
	/** @format int32 */
	TargetWaypointIndex?: number | null;
	/** @format double */
	TargetSpeed?: number | null;
	/** @format double */
	ApproachSpeed?: number | null;
	/** @format double */
	TurningSpeed?: number | null;
}

export interface OrganizationDto {
	id: string;
	name: string;
	type: string;
	member: boolean;
	urlConnections: string;
}

export type PartialCoverageDrivenPathCombinedUpdateMessage =
	CoverageUpdateMessageBase & {
		/** GeoJSON MultiPolygon */
		NewCoverage: MultiPolygon;
		NewSegment: boolean;
		/** GeoJSON Point */
		TractorCenter: Point;
		/** @format double */
		TractorBearing: number;
		/** GeoJSON Point */
		ImplementCenter: Point;
		/** GeoJSON Point */
		ImplementLeft: Point;
		/** GeoJSON Point */
		ImplementRight: Point;
		SkipCloudDrivenPath?: boolean | null;
	};

export type PartialCoveragePolygonUpdateMessage = CoverageUpdateMessageBase & {
	/** GeoJSON MultiPolygon */
	NewCoverage: MultiPolygon;
};

export type PartialDrivenPathUpdateMessage = CoverageUpdateMessageBase & {
	NewSegment: boolean;
	/** GeoJSON Point */
	TractorCenter: Point;
	/** @format double */
	TractorBearing: number;
	/** GeoJSON Point */
	ImplementCenter: Point;
	/** GeoJSON Point */
	ImplementLeft: Point;
	/** GeoJSON Point */
	ImplementRight: Point;
	SkipCloudDrivenPath?: boolean | null;
};

export interface PathMetadata {
	Created?: string | null;
	Datum?: string | null;
	ID?: string | null;
}

export interface PathOrigin {
	/** @format double */
	Alt: number;
	/** @format double */
	Lat: number;
	/** @format double */
	Long: number;
}

export interface PathRecordingEvent {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	SessionId: string;
	EventType: PathRecordingEventType;
	/** GeoJSON Point */
	LocationCenter?: Point;
	/** GeoJSON Point */
	LocationLeft?: Point;
	/** GeoJSON Point */
	LocationRight?: Point;
	/** @format date-time */
	GpsTime: string;
	/** @format date-time */
	CreatedAt: string;
}

export interface PathRecordingPolygon {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	SessionId: string;
	/** @format uuid */
	AccountId: string;
	Type: PathRecordingPolygonType;
	/** GeoJSON Geometry */
	Geometry?: Geometry;
	/** @format date-time */
	CreatedAt: string;
}

export interface PathRecordingSession {
	/** GeoJSON LineString */
	ImplementCenterPath: LineString;
	/** GeoJSON LineString */
	ImplementLeftPath: LineString;
	/** GeoJSON LineString */
	ImplementRightPath: LineString;
	IsNewBoundary: boolean;
}

export interface PathSegment {
	/** GeoJSON LineString */
	Segment?: LineString;
	Label?: string | null;
	/** @format double */
	startFraction: number;
	/** @format double */
	endFraction: number;
}

export interface PersistentAlarmModel {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	OrganizationId: string;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	MissionId: string;
	/** GeoJSON Geometry */
	LastKnownLocation?: Geometry;
	/** @format date-time */
	TimeStamp: string;
	AlarmReference?: string | null;
	/** @format int64 */
	AlarmId: number;
	ActiveGuid?: string | null;
	/** @format int32 */
	Severity: number;
	Active: boolean;
	Acknowledged: boolean;
	Overridden: boolean;
	Description?: string | null;
}

export interface PersistentAlarmModelPagedAlarmsResponse {
	Data: PersistentAlarmModel[];
	/** @format int32 */
	Page: number;
	/** @format int32 */
	PageSize: number;
	/** @format int32 */
	TotalCount: number;
	/** @format int32 */
	TotalPages: number;
	HasNextPage: boolean;
}

export interface PersonDetectionRecoveryDecisionResult {
	Success: boolean;
	Message: string;
}

export interface PersonDetectionRecoveryImageReference {
	/** @format uuid */
	ImageId: string;
	Camera?: string | null;
	StillImage?: StillImage;
}

export interface PersonDetectionRecoveryModel {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	AccountId: string;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	EventId: string;
	/** @format uuid */
	MissionId?: string | null;
	/** @format date-time */
	RecoveryStartedAtUtc: string;
	/** @format uuid */
	FinalDecisionRequestId?: string | null;
	Decision?: PersonDetectionRecoveryDecision;
	/** @format date-time */
	DecidedAtUtc?: string | null;
	/** @format uuid */
	DecidedByUserId?: string | null;
	DecidedByUserEmail?: string | null;
	/** @format date-time */
	AcknowledgedAtUtc?: string | null;
	Outcome?: PersonDetectionRecoveryOutcome;
	/** @format date-time */
	OutcomeReportedAtUtc?: string | null;
	Images: PersonDetectionRecoveryImageReference[];
}

export interface PlannedPathParameters {
	/** @format uuid */
	PathId: string;
	PlanningParameters?: any;
}

/** GeoJSON Point */
export interface Point {
	type?: "Point";
	/** Point in 3D space */
	coordinates?: Position;
}

export interface PointOfInterest {
	/** @format uuid */
	id: string;
	type: PointOfInterestType;
	/** GeoJSON Point */
	location: Point;
	/** @format double */
	bearing?: number | null;
	/** @format date-time */
	created: string;
	/** @format date-time */
	updated: string;
	parameters?: PointOfInterestParameters;
}

export interface PointOfInterestParameters {
	/** @format double */
	entryPointLatitude?: number | null;
	/** @format double */
	entryPointLongitude?: number | null;
	/** @format double */
	entryPointBearing?: number | null;
	/** @format double */
	height?: number | null;
	/** @format double */
	width?: number | null;
}

export interface PointOfInterestUpdate {
	/** @format uuid */
	id: string;
	type: PointOfInterestType;
	/** GeoJSON Point */
	location: Point;
	/** @format double */
	bearing?: number | null;
	parameters?: PointOfInterestParameters;
}

/** GeoJSON Polygon */
export interface Polygon {
	type?: "Polygon";
	coordinates?: Position[][];
}

/**
 * Point in 3D space
 * @maxItems 3
 * @minItems 2
 */
export type Position = number[];

export interface ProblemDetails {
	type?: string | null;
	title?: string | null;
	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	[key: string]: any;
}

export interface ProcessedPathRecordingResponse {
	/** GeoJSON LineString */
	BoundaryLeft?: LineString;
	/** GeoJSON LineString */
	BoundaryCenter?: LineString;
	/** GeoJSON LineString */
	BoundaryRight?: LineString;
	Obstacles?: Polygon[] | null;
}

export interface PushNotificationConfig {
	/** @format int32 */
	missionCompletionPercentage?: number | null;
	missionCompleted?: boolean | null;
	/** @format int32 */
	fuelPercentage?: number | null;
	missionIds?: string[] | null;
	unknown?: boolean | null;
	humanImminent?: boolean | null;
	humanAvoidable?: boolean | null;
	autoExit?: boolean | null;
	nonHumanImminent?: boolean | null;
	nonHumanAvoidable?: boolean | null;
	minorFault?: boolean | null;
	majorFault?: boolean | null;
	implementAngle?: boolean | null;
	implementResponsiveness?: boolean | null;
}

export interface ReferencePoint2D {
	/** @format double */
	ReferencePointX: number;
	/** @format double */
	ReferencePointZ: number;
}

export interface ReferencePoint3D {
	/** @format double */
	ReferencePointX: number;
	/** @format double */
	ReferencePointY: number;
	/** @format double */
	ReferencePointZ: number;
}

export interface ReportMachineFeatureFlagsRequest {
	FeatureFlags: ReportedMachineFeatureFlag[];
	/** @format date-time */
	ReportedAt?: string | null;
}

export interface ReportedMachineFeatureFlag {
	/** @format uuid */
	FeatureFlagKeyId?: string | null;
	KeyName: string;
	DisplayName?: string | null;
	ValueType?: string | null;
	/** @format uuid */
	FeatureFlagValueId?: string | null;
	Value: string;
	EnumValue?: ResolvedFeatureFlagEnumValue;
	ResolvedFrom?: string | null;
}

export interface ResolvedFeatureFlagEnumValue {
	Value: string;
	Label: string;
}

export interface ResolvedFeatureFlagValue {
	/** @format uuid */
	FeatureFlagKeyId: string;
	KeyName: string;
	DisplayName: string;
	ValueType: string;
	AdminOnly: boolean;
	/** @format uuid */
	FeatureFlagValueId: string;
	Value: string;
	EnumValue?: ResolvedFeatureFlagEnumValue;
	ResolvedFrom: string;
}

export interface RosImplementSensorCalibrationRequestMessage {
	/** @format uuid */
	calibration_uuid: string;
	requested_step: ImplementSensorCalibrationStep;
}

export interface RosImplementTimingCalibrationRequestMessage {
	/** @format uuid */
	calibration_uuid: string;
	/** @format int32 */
	number_of_raise_lower_cycles: number;
	requested_step: ImplementTimingCalibrationStep;
	/** @format uuid */
	implement_uuid: string;
}

export interface RosLogFile {
	name: string;
	/** @format int64 */
	size_bytes: number;
	modified_at: string;
}

export interface RosLogUploadResponse {
	bucket: string;
	key: string;
	url: string;
}

export interface RosMachineCalibrationStateRequestMessage {
	/** @format uuid */
	request_uuid: string;
}

export interface RosMissionResumePoint {
	/** @format double */
	altitude: number;
	/** @format double */
	latitude: number;
	/** @format double */
	longitude: number;
}

export interface RosStateEvent {
	/** @format date-time */
	Timestamp: string;
	SubState: RosSubState;
	AutoExitReasons: RosAutoExitReasons[];
	/** GeoJSON Point */
	Location?: Point;
}

export type RosStateEventMessage = BaseMetricsUpdateMessage & {
	substate: RosSubState;
	auto_exit_reasons: RosAutoExitReasons[];
};

export interface RosSteeringCalibration {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	MachineId: string;
	/** @format double */
	MinTurningRadiusMeters: number;
	/** @format double */
	CurvatureLookaheadSeconds: number;
	/** @format double */
	SpeedLookaheadSeconds: number;
	/** @format double */
	CurvatureFeedForward: number;
	/** @format double */
	MaxYawRateRadPerSec: number;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
}

export interface RosbagUploadSessionCredentials {
	accessKeyId: string;
	secretAccessKey: string;
	sessionToken: string;
}

export interface RosbagUploadSessionRequest {
	/** @format uuid */
	accountId: string;
	fileName: string;
	/** @format int64 */
	fileSizeBytes: number;
	contentType?: string | null;
}

export interface RosbagUploadSessionResponse {
	bucket: string;
	key: string;
	region: string;
	/** @format date-time */
	expiresAt: string;
	credentials: RosbagUploadSessionCredentials;
	metadata: Record<string, string>;
}

export interface SectionDto {
	/** @format int32 */
	readonly ElementIndex: number;
	/** @format int32 */
	readonly ParentIndex: number;
	/** @format double */
	ElementWorkingWidth: number;
	/** @format double */
	ActualWorkingLength: number;
	DeviceElementReferencePoint: ReferencePoint3D;
	/** @format int32 */
	SectionControlTurnOnMilliseconds: number;
	/** @format int32 */
	SectionControlTurnOffMilliseconds: number;
}

export interface SetFeatureFlagValueRequest {
	Value: string;
}

export interface SetHarvestCertsRequest {
	/** @minLength 1 */
	Type: string;
	/** @minLength 1 */
	FileName: string;
	/** @minLength 1 */
	FileBase64: string;
}

export interface SetLocationRequest {
	/** @format double */
	Latitude: number;
	/** @format double */
	Longitude: number;
	/** @format double */
	Altitude?: number | null;
}

export interface SetPersonDetectionRecoveryDecisionRequest {
	Decision?: PersonDetectionRecoveryDecision;
}

export interface SetPersonDetectionRecoveryOutcomeRequest {
	Outcome?: PersonDetectionRecoveryOutcome;
	/** @format uuid */
	DecisionRequestId?: string | null;
	/** @format date-time */
	AcknowledgedAtUtc?: string | null;
}

export interface SetStageRequest {
	/** @minLength 1 */
	Stage: string;
}

export interface SetTillageCertRequest {
	/** @minLength 1 */
	FileName: string;
	/** @minLength 1 */
	FileBase64: string;
}

export interface SimplePoint {
	/** @format double */
	Lat: number;
	/** @format double */
	Long: number;
	/** @format double */
	Alt: number;
	Label?: string | null;
}

export interface SimulatorInstanceStatus {
	InstanceName: string;
	InstanceId: string;
	InstanceState: InstanceState;
	TillageStatus: SimulatorStatus;
	HarvestStatus: SimulatorStatus;
}

export interface SimulatorStatus {
	state: SimulatorState;
	current_operation?: string | null;
	location?: string | null;
	started_at?: string | null;
}

export interface SpeedChangeAck {
	request_id: string;
	task_id: string;
	/** @format double */
	current_set_target_speed?: number | null;
	/** @format double */
	current_set_turning_speed?: number | null;
	/** @format double */
	current_set_approach_speed?: number | null;
	Feedback: SpeedChangeFeedback;
}

export interface SpeedChangeRequest {
	TaskType: TaskType;
	TaskSpeeds: TaskSpeeds;
}

export interface SpeedChangeResponse {
	/** @format uuid */
	RequestId?: string | null;
	Status: SpeedChangeDispatchStatus;
	Feedback?: SpeedChangeFeedback;
}

export interface StillImage {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	JobId: string;
	/** @format uuid */
	SnapshotId: string;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	AccountId: string;
	CameraName: string;
	Location: SimplePoint;
	/** @format double */
	COG: number;
	AvailableDimensions: string[];
	ImageURLs: Record<string, string>;
	/** @format date-time */
	CreationTime: string;
	/** @format int32 */
	Type?: number | null;
	Description?: string | null;
	EventType?: string | null;
}

export interface StillImageSnapshotPage {
	Snapshots: Record<string, StillImage[]>;
	HasMore: boolean;
	/** @format int64 */
	TotalSnapshotCount?: number | null;
}

export interface SubscriptionDto {
	/** @format uuid */
	id: string;
	/** @format uuid */
	organizationId: string;
	/** @format uuid */
	machineId: string;
	machineName: string;
	machineType: MachineType;
	/** @format int32 */
	subscriptionMonths: number;
	/** @format date-time */
	lastPaymentDate: string;
	/** @format date-time */
	expiredDate?: string | null;
	subscriptionStatus?: string | null;
	isCancelled: boolean;
	/** @format date-time */
	createdAt?: string | null;
	/** @format date-time */
	updatedAt?: string | null;
	/** @format uuid */
	updatedByUserId?: string | null;
	updatedByUserEmail?: string | null;
	updatedByName?: string | null;
}

export interface SubscriptionValidityDto {
	/** @format uuid */
	subscriptionId?: string | null;
	isValid: boolean;
	/** @format date-time */
	expiredDate?: string | null;
	reason: string;
}

export interface SystemSoftwareUpdaterTelemetry {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	AccountId: string;
	/** @format uuid */
	MachineId: string;
	/** @format date-time */
	CreatedAt?: string | null;
	MachineName: string;
	SerialNumber: string;
	SystemVersion: string;
	/** @format double */
	DiskSpace: number;
	UpdateStatus?: TelemetryStatus;
	LogType: TelemetryLogType;
	Rfs: string;
	S3SystemStatsFile?: string | null;
	S3SoftwareUpdaterLogsFile?: string | null;
	S3ControllerParametersFile?: string | null;
	Ecus?: Ecu[] | null;
}

export interface TaskAvailability {
	available: boolean;
	unavailable_reasons: string[];
}

export type TaskEventMessage = BaseMetricsUpdateMessage & {
	/** @format uuid */
	task_id: string;
	task_type: string;
	status: RosTaskStatus;
};

export interface TaskInactive {
	/** @format uuid */
	TaskId: string;
	/** @format date-time */
	EndTime: string;
}

export interface TaskMetrics {
	/** @format uuid */
	TaskId: string;
	Status: RosTaskStatus;
	/** @format date-time */
	StartedAt: string;
	/** @format date-time */
	CompletedAt: string;
	TaskType: string;
}

export interface TaskPath {
	/** @format uuid */
	TaskId?: string | null;
	/** @format int32 */
	SegmentId?: number | null;
	/** GeoJSON LineString */
	Path: LineString;
}

export interface TaskResult {
	/** @format uuid */
	Id: string;
	TaskStatus: TaskStateType;
	/** @format int32 */
	Reason?: number | null;
}

export interface TaskResults {
	/** @format int32 */
	Completed: number;
	/** @format int32 */
	Failed: number;
	/** @format int32 */
	Cancelled: number;
}

export interface TaskSpeeds {
	/** @format double */
	TargetSpeed?: number | null;
	/** @format double */
	ApproachSpeed?: number | null;
	/** @format double */
	TurningSpeed?: number | null;
}

export interface TaskUpdate {
	/** @format uuid */
	Id: string;
	TaskStatus: TaskStateType;
	/** GeoJSON LineString */
	Path?: LineString;
	ClothoidPath?: ClothoidPath;
	/** @format uuid */
	PathId?: string | null;
	/** GeoJSON Point */
	TargetPoint?: Point;
	/** @format double */
	TargetBearing?: number | null;
	/** @format int32 */
	TargetWaypointIndex?: number | null;
	/** @format double */
	TargetSpeed?: number | null;
	/** @format double */
	ApproachSpeed?: number | null;
	/** @format double */
	TurningSpeed?: number | null;
	/** @format int32 */
	Reason?: number | null;
}

export interface TillageCertResponse {
	Name?: string | null;
}

export interface TimeSegment {
	/** @format date-time */
	StartTime: string;
	/** @format date-time */
	EndTime: string;
}

export interface UnloadTarget {
	/** @format uuid */
	harvester_id: string;
	/** @format uuid */
	cart_id: string;
	/** @format double */
	front_x: number;
	/** @format double */
	front_y: number;
	/** @format double */
	front_z: number;
	/** @format double */
	rear_x: number;
	/** @format double */
	rear_y: number;
	/** @format double */
	rear_z: number;
	/** @format double */
	x_offset?: number | null;
	/** @format double */
	y_offset?: number | null;
	/** @format double */
	target_x?: number | null;
	/** @format double */
	target_y?: number | null;
}

export interface UpdateEnumOptionRequest {
	Label?: string | null;
	/** @format int32 */
	SortOrder?: number | null;
}

export interface UpdateFeatureFlagKeyRequest {
	DisplayName?: string | null;
	Description?: string | null;
	AdminOnly?: boolean | null;
}

export interface UpdateFoxgloveDevice {
	name: string;
	properties: FoxgloveDeviceProperties;
	enabled: boolean;
}

export interface UpdateImplementMachineCalibration {
	/** @format double */
	TurningRadiusMeters: number;
	/** @format uuid */
	CalibrationJobId?: string | null;
	/** @format date-time */
	LastCalibrationTime?: string | null;
}

export interface UpdateRosSteeringCalibration {
	/** @format double */
	MinTurningRadiusMeters: number;
	/** @format double */
	CurvatureLookaheadSeconds: number;
	/** @format double */
	SpeedLookaheadSeconds: number;
	/** @format double */
	CurvatureFeedForward: number;
	/** @format double */
	MaxYawRateRadPerSec: number;
}

export interface UploadFilePriorityModel {
	/** @format int64 */
	file_id: number;
	file_name: string;
	/** @format int32 */
	priority: number;
	created_at?: string | null;
}

export interface UpsertHarvesterOffsets {
	/** @format double */
	CenterCombineToCenterGps: number;
	/** @format double */
	TopGpsToBottomCombine: number;
	/** @format double */
	FrontAxleToCenterGps: number;
	/** @format double */
	WheelBase: number;
	LeftOfCenter: boolean;
}

export interface UpsertWheelSlipValues {
	/** @format double */
	MaxSlipPercentage: number;
	/** @format int32 */
	SlipTimeoutSec: number;
}

export interface WellKnownDto {
	authorizationEndpoint: string;
	tokenEndpoint: string;
}

export interface WheelSlipValues {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	VersionId: string;
	/** @format double */
	MaxSlipPercentage: number;
	/** @format int32 */
	SlipTimeoutSec: number;
}

interface BaseMetricsUpdateMessage {
	type: string;
	/** @format date-time */
	timestamp: string;
	/** @format uuid */
	mission_id?: string | null;
	/** @format uuid */
	missionId?: string | null;
}

type BaseMetricsUpdateMessageTypeMapping<Key, Type> = {
	type: Key;
} & Type;

interface BaseJohnDeereGuidanceLineObjectDto {
	"@type": string;
	/** @format uuid */
	id: string;
	name?: string | null;
	/** @format date-time */
	lastModifiedTime?: string | null;
	archived: boolean;
	links?: JohnDeereLinkDto[] | null;
}

type BaseJohnDeereGuidanceLineObjectDtoTypeMapping<Key, Type> = {
	"@type": Key;
} & Type;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseFormat;
	/** request body */
	body?: unknown;
	/** base url */
	baseUrl?: string;
	/** request cancellation token */
	cancelToken?: CancelToken;
}

export type RequestParams = Omit<
	FullRequestParams,
	"body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
	baseUrl?: string;
	baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
	securityWorker?: (
		securityData: SecurityDataType | null,
	) => Promise<RequestParams | void> | RequestParams | void;
	customFetch?: typeof fetch;
}

export interface HttpResponse<
	D extends unknown,
	E extends unknown = unknown,
> extends Response {
	data: D;
	error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
	Json = "application/json",
	JsonApi = "application/vnd.api+json",
	FormData = "multipart/form-data",
	UrlEncoded = "application/x-www-form-urlencoded",
	Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
	public baseUrl: string = "";
	private securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
	private abortControllers = new Map<CancelToken, AbortController>();
	private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
		fetch(...fetchParams);

	private baseApiParams: RequestParams = {
		credentials: "same-origin",
		headers: {},
		redirect: "follow",
		referrerPolicy: "no-referrer",
	};

	constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
		Object.assign(this, apiConfig);
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	protected encodeQueryParam(key: string, value: any) {
		const encodedKey = encodeURIComponent(key);
		return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
	}

	protected addQueryParam(query: QueryParamsType, key: string) {
		return this.encodeQueryParam(key, query[key]);
	}

	protected addArrayQueryParam(query: QueryParamsType, key: string) {
		const value = query[key];
		return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
	}

	protected toQueryString(rawQuery?: QueryParamsType): string {
		const query = rawQuery || {};
		const keys = Object.keys(query).filter(
			key => "undefined" !== typeof query[key],
		);
		return keys
			.map(key =>
				Array.isArray(query[key])
					? this.addArrayQueryParam(query, key)
					: this.addQueryParam(query, key),
			)
			.join("&");
	}

	protected addQueryParams(rawQuery?: QueryParamsType): string {
		const queryString = this.toQueryString(rawQuery);
		return queryString ? `?${queryString}` : "";
	}

	private contentFormatters: Record<ContentType, (input: any) => any> = {
		[ContentType.Json]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.JsonApi]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.Text]: (input: any) =>
			input !== null && typeof input !== "string"
				? JSON.stringify(input)
				: input,
		[ContentType.FormData]: (input: any) => {
			if (input instanceof FormData) {
				return input;
			}

			return Object.keys(input || {}).reduce((formData, key) => {
				const property = input[key];
				formData.append(
					key,
					property instanceof Blob
						? property
						: typeof property === "object" && property !== null
							? JSON.stringify(property)
							: `${property}`,
				);
				return formData;
			}, new FormData());
		},
		[ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
	};

	protected mergeRequestParams(
		params1: RequestParams,
		params2?: RequestParams,
	): RequestParams {
		return {
			...this.baseApiParams,
			...params1,
			...(params2 || {}),
			headers: {
				...(this.baseApiParams.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	protected createAbortSignal = (
		cancelToken: CancelToken,
	): AbortSignal | undefined => {
		if (this.abortControllers.has(cancelToken)) {
			const abortController = this.abortControllers.get(cancelToken);
			if (abortController) {
				return abortController.signal;
			}
			return void 0;
		}

		const abortController = new AbortController();
		this.abortControllers.set(cancelToken, abortController);
		return abortController.signal;
	};

	public abortRequest = (cancelToken: CancelToken) => {
		const abortController = this.abortControllers.get(cancelToken);

		if (abortController) {
			abortController.abort();
			this.abortControllers.delete(cancelToken);
		}
	};

	public request = async <T = any, E = any>({
		body,
		secure,
		path,
		type,
		query,
		format,
		baseUrl,
		cancelToken,
		...params
	}: FullRequestParams): Promise<HttpResponse<T, E>> => {
		const secureParams =
			((typeof secure === "boolean"
				? secure
				: this.baseApiParams.secure) &&
				this.securityWorker &&
				(await this.securityWorker(this.securityData))) ||
			{};
		const requestParams = this.mergeRequestParams(params, secureParams);
		const queryString = query && this.toQueryString(query);
		const payloadFormatter =
			this.contentFormatters[type || ContentType.Json];
		const responseFormat = format || requestParams.format;

		return this.customFetch(
			`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
			{
				...requestParams,
				headers: {
					...(requestParams.headers || {}),
					...(type && type !== ContentType.FormData
						? { "Content-Type": type }
						: {}),
				},
				signal:
					(cancelToken
						? this.createAbortSignal(cancelToken)
						: requestParams.signal) || null,
				body:
					typeof body === "undefined" || body === null
						? null
						: payloadFormatter(body),
			},
		).then(async response => {
			const r = response as HttpResponse<T, E>;
			r.data = null as unknown as T;
			r.error = null as unknown as E;

			const responseToParse = responseFormat
				? response.clone()
				: response;
			const data = !responseFormat
				? r
				: await responseToParse[responseFormat]()
						.then(data => {
							if (r.ok) {
								r.data = data;
							} else {
								r.error = data;
							}
							return r;
						})
						.catch(e => {
							r.error = e as E;
							return r;
						});

			if (cancelToken) {
				this.abortControllers.delete(cancelToken);
			}

			if (!response.ok) {
				const error = Object.assign(
					new Error(
						`HTTP ${data.status}: ${data.statusText || "Error"}`,
					),
					{
						status: data.status,
						statusText: data.statusText,
						data: data.data,
						error: data.error,
						response: data,
						json: data.json.bind(data),
						text: data.text.bind(data),
					},
				);

				throw error;
			}
			return data;
		});
	};
}

/**
 * @title FlightpathServiceLambda
 * @version 1.0
 */
export class Api<
	SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
	alarms = {
		/**
		 * No description
		 *
		 * @tags Alarms
		 * @name AlarmList
		 * @request GET:/alarms/alarm
		 */
		alarmList: (
			query?: {
				alarmId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<PersistentAlarmModel, ProblemDetails>({
				path: `/alarms/alarm`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Alarms
		 * @name AlarmbymachineList
		 * @request GET:/alarms/alarmbymachine
		 */
		alarmbymachineList: (
			query?: {
				machineId?: string;
				/** @format date-time */
				startDate?: string;
				/** @format date-time */
				endDate?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<PersistentAlarmModel[], ProblemDetails>({
				path: `/alarms/alarmbymachine`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Alarms
		 * @name AlarmbymachinePaginatedList
		 * @request GET:/alarms/alarmbymachine-paginated
		 */
		alarmbymachinePaginatedList: (
			query?: {
				machineId?: string;
				/** @format date-time */
				startDate?: string;
				/** @format date-time */
				endDate?: string;
				/**
				 * @format int32
				 * @default 1
				 */
				page?: number;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<
				PersistentAlarmModelPagedAlarmsResponse,
				ProblemDetails
			>({
				path: `/alarms/alarmbymachine-paginated`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Alarms
		 * @name AlarmbyorganizationList
		 * @request GET:/alarms/alarmbyorganization
		 */
		alarmbyorganizationList: (
			query?: {
				organizationId?: string;
				/** @format date-time */
				startDate?: string;
				/** @format date-time */
				endDate?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<PersistentAlarmModel[], ProblemDetails>({
				path: `/alarms/alarmbyorganization`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Alarms
		 * @name AlarmbymissionList
		 * @request GET:/alarms/alarmbymission
		 */
		alarmbymissionList: (
			query?: {
				organizationId?: string;
				missionId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<PersistentAlarmModel[], ProblemDetails>({
				path: `/alarms/alarmbymission`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	missions = {
		/**
		 * No description
		 *
		 * @tags AppNotificationBanner
		 * @name GetMissionNotifications
		 * @request GET:/missions/{missionId}/notifications
		 */
		getMissionNotifications: (
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<AppNotificationBanner[], ProblemDetails | void>({
				path: `/missions/${missionId}/notifications`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsList
		 * @request GET:/missions
		 */
		missionsList: (
			query?: {
				/** @format uuid */
				machineId?: string;
				status?: "Active" | "Inactive";
			},
			params: RequestParams = {},
		) =>
			this.request<Mission[], any>({
				path: `/missions`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsCreate
		 * @request POST:/missions
		 * @deprecated
		 */
		missionsCreate: (data: NewMission, params: RequestParams = {}) =>
			this.request<string, ProblemDetails | void>({
				path: `/missions`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsUpdate
		 * @request PUT:/missions
		 */
		missionsUpdate: (data: MissionUpdate, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/missions`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name SummariesList
		 * @request GET:/missions/summaries
		 */
		summariesList: (
			query?: {
				/** @format uuid */
				machineId?: string;
				status?: "Active" | "Inactive";
			},
			params: RequestParams = {},
		) =>
			this.request<MissionSummary[], any>({
				path: `/missions/summaries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name IdsActiveList
		 * @request GET:/missions/ids/active
		 */
		idsActiveList: (params: RequestParams = {}) =>
			this.request<string[], any>({
				path: `/missions/ids/active`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name PersistenceDetail
		 * @request GET:/missions/persistence/{machineId}
		 */
		persistenceDetail: (machineId: string, params: RequestParams = {}) =>
			this.request<MissionPersistenceMessage, void>({
				path: `/missions/persistence/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name SummariesFieldList
		 * @request GET:/missions/summaries/field
		 */
		summariesFieldList: (params: RequestParams = {}) =>
			this.request<Record<string, MissionSummary[]>, void>({
				path: `/missions/summaries/field`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name SummariesSinceList
		 * @request GET:/missions/summaries/since
		 */
		summariesSinceList: (
			query?: {
				/** @format date-time */
				since?: string;
				/** @format uuid */
				fieldId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MissionSummary[], void>({
				path: `/missions/summaries/since`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsDetail
		 * @request GET:/missions/{missionId}
		 */
		missionsDetail: (missionId: string, params: RequestParams = {}) =>
			this.request<Mission, any>({
				path: `/missions/${missionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name FullList
		 * @request GET:/missions/{missionId}/full
		 */
		fullList: (missionId: string, params: RequestParams = {}) =>
			this.request<Mission, ProblemDetails | void>({
				path: `/missions/${missionId}/full`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name FromJobCreate
		 * @request POST:/missions/from-job/{jobId}
		 */
		fromJobCreate: (
			jobId: string,
			data: NewMission,
			params: RequestParams = {},
		) =>
			this.request<
				string,
				ProblemDetails | MissionCompatibilityFailure | void
			>({
				path: `/missions/from-job/${jobId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name JoinCreate
		 * @request POST:/missions/join
		 */
		joinCreate: (
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				boundaryId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				string,
				ProblemDetails | MissionCompatibilityFailure | void
			>({
				path: `/missions/join`,
				method: "POST",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name LeaveCreate
		 * @request POST:/missions/leave
		 */
		leaveCreate: (
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format uuid */
				machineId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<LeaveMissionResponse, ProblemDetails | void>({
				path: `/missions/leave`,
				method: "POST",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name BoundariesList
		 * @request GET:/missions/{missionId}/boundaries
		 */
		boundariesList: (
			missionId: string,
			query?: {
				/** @default false */
				simplified?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<Boundary[], ProblemDetails | void>({
				path: `/missions/${missionId}/boundaries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name PointsofinterestList
		 * @request GET:/missions/{missionId}/pointsofinterest
		 */
		pointsofinterestList: (missionId: string, params: RequestParams = {}) =>
			this.request<PointOfInterest[], ProblemDetails | void>({
				path: `/missions/${missionId}/pointsofinterest`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name ImplementList
		 * @request GET:/missions/{missionId}/implement
		 */
		implementList: (missionId: string, params: RequestParams = {}) =>
			this.request<ImplementV2Model, ProblemDetails | void>({
				path: `/missions/${missionId}/implement`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name ImplementAssignmentsList
		 * @request GET:/missions/{missionId}/implement-assignments
		 */
		implementAssignmentsList: (
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<ImplementAssignmentDetails[], ProblemDetails | void>({
				path: `/missions/${missionId}/implement-assignments`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name BoundariesCreate
		 * @request POST:/missions/{missionId}/boundaries/{boundaryId}
		 */
		boundariesCreate: (
			missionId: string,
			boundaryId: string,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/missions/${missionId}/boundaries/${boundaryId}`,
				method: "POST",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name BoundariesDelete
		 * @request DELETE:/missions/{missionId}/boundaries/{boundaryId}
		 */
		boundariesDelete: (
			missionId: string,
			boundaryId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/missions/${missionId}/boundaries/${boundaryId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name PathsList
		 * @request GET:/missions/{missionId}/paths
		 */
		pathsList: (missionId: string, params: RequestParams = {}) =>
			this.request<SimplePoint[], ProblemDetails | void>({
				path: `/missions/${missionId}/paths`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name PlanningParametersList
		 * @request GET:/missions/{missionId}/planning-parameters
		 */
		planningParametersList: (
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<PlannedPathParameters[], any>({
				path: `/missions/${missionId}/planning-parameters`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name ClothoidList
		 * @request GET:/missions/{missionId}/clothoid
		 */
		clothoidList: (missionId: string, params: RequestParams = {}) =>
			this.request<string, ProblemDetails | void>({
				path: `/missions/${missionId}/clothoid`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name PathsegmentsList
		 * @request GET:/missions/{missionId}/pathsegments
		 */
		pathsegmentsList: (missionId: string, params: RequestParams = {}) =>
			this.request<PathSegment[], ProblemDetails | void>({
				path: `/missions/${missionId}/pathsegments`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MachinesCreate
		 * @request POST:/missions/{missionId}/machines/{machineId}/{command}
		 */
		machinesCreate: (
			missionId: string,
			machineId: string,
			command: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/missions/${missionId}/machines/${machineId}/${command}`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MachinesResumePointCreate
		 * @request POST:/missions/{missionId}/machines/{machineId}/resume-point
		 */
		machinesResumePointCreate: (
			missionId: string,
			machineId: string,
			data: MissionResumePointRequest,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/missions/${missionId}/machines/${machineId}/resume-point`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MachinesServicePointCreate
		 * @request POST:/missions/{missionId}/machines/{machineId}/service-point
		 */
		machinesServicePointCreate: (
			missionId: string,
			machineId: string,
			data: MissionServicePointRequest,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/missions/${missionId}/machines/${machineId}/service-point`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MachinesGoToServicePointCreate
		 * @request POST:/missions/{missionId}/machines/{machineId}/go-to-service-point
		 */
		machinesGoToServicePointCreate: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/missions/${missionId}/machines/${machineId}/go-to-service-point`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name StopUpdate
		 * @request PUT:/missions/{missionId}/stop
		 * @deprecated
		 */
		stopUpdate: (
			missionId: string,
			data: any,
			query?: {
				/** @format uuid */
				machineId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/missions/${missionId}/stop`,
				method: "PUT",
				query: query,
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name PointsofinterestCreate
		 * @request POST:/missions/{missionId}/pointsofinterest/{pointOfInterestId}
		 */
		pointsofinterestCreate: (
			missionId: string,
			pointOfInterestId: string,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/missions/${missionId}/pointsofinterest/${pointOfInterestId}`,
				method: "POST",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name PointsofinterestDelete
		 * @request DELETE:/missions/{missionId}/pointsofinterest/{pointOfInterestId}
		 */
		pointsofinterestDelete: (
			missionId: string,
			pointOfInterestId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/missions/${missionId}/pointsofinterest/${pointOfInterestId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags StillImage
		 * @name StillImageSnapshotsList
		 * @request GET:/missions/{missionId}/still-image-snapshots
		 */
		stillImageSnapshotsList: (
			missionId: string,
			query?: {
				/** @format date-time */
				since?: string;
				/**
				 * @format int32
				 * @default 500
				 */
				pageSize?: number;
				/** @default false */
				includeTotalCount?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<StillImageSnapshotPage, ProblemDetails | void>({
				path: `/missions/${missionId}/still-image-snapshots`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	cloudMachineApi = {
		/**
		 * No description
		 *
		 * @tags AutonomyTask
		 * @name AutonomyCreate
		 * @request POST:/cloud-machine-api/{machineId}/autonomy
		 */
		autonomyCreate: (
			machineId: string,
			data: AutonomyTaskPath,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/autonomy`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags AutonomyTask
		 * @name TaskInactiveCreate
		 * @request POST:/cloud-machine-api/{machineId}/task-inactive
		 */
		taskInactiveCreate: (
			machineId: string,
			data: TaskInactive,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/task-inactive`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags AutonomyTask
		 * @name PathAttemptedCreate
		 * @request POST:/cloud-machine-api/{machineId}/path-attempted/{taskId}
		 */
		pathAttemptedCreate: (
			taskId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/path-attempted/${taskId}`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags CostMap
		 * @name ObstaclePolygonDetail
		 * @request GET:/cloud-machine-api/{machineId}/obstacle-polygon/{missionId}
		 */
		obstaclePolygonDetail: (
			machineId: string,
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<MultiPolygon, any>({
				path: `/cloud-machine-api/${machineId}/obstacle-polygon/${missionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags CostMap
		 * @name FieldBoundaryPolygonDetail
		 * @request GET:/cloud-machine-api/{machineId}/field-boundary-polygon/{missionId}
		 */
		fieldBoundaryPolygonDetail: (
			machineId: string,
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<MultiPolygon, any>({
				path: `/cloud-machine-api/${machineId}/field-boundary-polygon/${missionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags CostMap
		 * @name CoveragePolygonDetail
		 * @request GET:/cloud-machine-api/{machineId}/coverage-polygon/{missionId}
		 */
		coveragePolygonDetail: (
			machineId: string,
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<MultiPolygon, any>({
				path: `/cloud-machine-api/${machineId}/coverage-polygon/${missionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name InvertedCoveragePolygonDetail
		 * @request GET:/cloud-machine-api/{machineId}/inverted-coverage-polygon/{jobId}
		 */
		invertedCoveragePolygonDetail: (
			machineId: string,
			jobId: string,
			params: RequestParams = {},
		) =>
			this.request<MultiPolygon, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/inverted-coverage-polygon/${jobId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name DrivenPathDetail
		 * @request GET:/cloud-machine-api/{machineId}/driven-path/{jobId}
		 */
		drivenPathDetail: (
			jobId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<MultiLineString, void>({
				path: `/cloud-machine-api/${machineId}/driven-path/${jobId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name DrivenPathCompressedDetail
		 * @request GET:/cloud-machine-api/{machineId}/driven-path/compressed/{jobId}
		 */
		drivenPathCompressedDetail: (
			jobId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/cloud-machine-api/${machineId}/driven-path/compressed/${jobId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CoverageCreate
		 * @request POST:/cloud-machine-api/{machineId}/coverage
		 */
		coverageCreate: (
			machineId: string,
			data: FullDrivenPathCoverageCombinedUpdateMessage,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/coverage`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CoverageOnlyCreate
		 * @request POST:/cloud-machine-api/{machineId}/coverage-only
		 */
		coverageOnlyCreate: (
			machineId: string,
			data: FullCoverageUpdateMessage,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/coverage-only`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name DrivenPathCreate
		 * @request POST:/cloud-machine-api/{machineId}/driven-path
		 */
		drivenPathCreate: (
			machineId: string,
			data: FullDrivenPathUpdateMessage,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/driven-path`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name FeatureFlagsList
		 * @request GET:/cloud-machine-api/{machineId}/feature-flags
		 */
		featureFlagsList: (machineId: string, params: RequestParams = {}) =>
			this.request<ResolvedFeatureFlagValue[], any>({
				path: `/cloud-machine-api/${machineId}/feature-flags`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name FeatureFlagsCreate
		 * @request POST:/cloud-machine-api/{machineId}/feature-flags
		 */
		featureFlagsCreate: (
			machineId: string,
			data: ReportMachineFeatureFlagsRequest,
			params: RequestParams = {},
		) =>
			this.request<MachineFeatureFlagReport, ProblemDetails>({
				path: `/cloud-machine-api/${machineId}/feature-flags`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags HarvesterOffsets
		 * @name HarvesterOffsetsList
		 * @request GET:/cloud-machine-api/{machineId}/harvester-offsets
		 */
		harvesterOffsetsList: (machineId: string, params: RequestParams = {}) =>
			this.request<HarvesterOffsets, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/harvester-offsets`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ImplementV2List
		 * @request GET:/cloud-machine-api/{machineId}/ImplementV2
		 */
		implementV2List: (
			machineId: string,
			query?: {
				implementType?: ImplementType;
			},
			params: RequestParams = {},
		) =>
			this.request<ImplementV2Model[], void>({
				path: `/cloud-machine-api/${machineId}/ImplementV2`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ImplementV2Detail
		 * @request GET:/cloud-machine-api/{machineId}/ImplementV2/{implementId}
		 */
		implementV2Detail: (
			implementId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<ImplementV2Model, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/ImplementV2/${implementId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ImplementsAssignmentList
		 * @request GET:/cloud-machine-api/{machineId}/implements/assignment
		 */
		implementsAssignmentList: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<ImplementV2Model, void>({
				path: `/cloud-machine-api/${machineId}/implements/assignment`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name Implementv2RefreshCalibrationCreate
		 * @request POST:/cloud-machine-api/{machineId}/implementv2/{implementId}/refresh-calibration/{requestId}
		 */
		implementv2RefreshCalibrationCreate: (
			machineId: string,
			implementId: string,
			requestId: string,
			data: ConfirmRefreshLookAheadsRequest,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/implementv2/${implementId}/refresh-calibration/${requestId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name Implementv2ActiveCalibrationsCreate
		 * @request POST:/cloud-machine-api/{machineId}/implementv2/{implementId}/active-calibrations
		 */
		implementv2ActiveCalibrationsCreate: (
			machineId: string,
			implementId: string,
			data: ActiveImplementCalibrationMessage,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/implementv2/${implementId}/active-calibrations`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name Implementv2ActiveLookaheadsCreate
		 * @request POST:/cloud-machine-api/{machineId}/implementv2/{implementId}/active-lookaheads
		 */
		implementv2ActiveLookaheadsCreate: (
			machineId: string,
			implementId: string,
			data: ImplementActiveLookaheadMessage,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/implementv2/${implementId}/active-lookaheads`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name Implementv2CalibrationCreate
		 * @request POST:/cloud-machine-api/{machineId}/implementv2/{implementId}/calibration
		 */
		implementv2CalibrationCreate: (
			machineId: string,
			implementId: string,
			data: ImplementCalibrationRequest,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/implementv2/${implementId}/calibration`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name Implementv2CalibrationCreate2
		 * @request POST:/cloud-machine-api/{machineId}/implementv2/{implementId}/calibration/{requestId}
		 * @originalName implementv2CalibrationCreate
		 * @duplicate
		 */
		implementv2CalibrationCreate2: (
			machineId: string,
			implementId: string,
			requestId: string,
			data: boolean,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/implementv2/${implementId}/calibration/${requestId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name Implementv2LookAheadUpdateConfirmCreate
		 * @request POST:/cloud-machine-api/{machineId}/implementv2/{implementId}/look-ahead-update-confirm/{requestId}
		 */
		implementv2LookAheadUpdateConfirmCreate: (
			machineId: string,
			implementId: string,
			requestId: string,
			data: ConfirmRefreshLookAheadsRequest,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/implementv2/${implementId}/look-ahead-update-confirm/${requestId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name Implementv2FlightpathMeasuredLookaheadsCreate
		 * @request POST:/cloud-machine-api/{machineId}/implementv2/{implementId}/flightpath-measured-lookaheads
		 */
		implementv2FlightpathMeasuredLookaheadsCreate: (
			machineId: string,
			implementId: string,
			data: ImplementCalibrationRequest,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/implementv2/${implementId}/flightpath-measured-lookaheads`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsList
		 * @request GET:/cloud-machine-api/{machineId}/missions
		 */
		missionsList: (
			machineId: string,
			query?: {
				/** @format uuid */
				machineId?: string;
				status?: "Active" | "Inactive";
			},
			params: RequestParams = {},
		) =>
			this.request<Mission[], any>({
				path: `/cloud-machine-api/${machineId}/missions`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsPersistenceList
		 * @request GET:/cloud-machine-api/{machineId}/missions/persistence
		 */
		missionsPersistenceList: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<MissionPersistenceMessage, void>({
				path: `/cloud-machine-api/${machineId}/missions/persistence`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsDetail
		 * @request GET:/cloud-machine-api/{machineId}/missions/{missionId}
		 */
		missionsDetail: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<Mission, any>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsCreate
		 * @request POST:/cloud-machine-api/{machineId}/missions/{missionId}
		 */
		missionsCreate: (
			missionId: string,
			machineId: string,
			data: NewMission,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsFullList
		 * @request GET:/cloud-machine-api/{machineId}/missions/{missionId}/full
		 */
		missionsFullList: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<Mission, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/full`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name AssignedMissionList
		 * @request GET:/cloud-machine-api/{machineId}/assigned-mission
		 */
		assignedMissionList: (machineId: string, params: RequestParams = {}) =>
			this.request<AssignedMissionResponse, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/assigned-mission`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionCompleteCreate
		 * @request POST:/cloud-machine-api/{machineId}/mission-complete/{missionId}
		 */
		missionCompleteCreate: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/mission-complete/${missionId}`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionResumeCreate
		 * @request POST:/cloud-machine-api/{machineId}/mission-resume/{missionId}
		 */
		missionResumeCreate: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/mission-resume/${missionId}`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsBoundariesList
		 * @request GET:/cloud-machine-api/{machineId}/missions/{missionId}/boundaries
		 */
		missionsBoundariesList: (
			missionId: string,
			machineId: string,
			query?: {
				/** @default false */
				simplified?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<Boundary[], ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/boundaries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsPointsofinterestList
		 * @request GET:/cloud-machine-api/{machineId}/missions/{missionId}/pointsofinterest
		 */
		missionsPointsofinterestList: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<PointOfInterest[], ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/pointsofinterest`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsImplementList
		 * @request GET:/cloud-machine-api/{machineId}/missions/{missionId}/implement
		 */
		missionsImplementList: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<ImplementV2Model, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/implement`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsPathsList
		 * @request GET:/cloud-machine-api/{machineId}/missions/{missionId}/paths
		 */
		missionsPathsList: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<SimplePoint[], ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/paths`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsClothoidList
		 * @request GET:/cloud-machine-api/{machineId}/missions/{missionId}/clothoid
		 */
		missionsClothoidList: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/clothoid`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsPathsegmentsList
		 * @request GET:/cloud-machine-api/{machineId}/missions/{missionId}/pathsegments
		 */
		missionsPathsegmentsList: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<PathSegment[], ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/pathsegments`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsAcceptCreate
		 * @request POST:/cloud-machine-api/{machineId}/missions/{missionId}/accept
		 */
		missionsAcceptCreate: (
			machineId: string,
			missionId: string,
			query?: {
				softwareClient?: SoftwareClient;
			},
			params: RequestParams = {},
		) =>
			this.request<AcceptMissionResponse, any>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/accept`,
				method: "POST",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsRejectCreate
		 * @request POST:/cloud-machine-api/{machineId}/missions/{missionId}/reject
		 */
		missionsRejectCreate: (
			machineId: string,
			missionId: string,
			data: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/reject`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsJoinedCreate
		 * @request POST:/cloud-machine-api/{machineId}/missions/{missionId}/joined/{requestId}
		 */
		missionsJoinedCreate: (
			machineId: string,
			missionId: string,
			requestId: string,
			data: boolean,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/joined/${requestId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsLeftCreate
		 * @request POST:/cloud-machine-api/{machineId}/missions/{missionId}/left/{requestId}
		 */
		missionsLeftCreate: (
			machineId: string,
			missionId: string,
			requestId: string,
			data: boolean,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/missions/${missionId}/left/${requestId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PersonDetectionRecovery
		 * @name SetPersonDetectionRecoveryOutcome
		 * @request POST:/cloud-machine-api/{machineId}/person-detection-recovery/{recoveryId}/outcome
		 */
		setPersonDetectionRecoveryOutcome: (
			machineId: string,
			recoveryId: string,
			data: SetPersonDetectionRecoveryOutcomeRequest,
			params: RequestParams = {},
		) =>
			this.request<boolean, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/person-detection-recovery/${recoveryId}/outcome`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosCalibration
		 * @name RosCalibrationSteeringList
		 * @request GET:/cloud-machine-api/{machineId}/ros/calibration/steering
		 */
		rosCalibrationSteeringList: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<RosSteeringCalibration, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/ros/calibration/steering`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosCalibration
		 * @name RosCalibrationSteeringCreate
		 * @request POST:/cloud-machine-api/{machineId}/ros/calibration/steering
		 */
		rosCalibrationSteeringCreate: (
			machineId: string,
			data: NewRosSteeringCalibration,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/ros/calibration/steering`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosCalibration
		 * @name RosCalibrationSteeringUpdate
		 * @request PUT:/cloud-machine-api/{machineId}/ros/calibration/steering
		 */
		rosCalibrationSteeringUpdate: (
			machineId: string,
			data: UpdateRosSteeringCalibration,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/ros/calibration/steering`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosCalibration
		 * @name RosCalibrationSteeringDelete
		 * @request DELETE:/cloud-machine-api/{machineId}/ros/calibration/steering
		 */
		rosCalibrationSteeringDelete: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/ros/calibration/steering`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetMachineTask
		 * @request GET:/cloud-machine-api/{machineId}/task
		 */
		getMachineTask: (
			machineId: string,
			query?: {
				/** @format uuid */
				taskId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AutonomousTask, void>({
				path: `/cloud-machine-api/${machineId}/task`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetMachineActiveTaskDeprecated
		 * @request GET:/cloud-machine-api/{machineId}/tasks
		 */
		getMachineActiveTaskDeprecated: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<AutonomousTask, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/tasks`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name SetTask
		 * @request POST:/cloud-machine-api/{machineId}/tasks
		 */
		setTask: (
			machineId: string,
			data: NewTask,
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/cloud-machine-api/${machineId}/tasks`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetMachineActiveTask
		 * @request GET:/cloud-machine-api/{machineId}/active-task
		 */
		getMachineActiveTask: (machineId: string, params: RequestParams = {}) =>
			this.request<AutonomousTask, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/active-task`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetMachineTasksBySourceMachine
		 * @request GET:/cloud-machine-api/{machineId}/tasks-by-source
		 */
		getMachineTasksBySourceMachine: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<AutonomousTask[], void>({
				path: `/cloud-machine-api/${machineId}/tasks-by-source`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetMachineActiveTaskBySourceMachine
		 * @request GET:/cloud-machine-api/{machineId}/tasks-by-source/active
		 */
		getMachineActiveTaskBySourceMachine: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<AutonomousTask, void>({
				path: `/cloud-machine-api/${machineId}/tasks-by-source/active`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name AckTaskSpeed
		 * @request POST:/cloud-machine-api/{machineId}/tasks/{taskId}/speed-ack
		 */
		ackTaskSpeed: (
			machineId: string,
			taskId: string,
			data: SpeedChangeAck,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/cloud-machine-api/${machineId}/tasks/${taskId}/speed-ack`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name UpdateMachineTask
		 * @request POST:/cloud-machine-api/{machineId}/tasks/{taskId}/path
		 */
		updateMachineTask: (
			machineId: string,
			taskId: string,
			data: TaskUpdate,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/tasks/${taskId}/path`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name CancelAccept
		 * @request POST:/cloud-machine-api/{machineId}/tasks/{taskId}/cancel-accept
		 */
		cancelAccept: (
			machineId: string,
			taskId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/tasks/${taskId}/cancel-accept`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name AcceptTask
		 * @request POST:/cloud-machine-api/{machineId}/tasks/{taskId}/accept
		 */
		acceptTask: (
			machineId: string,
			taskId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/tasks/${taskId}/accept`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name RejectTask
		 * @request POST:/cloud-machine-api/{machineId}/tasks/{taskId}/reject
		 */
		rejectTask: (
			machineId: string,
			taskId: string,
			data: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/cloud-machine-api/${machineId}/tasks/${taskId}/reject`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name ResultTask
		 * @request POST:/cloud-machine-api/{machineId}/tasks/{taskId}/result
		 */
		resultTask: (
			machineId: string,
			taskId: string,
			data: TaskResult,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/tasks/${taskId}/result`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UnloadTarget
		 * @name GetMachineUnloadTargetsByHarvesterAndCart
		 * @request GET:/cloud-machine-api/{machineId}/unload-target
		 */
		getMachineUnloadTargetsByHarvesterAndCart: (
			machineId: string,
			query?: {
				/** @format uuid */
				harvesterId?: string;
				/** @format uuid */
				cartId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<UnloadTarget[], void>({
				path: `/cloud-machine-api/${machineId}/unload-target`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UnloadTarget
		 * @name MachineCreateOrUpdateUnloadTarget
		 * @request POST:/cloud-machine-api/{machineId}/unload-target
		 */
		machineCreateOrUpdateUnloadTarget: (
			machineId: string,
			data: UnloadTarget,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/cloud-machine-api/${machineId}/unload-target`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UnloadTarget
		 * @name GetMachineAllUnloadTargetsForCart
		 * @request GET:/cloud-machine-api/{machineId}/unload-targets
		 */
		getMachineAllUnloadTargetsForCart: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<UnloadTarget[], void>({
				path: `/cloud-machine-api/${machineId}/unload-targets`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UnloadTarget
		 * @name GetMachineAllUnloadTargetsForHarvester
		 * @request GET:/cloud-machine-api/{machineId}/unload-targets/harvester
		 */
		getMachineAllUnloadTargetsForHarvester: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<UnloadTarget[], void>({
				path: `/cloud-machine-api/${machineId}/unload-targets/harvester`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	tasks = {
		/**
		 * No description
		 *
		 * @tags AutonomyTask
		 * @name AutonomyList
		 * @request GET:/tasks/autonomy
		 */
		autonomyList: (
			query?: {
				/** @format uuid */
				missionId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<LineString, void>({
				path: `/tasks/autonomy`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags AutonomyTask
		 * @name PlannedPathsList
		 * @request GET:/tasks/planned-paths
		 */
		plannedPathsList: (
			query?: {
				/** @format uuid */
				missionId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AutonomyTaskData[], void>({
				path: `/tasks/planned-paths`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetTask
		 * @request GET:/tasks/{machineId}/task
		 */
		getTask: (
			machineId: string,
			query?: {
				/** @format uuid */
				taskId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AutonomousTask, void>({
				path: `/tasks/${machineId}/task`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetActiveTask
		 * @request GET:/tasks/{machineId}/active-task
		 */
		getActiveTask: (machineId: string, params: RequestParams = {}) =>
			this.request<AutonomousTask, ProblemDetails | void>({
				path: `/tasks/${machineId}/active-task`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetTasksBySourceMachine
		 * @request GET:/tasks/{machineId}/tasks-by-source
		 */
		getTasksBySourceMachine: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<AutonomousTask[], void>({
				path: `/tasks/${machineId}/tasks-by-source`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetActiveTaskBySourceMachine
		 * @request GET:/tasks/{machineId}/tasks-by-source/active
		 */
		getActiveTaskBySourceMachine: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<AutonomousTask, void>({
				path: `/tasks/${machineId}/tasks-by-source/active`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetActiveTasksForMission
		 * @request GET:/tasks/missions/{missionId}/active
		 */
		getActiveTasksForMission: (
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<AutonomousTask[], void>({
				path: `/tasks/missions/${missionId}/active`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name CreateTaskOld
		 * @request POST:/tasks/{machineId}/{taskId}/path
		 * @deprecated
		 */
		createTaskOld: (
			machineId: string,
			taskId: string,
			data: NewTask,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/tasks/${machineId}/${taskId}/path`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name CreateTask
		 * @request POST:/tasks/{machineId}/path
		 */
		createTask: (
			machineId: string,
			data: NewTask,
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/tasks/${machineId}/path`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name GetTaskSpeeds
		 * @request GET:/tasks/{machineId}/speed
		 */
		getTaskSpeeds: (machineId: string, params: RequestParams = {}) =>
			this.request<
				{
					follow_behind_harvester?: TaskSpeeds;
					send_to_truck?: TaskSpeeds;
					stage_cart?: TaskSpeeds;
					unload_to_cart?: TaskSpeeds;
					tillage_coverage?: TaskSpeeds;
					tillage_service?: TaskSpeeds;
				},
				ProblemDetails | void
			>({
				path: `/tasks/${machineId}/speed`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name ChangeTaskSpeed
		 * @request PUT:/tasks/{machineId}/speed
		 */
		changeTaskSpeed: (
			machineId: string,
			data: SpeedChangeRequest,
			params: RequestParams = {},
		) =>
			this.request<SpeedChangeResponse, SpeedChangeResponse | void>({
				path: `/tasks/${machineId}/speed`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name UpdateTask
		 * @request POST:/tasks/{machineId}/{taskId}/update-path
		 */
		updateTask: (
			machineId: string,
			taskId: string,
			data: TaskUpdate,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/tasks/${machineId}/${taskId}/update-path`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosTask
		 * @name CancelTask
		 * @request POST:/tasks/{machineId}/{taskId}/cancel
		 */
		cancelTask: (
			machineId: string,
			taskId: string,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/tasks/${machineId}/${taskId}/cancel`,
				method: "POST",
				...params,
			}),
	};
	boundaries = {
		/**
		 * No description
		 *
		 * @tags Boundaries
		 * @name BoundariesList
		 * @request GET:/Boundaries
		 */
		boundariesList: (
			query?: {
				/** @default false */
				isRtkRecorded?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<BoundarySummary[], void>({
				path: `/Boundaries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Boundaries
		 * @name BoundariesCreate
		 * @request POST:/Boundaries
		 */
		boundariesCreate: (data: NewBoundary, params: RequestParams = {}) =>
			this.request<string, void>({
				path: `/Boundaries`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Boundaries
		 * @name BoundariesUpdate
		 * @request PUT:/Boundaries
		 */
		boundariesUpdate: (data: BoundaryUpdate, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/Boundaries`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Boundaries
		 * @name GetBoundary
		 * @request GET:/Boundaries/{boundaryId}
		 */
		getBoundary: (
			boundaryId: string,
			query?: {
				/** @default false */
				simplified?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<Boundary, ProblemDetails | void>({
				path: `/Boundaries/${boundaryId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Boundaries
		 * @name BoundariesDelete
		 * @request DELETE:/Boundaries/{boundaryId}
		 */
		boundariesDelete: (boundaryId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/Boundaries/${boundaryId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Boundaries
		 * @name ParametersUpdate
		 * @request PUT:/Boundaries/{boundaryId}/parameters
		 */
		parametersUpdate: (
			boundaryId: string,
			data: BoundaryParameters,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/Boundaries/${boundaryId}/parameters`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Boundaries
		 * @name FarmsList
		 * @request GET:/Boundaries/{boundaryId}/farms
		 */
		farmsList: (boundaryId: string, params: RequestParams = {}) =>
			this.request<Field[], ProblemDetails | void>({
				path: `/Boundaries/${boundaryId}/farms`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Boundaries
		 * @name GeofenceList
		 * @request GET:/Boundaries/{boundaryId}/geofence
		 */
		geofenceList: (boundaryId: string, params: RequestParams = {}) =>
			this.request<BoundaryGeofence, ProblemDetails | void>({
				path: `/Boundaries/${boundaryId}/geofence`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Boundaries
		 * @name GeofenceCreate
		 * @request POST:/Boundaries/{boundaryId}/geofence
		 */
		geofenceCreate: (
			boundaryId: string,
			query?: {
				/** @format double */
				bufferDistanceMeters?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/Boundaries/${boundaryId}/geofence`,
				method: "POST",
				query: query,
				...params,
			}),
	};
	machines = {
		/**
		 * No description
		 *
		 * @tags CalibrationCommand
		 * @name CalibrationStateCreate
		 * @request POST:/machines/{machineId}/calibration/state
		 */
		calibrationStateCreate: (
			machineId: string,
			query: {
				/** @format uuid */
				implementId: string;
			},
			data: RosMachineCalibrationStateRequestMessage,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/machines/${machineId}/calibration/state`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags CalibrationCommand
		 * @name CalibrationSensorCreate
		 * @request POST:/machines/{machineId}/calibration/sensor
		 */
		calibrationSensorCreate: (
			machineId: string,
			query: {
				/** @format uuid */
				implementId: string;
			},
			data: RosImplementSensorCalibrationRequestMessage,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/machines/${machineId}/calibration/sensor`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags CalibrationCommand
		 * @name CalibrationTimingCreate
		 * @request POST:/machines/{machineId}/calibration/timing
		 */
		calibrationTimingCreate: (
			machineId: string,
			data: RosImplementTimingCalibrationRequestMessage,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/machines/${machineId}/calibration/timing`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name FeatureFlagsHistoryList
		 * @request GET:/machines/{machineId}/feature-flags/history
		 */
		featureFlagsHistoryList: (
			machineId: string,
			query?: {
				/**
				 * @format int32
				 * @default 50
				 */
				limit?: number;
				/**
				 * @format int32
				 * @default 0
				 */
				offset?: number;
				/** @format date-time */
				from?: string;
				/** @format date-time */
				to?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineFeatureFlagReport[], ProblemDetails>({
				path: `/machines/${machineId}/feature-flags/history`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name AssignedMissionList
		 * @request GET:/machines/{machineId}/assigned-mission
		 */
		assignedMissionList: (machineId: string, params: RequestParams = {}) =>
			this.request<AssignedMissionResponse, ProblemDetails | void>({
				path: `/machines/${machineId}/assigned-mission`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PersonDetectionRecovery
		 * @name GetPersonDetectionRecoveryById
		 * @request GET:/machines/{machineId}/person-detection-recovery/{recoveryId}
		 */
		getPersonDetectionRecoveryById: (
			machineId: string,
			recoveryId: string,
			params: RequestParams = {},
		) =>
			this.request<PersonDetectionRecoveryModel, ProblemDetails | void>({
				path: `/machines/${machineId}/person-detection-recovery/${recoveryId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PersonDetectionRecovery
		 * @name GetPersonDetectionRecoveriesByEventId
		 * @request GET:/machines/{machineId}/person-detection-recovery/event/{eventId}
		 */
		getPersonDetectionRecoveriesByEventId: (
			machineId: string,
			eventId: string,
			params: RequestParams = {},
		) =>
			this.request<PersonDetectionRecoveryModel[], ProblemDetails | void>(
				{
					path: `/machines/${machineId}/person-detection-recovery/event/${eventId}`,
					method: "GET",
					format: "json",
					...params,
				},
			),

		/**
		 * No description
		 *
		 * @tags PersonDetectionRecovery
		 * @name SetPersonDetectionRecoveryDecision
		 * @request POST:/machines/{machineId}/person-detection-recovery/{recoveryId}/decision
		 */
		setPersonDetectionRecoveryDecision: (
			machineId: string,
			recoveryId: string,
			data: SetPersonDetectionRecoveryDecisionRequest,
			params: RequestParams = {},
		) =>
			this.request<
				PersonDetectionRecoveryDecisionResult,
				ProblemDetails | void
			>({
				path: `/machines/${machineId}/person-detection-recovery/${recoveryId}/decision`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	videostream = {
		/**
		 * No description
		 *
		 * @tags Channels
		 * @name GetChannels
		 * @request GET:/videostream/Channels/{accountId}/machines
		 */
		getChannels: (accountId: string, params: RequestParams = {}) =>
			this.request<ChannelDto[], any>({
				path: `/videostream/Channels/${accountId}/machines`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Channels
		 * @name GetMachineChannels
		 * @request GET:/videostream/Channels/{accountId}/machines/{machineId}
		 */
		getMachineChannels: (
			accountId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<ChannelDto[], any>({
				path: `/videostream/Channels/${accountId}/machines/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Channels
		 * @name GetMachineCameraChannel
		 * @request GET:/videostream/Channels/{accountId}/machines/{machineId}/cameras/{cameraName}
		 */
		getMachineCameraChannel: (
			accountId: string,
			machineId: string,
			cameraName: string,
			params: RequestParams = {},
		) =>
			this.request<ChannelDto, ProblemDetails>({
				path: `/videostream/Channels/${accountId}/machines/${machineId}/cameras/${cameraName}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Channels
		 * @name CreateChannel
		 * @request POST:/videostream/Channels/{accountId}/machines/{machineId}/cameras/{cameraName}
		 */
		createChannel: (
			accountId: string,
			machineId: string,
			cameraName: string,
			query?: {
				machineName?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<ChannelDto, ProblemDetails | void>({
				path: `/videostream/Channels/${accountId}/machines/${machineId}/cameras/${cameraName}`,
				method: "POST",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Channels
		 * @name DeleteChannel
		 * @request DELETE:/videostream/Channels/{accountId}/machines/{machineId}/cameras/{cameraName}
		 */
		deleteChannel: (
			accountId: string,
			machineId: string,
			cameraName: string,
			params: RequestParams = {},
		) =>
			this.request<boolean, ProblemDetails>({
				path: `/videostream/Channels/${accountId}/machines/${machineId}/cameras/${cameraName}`,
				method: "DELETE",
				format: "json",
				...params,
			}),
	};
	umc = {
		/**
		 * No description
		 *
		 * @tags Country
		 * @name GetCountry
		 * @request GET:/umc/Country/{countryId}
		 */
		getCountry: (countryId: string, params: RequestParams = {}) =>
			this.request<Country, ProblemDetails | void>({
				path: `/umc/Country/${countryId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Country
		 * @name CountryList
		 * @request GET:/umc/Country
		 */
		countryList: (
			query?: {
				name?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<Country[], ProblemDetails | void>({
				path: `/umc/Country`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name GetDealer
		 * @request GET:/umc/Dealer/{dealerId}
		 */
		getDealer: (dealerId: string, params: RequestParams = {}) =>
			this.request<DealerDto, ProblemDetails | void>({
				path: `/umc/Dealer/${dealerId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name DeleteDealer
		 * @request DELETE:/umc/Dealer/{dealerId}
		 */
		deleteDealer: (dealerId: string, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/umc/Dealer/${dealerId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name GetDealers
		 * @request GET:/umc/Dealer
		 */
		getDealers: (
			query?: {
				isActive?: boolean;
				name?: string;
				countryId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<DealerDto[], ProblemDetails | void>({
				path: `/umc/Dealer`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name DealerCreate
		 * @request POST:/umc/Dealer
		 */
		dealerCreate: (data: DealerDto, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/umc/Dealer`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name UpdateDealer
		 * @request PUT:/umc/Dealer
		 */
		updateDealer: (data: DealerDto, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/umc/Dealer`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name ActivateOrDeactivateDealer
		 * @request PUT:/umc/Dealer/{dealerId}/activate/{isActive}
		 */
		activateOrDeactivateDealer: (
			dealerId: string,
			isActive: boolean,
			params: RequestParams = {},
		) =>
			this.request<string[], ProblemDetails | void>({
				path: `/umc/Dealer/${dealerId}/activate/${isActive}`,
				method: "PUT",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name GetDealerUserById
		 * @request GET:/umc/Dealer/{dealerId}/users/{userId}
		 */
		getDealerUserById: (
			dealerId: string,
			userId: string,
			params: RequestParams = {},
		) =>
			this.request<DealerUserDto, ProblemDetails | void>({
				path: `/umc/Dealer/${dealerId}/users/${userId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name GetDealerUserByEmail
		 * @request GET:/umc/Dealer/{dealerId}/users/email/{userEmail}
		 */
		getDealerUserByEmail: (
			dealerId: string,
			userEmail: string,
			params: RequestParams = {},
		) =>
			this.request<DealerUserDto, ProblemDetails | void>({
				path: `/umc/Dealer/${dealerId}/users/email/${userEmail}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name GetDealerUsers
		 * @request GET:/umc/Dealer/{dealerId}/users
		 */
		getDealerUsers: (
			dealerId: string,
			query?: {
				userEmail?: string;
				userName?: string;
				isUserEnabled?: boolean;
				dealerName?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<DealerUserDto, ProblemDetails | void>({
				path: `/umc/Dealer/${dealerId}/users`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name AddDealerUser
		 * @request POST:/umc/Dealer/{dealerId}/users
		 */
		addDealerUser: (
			dealerId: string,
			data: CreateUmcUserRequest,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/umc/Dealer/${dealerId}/users`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name EnableOrDisableDealerUser
		 * @request PUT:/umc/Dealer/{dealerId}/users/{userEmail}/enable/{enable}
		 */
		enableOrDisableDealerUser: (
			dealerId: string,
			userEmail: string,
			enable: boolean,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/umc/Dealer/${dealerId}/users/${userEmail}/enable/${enable}`,
				method: "PUT",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Dealer
		 * @name DeleteDealerUser
		 * @request DELETE:/umc/Dealer/{dealerId}/users/{dealerUserId}
		 */
		deleteDealerUser: (
			dealerId: string,
			dealerUserId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/umc/Dealer/${dealerId}/users/${dealerUserId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organization
		 * @name GetUmcOrganizations
		 * @request GET:/umc/Organization
		 */
		getUmcOrganizations: (
			query?: {
				name?: string;
				isActive?: boolean;
				isEngOrg?: boolean;
				/** @format uuid */
				dealerId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AccountDto[], ProblemDetails | void>({
				path: `/umc/Organization`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organization
		 * @name OrganizationCreate
		 * @request POST:/umc/Organization
		 */
		organizationCreate: (data: AccountDto, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/umc/Organization`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organization
		 * @name UpdateUmcOrganization
		 * @request PUT:/umc/Organization
		 */
		updateUmcOrganization: (data: AccountDto, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/umc/Organization`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organization
		 * @name GetOrganizationsByGroup
		 * @request GET:/umc/Organization/access
		 */
		getOrganizationsByGroup: (
			query?: {
				isActive?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<AccountDto[], ProblemDetails | void>({
				path: `/umc/Organization/access`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organization
		 * @name GetUmcOrganization
		 * @request GET:/umc/Organization/{orgId}
		 */
		getUmcOrganization: (
			orgId: string,
			query?: {
				isActive?: boolean;
				isEngOrg?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<AccountDto, ProblemDetails | void>({
				path: `/umc/Organization/${orgId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organization
		 * @name DeleteUmcOrganization
		 * @request DELETE:/umc/Organization/{orgId}
		 */
		deleteUmcOrganization: (orgId: string, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/umc/Organization/${orgId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name ActivateCognitoUser
		 * @request PUT:/umc/User/{userEmail}/activate
		 */
		activateCognitoUser: (userEmail: string, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/umc/User/${userEmail}/activate`,
				method: "PUT",
				...params,
			}),
	};
	coverage = {
		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CoverageList
		 * @request GET:/coverage
		 */
		coverageList: (
			query?: {
				/** @format uuid */
				jobId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MultiPolygon, void>({
				path: `/coverage`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name HarvestedCoverageList
		 * @request GET:/coverage/harvested-coverage
		 */
		harvestedCoverageList: (
			query?: {
				/** @format uuid */
				jobId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MultiPolygon, ProblemDetails | void>({
				path: `/coverage/harvested-coverage`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name DrivenPathList
		 * @request GET:/coverage/driven-path
		 */
		drivenPathList: (
			query?: {
				/** @format uuid */
				jobId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MultiLineString, void>({
				path: `/coverage/driven-path`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CompressedList
		 * @request GET:/coverage/compressed
		 */
		compressedList: (
			query?: {
				/** @format uuid */
				jobId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/coverage/compressed`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name DrivenPathCompressedList
		 * @request GET:/coverage/driven-path/compressed
		 */
		drivenPathCompressedList: (
			query?: {
				/** @format uuid */
				jobId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/coverage/driven-path/compressed`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CoverageCreate
		 * @request POST:/coverage/{missionId}
		 */
		coverageCreate: (
			missionId: string,
			data: FullDrivenPathCoverageCombinedUncompressed,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/coverage/${missionId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CloudList
		 * @request GET:/coverage/cloud
		 */
		cloudList: (
			query?: {
				/** @format uuid */
				jobId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MultiPolygon, ProblemDetails | void>({
				path: `/coverage/cloud`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name AutonomousList
		 * @request GET:/coverage/autonomous
		 */
		autonomousList: (
			query?: {
				/** @format uuid */
				jobId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MultiPolygon, void>({
				path: `/coverage/autonomous`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CloudHarvestedCoverageList
		 * @request GET:/coverage/cloud/harvested-coverage
		 * @deprecated
		 */
		cloudHarvestedCoverageList: (
			query?: {
				/** @format uuid */
				jobId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MultiPolygon, ProblemDetails | void>({
				path: `/coverage/cloud/harvested-coverage`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name GenerateList
		 * @request GET:/coverage/generate
		 */
		generateList: (
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				implementId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				/** @format double */
				simplifyTolerance?: number;
				/** @format int32 */
				polygonUnionBatchSize?: number;
				/** @format int32 */
				lineSimplifyBatchSize?: number;
				/** @format double */
				distanceThreshold?: number;
				/** @format double */
				angleThreshold?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<GeneratedCoverageResponse, ProblemDetails | void>({
				path: `/coverage/generate`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name GenerateCreate
		 * @request POST:/coverage/generate
		 */
		generateCreate: (
			data: CoverageGenerationState,
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				implementId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				/** @format double */
				simplifyTolerance?: number;
				/** @format int32 */
				polygonUnionBatchSize?: number;
				/** @format int32 */
				lineSimplifyBatchSize?: number;
				/** @format double */
				distanceThreshold?: number;
				/** @format double */
				angleThreshold?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<CoverageGenerationState, ProblemDetails | void>({
				path: `/coverage/generate`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	dealer = {
		/**
		 * No description
		 *
		 * @tags DealerKinesisVideo
		 * @name GetDealerKinesisVideoWebRtcViewerCredentials
		 * @request POST:/dealer/kinesis-video/webrtc-viewer-credentials
		 */
		getDealerKinesisVideoWebRtcViewerCredentials: (
			data: DealerKinesisCredentialsRequest,
			params: RequestParams = {},
		) =>
			this.request<
				DealerKinesisCredentialsResponse,
				ProblemDetails | void
			>({
				path: `/dealer/kinesis-video/webrtc-viewer-credentials`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	events = {
		/**
		 * No description
		 *
		 * @tags Event
		 * @name GetEventById
		 * @request GET:/Events/{eventId}
		 */
		getEventById: (eventId: string, params: RequestParams = {}) =>
			this.request<EventDetailsModel, ProblemDetails | void>({
				path: `/Events/${eventId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Event
		 * @name GetEventsByBagName
		 * @request GET:/Events/bag
		 */
		getEventsByBagName: (
			query?: {
				bagName?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<EventDetailsModel[], ProblemDetails | void>({
				path: `/Events/bag`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Event
		 * @name GetEvents
		 * @request GET:/Events
		 */
		getEvents: (
			query?: {
				accountIds?: string[];
				machineIds?: string[];
				eventTypes?: string[];
				reasons?: string[];
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				uploaded?: boolean;
				streamNames?: string[];
				/**
				 * @format int32
				 * @default 1
				 */
				page?: number;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<EventBaseModelPageResponse, ProblemDetails | void>({
				path: `/Events`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Event
		 * @name GetMachineUploadQueueStatus
		 * @request GET:/Events/queue-status
		 */
		getMachineUploadQueueStatus: (
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				accountId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineUploadQueueStatusModel, ProblemDetails | void>({
				path: `/Events/queue-status`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	farmEngage = {
		/**
		 * No description
		 *
		 * @tags FarmEngage
		 * @name OrganizationsList
		 * @request GET:/FarmEngage/organizations
		 */
		organizationsList: (params: RequestParams = {}) =>
			this.request<FarmEngageOrganizationDto[], ProblemDetails | void>({
				path: `/FarmEngage/organizations`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FarmEngage
		 * @name OrganizationsFieldsList
		 * @request GET:/FarmEngage/organizations/{orgId}/fields
		 */
		organizationsFieldsList: (orgId: string, params: RequestParams = {}) =>
			this.request<FarmEngageFieldDto[], ProblemDetails | void>({
				path: `/FarmEngage/organizations/${orgId}/fields`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FarmEngage
		 * @name OrganizationsFieldsExtentList
		 * @request GET:/FarmEngage/organizations/{orgId}/fields/{fieldId}/extent
		 */
		organizationsFieldsExtentList: (
			orgId: string,
			fieldId: string,
			params: RequestParams = {},
		) =>
			this.request<FarmEngageFieldExtentDto, ProblemDetails | void>({
				path: `/FarmEngage/organizations/${orgId}/fields/${fieldId}/extent`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FarmEngage
		 * @name OrganizationsBoundariesList
		 * @request GET:/FarmEngage/organizations/{orgId}/boundaries
		 */
		organizationsBoundariesList: (
			orgId: string,
			params: RequestParams = {},
		) =>
			this.request<FarmEngageBoundaryDto[], ProblemDetails | void>({
				path: `/FarmEngage/organizations/${orgId}/boundaries`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FarmEngage
		 * @name FarmEngageGetBoundary
		 * @request GET:/FarmEngage/organizations/{orgId}/boundaries/{boundaryId}
		 */
		farmEngageGetBoundary: (
			orgId: string,
			boundaryId: string,
			params: RequestParams = {},
		) =>
			this.request<FarmEngageBoundaryDto, ProblemDetails | void>({
				path: `/FarmEngage/organizations/${orgId}/boundaries/${boundaryId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FarmEngage
		 * @name GetGuidanceLinesList
		 * @request GET:/FarmEngage/organizations/{orgId}/guidancelines
		 */
		getGuidanceLinesList: (orgId: string, params: RequestParams = {}) =>
			this.request<FarmEngageGuidanceLineListDto, ProblemDetails | void>({
				path: `/FarmEngage/organizations/${orgId}/guidancelines`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FarmEngage
		 * @name GetGuidanceLineDetail
		 * @request GET:/FarmEngage/organizations/{orgId}/guidancelines/{guidanceLineId}
		 */
		getGuidanceLineDetail: (
			orgId: string,
			guidanceLineId: string,
			params: RequestParams = {},
		) =>
			this.request<
				FarmEngageGuidanceLineDetailDto,
				ProblemDetails | void
			>({
				path: `/FarmEngage/organizations/${orgId}/guidancelines/${guidanceLineId}`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	featureFlags = {
		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysCreate
		 * @request POST:/feature-flags/keys
		 */
		keysCreate: (
			data: CreateFeatureFlagKeyRequest,
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagKey, ProblemDetails>({
				path: `/feature-flags/keys`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysList
		 * @request GET:/feature-flags/keys
		 */
		keysList: (
			query?: {
				/** @default false */
				showInactive?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagKey[], any>({
				path: `/feature-flags/keys`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysDetail
		 * @request GET:/feature-flags/keys/{keyId}
		 */
		keysDetail: (keyId: string, params: RequestParams = {}) =>
			this.request<FeatureFlagKeyDetail, ProblemDetails>({
				path: `/feature-flags/keys/${keyId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysPartialUpdate
		 * @request PATCH:/feature-flags/keys/{keyId}
		 */
		keysPartialUpdate: (
			keyId: string,
			data: UpdateFeatureFlagKeyRequest,
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagKey, ProblemDetails>({
				path: `/feature-flags/keys/${keyId}`,
				method: "PATCH",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysActivatePartialUpdate
		 * @request PATCH:/feature-flags/keys/{keyId}/activate
		 */
		keysActivatePartialUpdate: (
			keyId: string,
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagKey, ProblemDetails>({
				path: `/feature-flags/keys/${keyId}/activate`,
				method: "PATCH",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysDeactivatePartialUpdate
		 * @request PATCH:/feature-flags/keys/{keyId}/deactivate
		 */
		keysDeactivatePartialUpdate: (
			keyId: string,
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagKey, ProblemDetails>({
				path: `/feature-flags/keys/${keyId}/deactivate`,
				method: "PATCH",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysEnumOptionsCreate
		 * @request POST:/feature-flags/keys/{keyId}/enum-options
		 */
		keysEnumOptionsCreate: (
			keyId: string,
			data: CreateEnumOptionRequest,
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagEnumOption, ProblemDetails>({
				path: `/feature-flags/keys/${keyId}/enum-options`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysEnumOptionsPartialUpdate
		 * @request PATCH:/feature-flags/keys/{keyId}/enum-options/{optionId}
		 */
		keysEnumOptionsPartialUpdate: (
			keyId: string,
			optionId: string,
			data: UpdateEnumOptionRequest,
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagEnumOption, ProblemDetails>({
				path: `/feature-flags/keys/${keyId}/enum-options/${optionId}`,
				method: "PATCH",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysEnumOptionsDelete
		 * @request DELETE:/feature-flags/keys/{keyId}/enum-options/{optionId}
		 */
		keysEnumOptionsDelete: (
			keyId: string,
			optionId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails>({
				path: `/feature-flags/keys/${keyId}/enum-options/${optionId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name ValuesList
		 * @request GET:/feature-flags/values
		 */
		valuesList: (
			query?: {
				scopeLevel?: string;
				/** @format uuid */
				organizationId?: string;
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				keyId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagValue[], ProblemDetails>({
				path: `/feature-flags/values`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name ValuesByKeyNameList
		 * @request GET:/feature-flags/values-by-key-name
		 */
		valuesByKeyNameList: (
			query?: {
				keyName?: string;
				/** @format uuid */
				organizationId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagValue[], ProblemDetails>({
				path: `/feature-flags/values-by-key-name`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name ValuesUpdate
		 * @request PUT:/feature-flags/values/{keyId}
		 */
		valuesUpdate: (
			keyId: string,
			data: SetFeatureFlagValueRequest,
			query?: {
				scopeLevel?: string;
				/** @format uuid */
				organizationId?: string;
				/** @format uuid */
				machineId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagValue, ProblemDetails>({
				path: `/feature-flags/values/${keyId}`,
				method: "PUT",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name ValuesActivatePartialUpdate
		 * @request PATCH:/feature-flags/values/{keyId}/activate
		 */
		valuesActivatePartialUpdate: (
			keyId: string,
			query?: {
				scopeLevel?: string;
				/** @format uuid */
				organizationId?: string;
				/** @format uuid */
				machineId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails>({
				path: `/feature-flags/values/${keyId}/activate`,
				method: "PATCH",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name ValuesDeactivatePartialUpdate
		 * @request PATCH:/feature-flags/values/{keyId}/deactivate
		 */
		valuesDeactivatePartialUpdate: (
			keyId: string,
			query?: {
				scopeLevel?: string;
				/** @format uuid */
				organizationId?: string;
				/** @format uuid */
				machineId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails>({
				path: `/feature-flags/values/${keyId}/deactivate`,
				method: "PATCH",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name KeysAuditLogList
		 * @request GET:/feature-flags/keys/{keyId}/audit-log
		 */
		keysAuditLogList: (
			keyId: string,
			query?: {
				/**
				 * @format int32
				 * @default 50
				 */
				limit?: number;
				/**
				 * @format int32
				 * @default 0
				 */
				offset?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagAuditEntry[], ProblemDetails>({
				path: `/feature-flags/keys/${keyId}/audit-log`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name AuditLogList
		 * @request GET:/feature-flags/audit-log
		 */
		auditLogList: (
			query?: {
				/** @format uuid */
				userId?: string;
				action?: string;
				/** @format date-time */
				from?: string;
				/** @format date-time */
				to?: string;
				/**
				 * @format int32
				 * @default 50
				 */
				limit?: number;
				/**
				 * @format int32
				 * @default 0
				 */
				offset?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagAuditEntry[], any>({
				path: `/feature-flags/audit-log`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name AdminsList
		 * @request GET:/feature-flags/admins
		 */
		adminsList: (
			query?: {
				nextToken?: string;
				/**
				 * @format int32
				 * @default 25
				 */
				limit?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<FeatureFlagAdminDto[], any>({
				path: `/feature-flags/admins`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FeatureFlag
		 * @name AdminsCreate
		 * @request POST:/feature-flags/admins/{username}
		 */
		adminsCreate: (username: string, params: RequestParams = {}) =>
			this.request<void, ProblemDetails>({
				path: `/feature-flags/admins/${username}`,
				method: "POST",
				...params,
			}),
	};
	farms = {
		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FarmsList
		 * @request GET:/farms
		 */
		farmsList: (params: RequestParams = {}) =>
			this.request<Field[], void>({
				path: `/farms`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FarmsCreate
		 * @request POST:/farms
		 */
		farmsCreate: (data: NewField, params: RequestParams = {}) =>
			this.request<string, void>({
				path: `/farms`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FarmsUpdate
		 * @request PUT:/farms
		 */
		farmsUpdate: (data: FieldUpdate, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/farms`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name InfoList
		 * @request GET:/farms/info
		 */
		infoList: (
			query?: {
				/** @default false */
				isRtkRecorded?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<FieldInfo[], void>({
				path: `/farms/info`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FarmsDetail
		 * @request GET:/farms/{fieldId}
		 */
		farmsDetail: (fieldId: string, params: RequestParams = {}) =>
			this.request<Field, ProblemDetails | void>({
				path: `/farms/${fieldId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FarmsDelete
		 * @request DELETE:/farms/{fieldId}
		 */
		farmsDelete: (
			fieldId: string,
			query?: {
				/** @default false */
				deleteBoundaries?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/farms/${fieldId}`,
				method: "DELETE",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FieldsWithBoundariesCreate
		 * @request POST:/farms/fields-with-boundaries
		 */
		fieldsWithBoundariesCreate: (
			data: NewFieldBoundary[],
			params: RequestParams = {},
		) =>
			this.request<string[], ProblemDetails | void>({
				path: `/farms/fields-with-boundaries`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name BoundariesCreate
		 * @request POST:/farms/{fieldId}/boundaries
		 */
		boundariesCreate: (
			fieldId: string,
			data: NewBoundary,
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/farms/${fieldId}/boundaries`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name BoundariesList
		 * @request GET:/farms/{fieldId}/boundaries
		 */
		boundariesList: (
			fieldId: string,
			query?: {
				/** @default false */
				isRtkRecorded?: boolean;
				boundaryTypes?: BoundaryType[];
				/** @default false */
				simplified?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<Boundary[], ProblemDetails | void>({
				path: `/farms/${fieldId}/boundaries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name BoundariesCreate2
		 * @request POST:/farms/{fieldId}/boundaries/{boundaryId}
		 * @originalName boundariesCreate
		 * @duplicate
		 */
		boundariesCreate2: (
			fieldId: string,
			boundaryId: string,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/farms/${fieldId}/boundaries/${boundaryId}`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name ZonesList
		 * @request GET:/farms/{fieldId}/zones
		 */
		zonesList: (
			fieldId: string,
			query?: {
				/** @default false */
				simplified?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<Boundary[], ProblemDetails | void>({
				path: `/farms/${fieldId}/zones`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name ZonesDelete
		 * @request DELETE:/farms/{fieldId}/zones
		 */
		zonesDelete: (fieldId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/farms/${fieldId}/zones`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name LinefeaturesList
		 * @request GET:/farms/{fieldId}/linefeatures
		 */
		linefeaturesList: (
			fieldId: string,
			query?: {
				lineFeatureTypes?: LineFeatureType[];
			},
			params: RequestParams = {},
		) =>
			this.request<LineFeature[], ProblemDetails | void>({
				path: `/farms/${fieldId}/linefeatures`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name LinefeaturesCreate
		 * @request POST:/farms/{fieldId}/linefeatures
		 */
		linefeaturesCreate: (
			fieldId: string,
			data: NewLineFeature,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/farms/${fieldId}/linefeatures`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name LinefeaturesDetail
		 * @request GET:/farms/linefeatures/{lineFeatureId}
		 */
		linefeaturesDetail: (
			lineFeatureId: string,
			params: RequestParams = {},
		) =>
			this.request<LineFeature, ProblemDetails | void>({
				path: `/farms/linefeatures/${lineFeatureId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name LinefeaturesCreate2
		 * @request POST:/farms/{fieldId}/linefeatures/{lineFeatureId}
		 * @originalName linefeaturesCreate
		 * @duplicate
		 */
		linefeaturesCreate2: (
			fieldId: string,
			lineFeatureId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/farms/${fieldId}/linefeatures/${lineFeatureId}`,
				method: "POST",
				...params,
			}),
	};
	fields = {
		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FieldsList
		 * @request GET:/Fields
		 */
		fieldsList: (params: RequestParams = {}) =>
			this.request<Field[], void>({
				path: `/Fields`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FieldsCreate
		 * @request POST:/Fields
		 */
		fieldsCreate: (data: NewField, params: RequestParams = {}) =>
			this.request<string, void>({
				path: `/Fields`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FieldsUpdate
		 * @request PUT:/Fields
		 */
		fieldsUpdate: (data: FieldUpdate, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/Fields`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name InfoList
		 * @request GET:/Fields/info
		 */
		infoList: (
			query?: {
				/** @default false */
				isRtkRecorded?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<FieldInfo[], void>({
				path: `/Fields/info`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FieldsDetail
		 * @request GET:/Fields/{fieldId}
		 */
		fieldsDetail: (fieldId: string, params: RequestParams = {}) =>
			this.request<Field, ProblemDetails | void>({
				path: `/Fields/${fieldId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FieldsDelete
		 * @request DELETE:/Fields/{fieldId}
		 */
		fieldsDelete: (
			fieldId: string,
			query?: {
				/** @default false */
				deleteBoundaries?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/Fields/${fieldId}`,
				method: "DELETE",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name FieldsWithBoundariesCreate
		 * @request POST:/Fields/fields-with-boundaries
		 */
		fieldsWithBoundariesCreate: (
			data: NewFieldBoundary[],
			params: RequestParams = {},
		) =>
			this.request<string[], ProblemDetails | void>({
				path: `/Fields/fields-with-boundaries`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name BoundariesCreate
		 * @request POST:/Fields/{fieldId}/boundaries
		 */
		boundariesCreate: (
			fieldId: string,
			data: NewBoundary,
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/Fields/${fieldId}/boundaries`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name BoundariesList
		 * @request GET:/Fields/{fieldId}/boundaries
		 */
		boundariesList: (
			fieldId: string,
			query?: {
				/** @default false */
				isRtkRecorded?: boolean;
				boundaryTypes?: BoundaryType[];
				/** @default false */
				simplified?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<Boundary[], ProblemDetails | void>({
				path: `/Fields/${fieldId}/boundaries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name BoundariesCreate2
		 * @request POST:/Fields/{fieldId}/boundaries/{boundaryId}
		 * @originalName boundariesCreate
		 * @duplicate
		 */
		boundariesCreate2: (
			fieldId: string,
			boundaryId: string,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/Fields/${fieldId}/boundaries/${boundaryId}`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name ZonesList
		 * @request GET:/Fields/{fieldId}/zones
		 */
		zonesList: (
			fieldId: string,
			query?: {
				/** @default false */
				simplified?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<Boundary[], ProblemDetails | void>({
				path: `/Fields/${fieldId}/zones`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name ZonesDelete
		 * @request DELETE:/Fields/{fieldId}/zones
		 */
		zonesDelete: (fieldId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/Fields/${fieldId}/zones`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name LinefeaturesList
		 * @request GET:/Fields/{fieldId}/linefeatures
		 */
		linefeaturesList: (
			fieldId: string,
			query?: {
				lineFeatureTypes?: LineFeatureType[];
			},
			params: RequestParams = {},
		) =>
			this.request<LineFeature[], ProblemDetails | void>({
				path: `/Fields/${fieldId}/linefeatures`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name LinefeaturesCreate
		 * @request POST:/Fields/{fieldId}/linefeatures
		 */
		linefeaturesCreate: (
			fieldId: string,
			data: NewLineFeature,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/Fields/${fieldId}/linefeatures`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name LinefeaturesDetail
		 * @request GET:/Fields/linefeatures/{lineFeatureId}
		 */
		linefeaturesDetail: (
			lineFeatureId: string,
			params: RequestParams = {},
		) =>
			this.request<LineFeature, ProblemDetails | void>({
				path: `/Fields/linefeatures/${lineFeatureId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Fields
		 * @name LinefeaturesCreate2
		 * @request POST:/Fields/{fieldId}/linefeatures/{lineFeatureId}
		 * @originalName linefeaturesCreate
		 * @duplicate
		 */
		linefeaturesCreate2: (
			fieldId: string,
			lineFeatureId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/Fields/${fieldId}/linefeatures/${lineFeatureId}`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MissionsSummariesList
		 * @request GET:/fields/{fieldId}/missions/summaries
		 */
		missionsSummariesList: (
			fieldId: string,
			query?: {
				/** @format uuid */
				machineId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MissionSummary[], void>({
				path: `/fields/${fieldId}/missions/summaries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	foxglove = {
		/**
		 * No description
		 *
		 * @tags Foxglove
		 * @name GetDevice
		 * @request GET:/Foxglove/devices/{deviceId}
		 */
		getDevice: (deviceId: string, params: RequestParams = {}) =>
			this.request<FoxgloveDevice, ProblemDetails | void>({
				path: `/Foxglove/devices/${deviceId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Foxglove
		 * @name CreateRosbagUploadSession
		 * @request POST:/Foxglove/{machineId}/rosbag-upload-session
		 */
		createRosbagUploadSession: (
			machineId: string,
			data: RosbagUploadSessionRequest,
			params: RequestParams = {},
		) =>
			this.request<RosbagUploadSessionResponse, ProblemDetails | void>({
				path: `/Foxglove/${machineId}/rosbag-upload-session`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Foxglove
		 * @name AddDevice
		 * @request POST:/Foxglove/{machineId}/devices
		 */
		addDevice: (
			machineId: string,
			data: CreateFoxgloveDevice,
			params: RequestParams = {},
		) =>
			this.request<FoxgloveDevice, ProblemDetails | void>({
				path: `/Foxglove/${machineId}/devices`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Foxglove
		 * @name UpdateDevice
		 * @request PUT:/Foxglove/{machineId}/devices/{deviceId}
		 */
		updateDevice: (
			deviceId: string,
			machineId: string,
			data: UpdateFoxgloveDevice,
			params: RequestParams = {},
		) =>
			this.request<FoxgloveDevice, ProblemDetails | void>({
				path: `/Foxglove/${machineId}/devices/${deviceId}`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Foxglove
		 * @name DeleteDevice
		 * @request DELETE:/Foxglove/{machineId}/devices/{deviceId}
		 */
		deleteDevice: (
			deviceId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<FoxgloveDevice, ProblemDetails | void>({
				path: `/Foxglove/${machineId}/devices/${deviceId}`,
				method: "DELETE",
				format: "json",
				...params,
			}),
	};
	machineId = {
		/**
		 * No description
		 *
		 * @tags HarvesterOffsets
		 * @name HarvesterOffsetsList
		 * @request GET:/{machineId}/harvester-offsets
		 */
		harvesterOffsetsList: (machineId: string, params: RequestParams = {}) =>
			this.request<HarvesterOffsets, ProblemDetails | void>({
				path: `/${machineId}/harvester-offsets`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags HarvesterOffsets
		 * @name HarvesterOffsetsCreate
		 * @request POST:/{machineId}/harvester-offsets
		 */
		harvesterOffsetsCreate: (
			machineId: string,
			data: UpsertHarvesterOffsets,
			params: RequestParams = {},
		) =>
			this.request<HarvesterOffsets, ProblemDetails | void>({
				path: `/${machineId}/harvester-offsets`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	implementMachineCalibration = {
		/**
		 * No description
		 *
		 * @tags ImplementMachineCalibration
		 * @name MachineImplementDetail
		 * @request GET:/ImplementMachineCalibration/machine/{machineId}/implement/{implementId}
		 */
		machineImplementDetail: (
			machineId: string,
			implementId: string,
			params: RequestParams = {},
		) =>
			this.request<ImplementMachineCalibration, ProblemDetails | void>({
				path: `/ImplementMachineCalibration/machine/${machineId}/implement/${implementId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementMachineCalibration
		 * @name MachineDetail
		 * @request GET:/ImplementMachineCalibration/machine/{machineId}
		 */
		machineDetail: (machineId: string, params: RequestParams = {}) =>
			this.request<ImplementMachineCalibration[], void>({
				path: `/ImplementMachineCalibration/machine/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementMachineCalibration
		 * @name ImplementDetail
		 * @request GET:/ImplementMachineCalibration/implement/{implementId}
		 */
		implementDetail: (implementId: string, params: RequestParams = {}) =>
			this.request<ImplementMachineCalibration[], void>({
				path: `/ImplementMachineCalibration/implement/${implementId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementMachineCalibration
		 * @name ImplementMachineCalibrationCreate
		 * @request POST:/ImplementMachineCalibration
		 */
		implementMachineCalibrationCreate: (
			data: NewImplementMachineCalibration,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/ImplementMachineCalibration`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementMachineCalibration
		 * @name ImplementMachineCalibrationUpdate
		 * @request PUT:/ImplementMachineCalibration/{calibrationId}
		 */
		implementMachineCalibrationUpdate: (
			calibrationId: string,
			data: UpdateImplementMachineCalibration,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/ImplementMachineCalibration/${calibrationId}`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementMachineCalibration
		 * @name ImplementMachineCalibrationDelete
		 * @request DELETE:/ImplementMachineCalibration/{calibrationId}
		 */
		implementMachineCalibrationDelete: (
			calibrationId: string,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/ImplementMachineCalibration/${calibrationId}`,
				method: "DELETE",
				...params,
			}),
	};
	implements = {
		/**
		 * No description
		 *
		 * @tags ImplementMachineParameters
		 * @name MachinesParametersWheelSlipList
		 * @request GET:/implements/{implementId}/machines/{machineId}/parameters/wheel-slip
		 */
		machinesParametersWheelSlipList: (
			implementId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<WheelSlipValues, ProblemDetails | void>({
				path: `/implements/${implementId}/machines/${machineId}/parameters/wheel-slip`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementMachineParameters
		 * @name MachinesParametersWheelSlipCreate
		 * @request POST:/implements/{implementId}/machines/{machineId}/parameters/wheel-slip
		 */
		machinesParametersWheelSlipCreate: (
			implementId: string,
			machineId: string,
			data: UpsertWheelSlipValues,
			params: RequestParams = {},
		) =>
			this.request<WheelSlipValues, ProblemDetails | void>({
				path: `/implements/${implementId}/machines/${machineId}/parameters/wheel-slip`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name MachineAssignmentList
		 * @request GET:/implements/machine/{machineId}/assignment
		 */
		machineAssignmentList: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<ImplementV2Model, void>({
				path: `/implements/machine/${machineId}/assignment`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name MachineAssignmentCreate
		 * @request POST:/implements/{implementId}/machine/{machineId}/assignment
		 */
		machineAssignmentCreate: (
			implementId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/implements/${implementId}/machine/${machineId}/assignment`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name CalibrationsDelete
		 * @request DELETE:/implements/{implementId}/calibrations/{machineId}
		 */
		calibrationsDelete: (
			implementId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/implements/${implementId}/calibrations/${machineId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name RefreshCalibrationsCreate
		 * @request POST:/implements/{implementId}/refresh-calibrations/{machineId}
		 */
		refreshCalibrationsCreate: (
			implementId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/implements/${implementId}/refresh-calibrations/${machineId}`,
				method: "POST",
				...params,
			}),
	};
	implementV2 = {
		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ImplementV2List
		 * @request GET:/ImplementV2
		 */
		implementV2List: (
			query?: {
				implementType?: ImplementType;
			},
			params: RequestParams = {},
		) =>
			this.request<ImplementV2Model[], void>({
				path: `/ImplementV2`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ImplementV2Create
		 * @request POST:/ImplementV2
		 */
		implementV2Create: (
			data: ImplementV2Model,
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/ImplementV2`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ImplementV2Update
		 * @request PUT:/ImplementV2
		 */
		implementV2Update: (
			data: ImplementV2Model,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/ImplementV2`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name MachineDetail
		 * @request GET:/ImplementV2/machine/{machineId}
		 */
		machineDetail: (
			machineId: string,
			query?: {
				implementType?: ImplementType;
			},
			params: RequestParams = {},
		) =>
			this.request<ImplementV2Model[], void>({
				path: `/ImplementV2/machine/${machineId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ImplementV2Detail
		 * @request GET:/ImplementV2/{implementId}
		 */
		implementV2Detail: (implementId: string, params: RequestParams = {}) =>
			this.request<ImplementV2Model, ProblemDetails | void>({
				path: `/ImplementV2/${implementId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ImplementV2Delete
		 * @request DELETE:/ImplementV2/{implementId}
		 */
		implementV2Delete: (implementId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/ImplementV2/${implementId}`,
				method: "DELETE",
				...params,
			}),
	};
	implementv2 = {
		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ActiveCalibrationsList
		 * @request GET:/implementv2/{implementId}/active-calibrations
		 */
		activeCalibrationsList: (
			implementId: string,
			query?: {
				/** @format uuid */
				machineId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				ActiveImplementCalibrationMessage,
				ProblemDetails | void
			>({
				path: `/implementv2/${implementId}/active-calibrations`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name ActiveLookaheadsDetail
		 * @request GET:/implementv2/{implementId}/active-lookaheads/{machineId}
		 */
		activeLookaheadsDetail: (
			implementId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<
				ImplementActiveLookaheadMessage,
				ProblemDetails | void
			>({
				path: `/implementv2/${implementId}/active-lookaheads/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags ImplementV2
		 * @name CalibrationCreate
		 * @request POST:/implementv2/{implementId}/calibration/{machineId}
		 */
		calibrationCreate: (
			machineId: string,
			implementId: string,
			data: ImplementCalibrationRequest,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/implementv2/${implementId}/calibration/${machineId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),
	};
	attachIotPolicy = {
		/**
		 * No description
		 *
		 * @tags IotPolicy
		 * @name AttachIotPolicyCreate
		 * @request POST:/attach-iot-policy
		 */
		attachIotPolicyCreate: (
			data: AttachIotPolicyRequest,
			params: RequestParams = {},
		) =>
			this.request<AttachIotPolicyResponse, ProblemDetails | void>({
				path: `/attach-iot-policy`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	jobs = {
		/**
		 * No description
		 *
		 * @tags Jobs
		 * @name JobsDetail
		 * @request GET:/jobs/{machineId}
		 */
		jobsDetail: (machineId: string, params: RequestParams = {}) =>
			this.request<JobInfo, ProblemDetails | void>({
				path: `/jobs/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Jobs
		 * @name JobsDelete
		 * @request DELETE:/jobs/{machineId}
		 */
		jobsDelete: (machineId: string, params: RequestParams = {}) =>
			this.request<void, ProblemDetails>({
				path: `/jobs/${machineId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Jobs
		 * @name JobsCreate
		 * @request POST:/jobs
		 */
		jobsCreate: (data: CloudJobNotification, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/jobs`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name RecordingSessionList
		 * @request GET:/jobs/{jobId}/recording-session
		 */
		recordingSessionList: (jobId: string, params: RequestParams = {}) =>
			this.request<string[], void>({
				path: `/jobs/${jobId}/recording-session`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name RecordingSessionCreate
		 * @request POST:/jobs/{jobId}/recording-session
		 */
		recordingSessionCreate: (
			jobId: string,
			query?: {
				/** @default true */
				isNewBoundary?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/jobs/${jobId}/recording-session`,
				method: "POST",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name RecordingSessionDelete
		 * @request DELETE:/jobs/{jobId}/recording-session
		 */
		recordingSessionDelete: (jobId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/jobs/${jobId}/recording-session`,
				method: "DELETE",
				...params,
			}),
	};
	machineAssignments = {
		/**
		 * No description
		 *
		 * @tags MachineAssignments
		 * @name MissionDetail
		 * @request GET:/machine-assignments/mission/{missionId}
		 */
		missionDetail: (missionId: string, params: RequestParams = {}) =>
			this.request<string[], any>({
				path: `/machine-assignments/mission/${missionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineAssignments
		 * @name MissionsActiveList
		 * @request GET:/machine-assignments/missions/{missionId}/active
		 */
		missionsActiveList: (missionId: string, params: RequestParams = {}) =>
			this.request<string[], any>({
				path: `/machine-assignments/missions/${missionId}/active`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineAssignments
		 * @name MachinesActiveList
		 * @request GET:/machine-assignments/machines/{machineId}/active
		 */
		machinesActiveList: (machineId: string, params: RequestParams = {}) =>
			this.request<string | null, any>({
				path: `/machine-assignments/machines/${machineId}/active`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineAssignments
		 * @name MachinesInactiveList
		 * @request GET:/machine-assignments/machines/{machineId}/inactive
		 */
		machinesInactiveList: (machineId: string, params: RequestParams = {}) =>
			this.request<string[], any>({
				path: `/machine-assignments/machines/${machineId}/inactive`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineAssignments
		 * @name MachinesDetail
		 * @request GET:/machine-assignments/machines/{machineId}
		 */
		machinesDetail: (machineId: string, params: RequestParams = {}) =>
			this.request<string[], any>({
				path: `/machine-assignments/machines/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	machineData = {
		/**
		 * No description
		 *
		 * @tags MachineData
		 * @name GetMachineData
		 * @request GET:/MachineData/gps/{machineId}
		 */
		getMachineData: (machineId: string, params: RequestParams = {}) =>
			this.request<GpsMetricsMessage, void>({
				path: `/MachineData/gps/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineData
		 * @name DataDetail
		 * @request GET:/MachineData/data/{machineId}
		 */
		dataDetail: (machineId: string, params: RequestParams = {}) =>
			this.request<MachineDataMetricsMessage, void>({
				path: `/MachineData/data/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	machineMake = {
		/**
		 * No description
		 *
		 * @tags MachineMake
		 * @name GetActiveMachineMakes
		 * @request GET:/MachineMake
		 */
		getActiveMachineMakes: (
			query?: {
				/**
				 * @format int32
				 * @default 1
				 */
				page?: number;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineMakeDtoPageResponse, ProblemDetails | void>({
				path: `/MachineMake`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineMake
		 * @name AddMachineMake
		 * @request POST:/MachineMake
		 */
		addMachineMake: (data: MachineMakeDto, params: RequestParams = {}) =>
			this.request<MachineMakePageResponse, ProblemDetails | void>({
				path: `/MachineMake`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	machineModel = {
		/**
		 * No description
		 *
		 * @tags MachineModel
		 * @name MachineModelList
		 * @request GET:/MachineModel
		 */
		machineModelList: (
			query?: {
				/** @format uuid */
				accountId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineModel[], void>({
				path: `/MachineModel`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineModel
		 * @name MachineModelCreate
		 * @request POST:/MachineModel
		 */
		machineModelCreate: (
			data: MachineModel,
			query?: {
				/** @format uuid */
				accountId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/MachineModel`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineModel
		 * @name MachineModelUpdate
		 * @request PUT:/MachineModel
		 */
		machineModelUpdate: (
			data: MachineModel,
			query?: {
				/** @format uuid */
				accountId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/MachineModel`,
				method: "PUT",
				query: query,
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineModel
		 * @name MachineModelDetail
		 * @request GET:/MachineModel/{machineId}
		 */
		machineModelDetail: (
			machineId: string,
			query?: {
				/** @format uuid */
				accountId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineModel, ProblemDetails | void>({
				path: `/MachineModel/${machineId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineModel
		 * @name MachineModelDelete
		 * @request DELETE:/MachineModel/{machineId}
		 */
		machineModelDelete: (
			machineId: string,
			query?: {
				/** @format uuid */
				accountId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/MachineModel/${machineId}`,
				method: "DELETE",
				query: query,
				...params,
			}),
	};
	machineNotes = {
		/**
		 * No description
		 *
		 * @tags MachineNotes
		 * @name GetMachineNotes
		 * @request GET:/MachineNotes
		 */
		getMachineNotes: (
			query?: {
				/** @format uuid */
				machineId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineNotesDto[], ProblemDetails | void>({
				path: `/MachineNotes`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineNotes
		 * @name MachineNotesCreate
		 * @request POST:/MachineNotes
		 */
		machineNotesCreate: (
			data: MachineNoteCreateDto,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/MachineNotes`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineNotes
		 * @name MachineNotesUpdate
		 * @request PUT:/MachineNotes
		 */
		machineNotesUpdate: (
			data: MachineNoteUpdateDto,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/MachineNotes`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineNotes
		 * @name GetMachineNote
		 * @request GET:/MachineNotes/{noteId}
		 */
		getMachineNote: (noteId: string, params: RequestParams = {}) =>
			this.request<MachineNotesDto, ProblemDetails | void>({
				path: `/MachineNotes/${noteId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineNotes
		 * @name DeleteMachineNotes
		 * @request DELETE:/MachineNotes/{noteId}
		 */
		deleteMachineNotes: (noteId: string, params: RequestParams = {}) =>
			this.request<void, ProblemDetails | void>({
				path: `/MachineNotes/${noteId}`,
				method: "DELETE",
				...params,
			}),
	};
	machinePlatform = {
		/**
		 * No description
		 *
		 * @tags MachinePlatform
		 * @name GetActiveMachinePlatforms
		 * @request GET:/MachinePlatform
		 */
		getActiveMachinePlatforms: (
			query?: {
				machineMake?: string;
				/**
				 * @format int32
				 * @default 1
				 */
				page?: number;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<MachinePlatformDtoPageResponse, ProblemDetails | void>(
				{
					path: `/MachinePlatform`,
					method: "GET",
					query: query,
					format: "json",
					...params,
				},
			),

		/**
		 * No description
		 *
		 * @tags MachinePlatform
		 * @name AddMachinePlatform
		 * @request POST:/MachinePlatform
		 */
		addMachinePlatform: (
			data: MachinePlatformDto,
			params: RequestParams = {},
		) =>
			this.request<MachinePlatformPageResponse, ProblemDetails | void>({
				path: `/MachinePlatform`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	metrics = {
		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name AverageList
		 * @request GET:/metrics/{machineId}/{missionId}/average
		 */
		averageList: (
			machineId: string,
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<MetricsAverages, any>({
				path: `/metrics/${machineId}/${missionId}/average`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MetricsDetail
		 * @request GET:/metrics/{machineId}/{missionId}
		 */
		metricsDetail: (
			machineId: string,
			missionId: string,
			query?: {
				/** @format date-time */
				since?: string;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
				/** @default false */
				includeTotalCount?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<CombinedMetricsPage, ProblemDetails | void>({
				path: `/metrics/${machineId}/${missionId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name GetMetrics
		 * @request GET:/metrics/{machineId}/{missionId}/gps
		 * @deprecated
		 */
		getMetrics: (
			machineId: string,
			missionId: string,
			query?: {
				/**
				 * @format int32
				 * @default 10000
				 */
				maxDataPoints?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<GpsMetrics[], any>({
				path: `/metrics/${machineId}/${missionId}/gps`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name GpsPagedList
		 * @request GET:/metrics/{machineId}/{missionId}/gps/paged
		 * @deprecated
		 */
		gpsPagedList: (
			machineId: string,
			missionId: string,
			query?: {
				/**
				 * @format int32
				 * @default 1
				 */
				page?: number;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
				/** @default true */
				includeTotalCount?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<GpsMetricsPagedMetricsResponse, void>({
				path: `/metrics/${machineId}/${missionId}/gps/paged`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name GpsByTimestampList
		 * @request GET:/metrics/{machineId}/{missionId}/gps/by-timestamp
		 */
		gpsByTimestampList: (
			machineId: string,
			missionId: string,
			query?: {
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				/** @format int32 */
				intervalSeconds?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<GpsMetrics[], ProblemDetails | void>({
				path: `/metrics/${machineId}/${missionId}/gps/by-timestamp`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MachineList
		 * @request GET:/metrics/{machineId}/{missionId}/machine
		 * @deprecated
		 */
		machineList: (
			machineId: string,
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<MachineMetrics[], void>({
				path: `/metrics/${machineId}/${missionId}/machine`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MachinePagedList
		 * @request GET:/metrics/{machineId}/{missionId}/machine/paged
		 * @deprecated
		 */
		machinePagedList: (
			machineId: string,
			missionId: string,
			query?: {
				/**
				 * @format int32
				 * @default 1
				 */
				page?: number;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
				/** @default true */
				includeTotalCount?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineMetricsPagedMetricsResponse, void>({
				path: `/metrics/${machineId}/${missionId}/machine/paged`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MachineByTimestampList
		 * @request GET:/metrics/{machineId}/{missionId}/machine/by-timestamp
		 */
		machineByTimestampList: (
			machineId: string,
			missionId: string,
			query?: {
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				/** @format int32 */
				intervalSeconds?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineMetrics[], ProblemDetails | void>({
				path: `/metrics/${machineId}/${missionId}/machine/by-timestamp`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TaskResultsList
		 * @request GET:/metrics/{machineId}/task-results
		 */
		taskResultsList: (
			machineId: string,
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<Record<string, TaskResults>, void>({
				path: `/metrics/${machineId}/task-results`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TaskResultsList2
		 * @request GET:/metrics/task-results
		 * @originalName taskResultsList
		 * @duplicate
		 */
		taskResultsList2: (
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<Record<string, TaskResults>, void>({
				path: `/metrics/task-results`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsTaskResultsList
		 * @request GET:/metrics/organizations/task-results
		 */
		organizationsTaskResultsList: (
			query?: {
				orgIds?: string[];
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<Record<string, TaskResults>, void>({
				path: `/metrics/organizations/task-results`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name PathFollowerPerformanceList
		 * @request GET:/metrics/{machineId}/path-follower-performance
		 */
		pathFollowerPerformanceList: (
			machineId: string,
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					/** @format double */
					Inactive?: number;
					/** @format double */
					ParallelPid?: number;
					/** @format double */
					MachineFollower?: number;
				},
				void
			>({
				path: `/metrics/${machineId}/path-follower-performance`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name PathFollowerPerformanceList2
		 * @request GET:/metrics/path-follower-performance
		 * @originalName pathFollowerPerformanceList
		 * @duplicate
		 */
		pathFollowerPerformanceList2: (
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					/** @format double */
					Inactive?: number;
					/** @format double */
					ParallelPid?: number;
					/** @format double */
					MachineFollower?: number;
				},
				void
			>({
				path: `/metrics/path-follower-performance`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsPathFollowerPerformanceList
		 * @request GET:/metrics/organizations/path-follower-performance
		 */
		organizationsPathFollowerPerformanceList: (
			query?: {
				orgIds?: string[];
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					/** @format double */
					Inactive?: number;
					/** @format double */
					ParallelPid?: number;
					/** @format double */
					MachineFollower?: number;
				},
				void
			>({
				path: `/metrics/organizations/path-follower-performance`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name AvailabilityRateList
		 * @request GET:/metrics/{machineId}/availability-rate
		 */
		availabilityRateList: (
			machineId: string,
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, void>({
				path: `/metrics/${machineId}/availability-rate`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name AvailabilityRateList2
		 * @request GET:/metrics/availability-rate
		 * @originalName availabilityRateList
		 * @duplicate
		 */
		availabilityRateList2: (
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, void>({
				path: `/metrics/availability-rate`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsAvailabilityRateList
		 * @request GET:/metrics/organizations/availability-rate
		 */
		organizationsAvailabilityRateList: (
			query?: {
				orgIds?: string[];
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, void>({
				path: `/metrics/organizations/availability-rate`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TimeInMotionList
		 * @request GET:/metrics/{machineId}/time-in-motion
		 */
		timeInMotionList: (
			machineId: string,
			query: {
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/${machineId}/time-in-motion`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TimeInMotionList2
		 * @request GET:/metrics/time-in-motion
		 * @originalName timeInMotionList
		 * @duplicate
		 */
		timeInMotionList2: (
			query: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/time-in-motion`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsTimeInMotionList
		 * @request GET:/metrics/organizations/time-in-motion
		 */
		organizationsTimeInMotionList: (
			query: {
				orgIds?: string[];
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/organizations/time-in-motion`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MissionEfficiencyList
		 * @request GET:/metrics/{machineId}/mission-efficiency
		 */
		missionEfficiencyList: (
			machineId: string,
			query: {
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/${machineId}/mission-efficiency`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MissionEfficiencyList2
		 * @request GET:/metrics/mission-efficiency
		 * @originalName missionEfficiencyList
		 * @duplicate
		 */
		missionEfficiencyList2: (
			query: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/mission-efficiency`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsMissionEfficiencyList
		 * @request GET:/metrics/organizations/mission-efficiency
		 */
		organizationsMissionEfficiencyList: (
			query: {
				orgIds?: string[];
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/organizations/mission-efficiency`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name SpeedAchievementList
		 * @request GET:/metrics/{machineId}/speed-achievement
		 */
		speedAchievementList: (
			machineId: string,
			query: {
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/${machineId}/speed-achievement`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name SpeedAchievementList2
		 * @request GET:/metrics/speed-achievement
		 * @originalName speedAchievementList
		 * @duplicate
		 */
		speedAchievementList2: (
			query: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/speed-achievement`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsSpeedAchievementList
		 * @request GET:/metrics/organizations/speed-achievement
		 */
		organizationsSpeedAchievementList: (
			query: {
				orgIds?: string[];
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/organizations/speed-achievement`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TimeInStatesList
		 * @request GET:/metrics/{machineId}/time-in-states
		 */
		timeInStatesList: (
			machineId: string,
			query: {
				states?: RosSubState[];
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/${machineId}/time-in-states`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TimeInStatesList2
		 * @request GET:/metrics/time-in-states
		 * @originalName timeInStatesList
		 * @duplicate
		 */
		timeInStatesList2: (
			query: {
				states?: RosSubState[];
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/time-in-states`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsTimeInStatesList
		 * @request GET:/metrics/organizations/time-in-states
		 */
		organizationsTimeInStatesList: (
			query: {
				states?: RosSubState[];
				orgIds?: string[];
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/organizations/time-in-states`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MeanTimeInAutoList
		 * @request GET:/metrics/{machineId}/mean-time-in-auto
		 */
		meanTimeInAutoList: (
			machineId: string,
			query: {
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<MeanTimeInAutoResult, ProblemDetails | void>({
				path: `/metrics/${machineId}/mean-time-in-auto`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MeanTimeInAutoList2
		 * @request GET:/metrics/mean-time-in-auto
		 * @originalName meanTimeInAutoList
		 * @duplicate
		 */
		meanTimeInAutoList2: (
			query: {
				/** @format uuid */
				machineId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<MeanTimeInAutoResult, ProblemDetails | void>({
				path: `/metrics/mean-time-in-auto`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TotalAutonomousAreaList
		 * @request GET:/metrics/{machineId}/total-autonomous-area
		 */
		totalAutonomousAreaList: (
			machineId: string,
			query: {
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/${machineId}/total-autonomous-area`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TotalAutonomousAreaList2
		 * @request GET:/metrics/total-autonomous-area
		 * @originalName totalAutonomousAreaList
		 * @duplicate
		 */
		totalAutonomousAreaList2: (
			query: {
				/** @format uuid */
				machineId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/total-autonomous-area`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TotalAutonomousAreaList3
		 * @request GET:/metrics/{machineId}/{missionId}/total-autonomous-area
		 * @originalName totalAutonomousAreaList
		 * @duplicate
		 */
		totalAutonomousAreaList3: (
			machineId: string,
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<number, void>({
				path: `/metrics/${machineId}/${missionId}/total-autonomous-area`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MissionsTotalAutonomousAreaList
		 * @request GET:/metrics/missions/{missionId}/total-autonomous-area
		 */
		missionsTotalAutonomousAreaList: (
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<number, void>({
				path: `/metrics/missions/${missionId}/total-autonomous-area`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsTotalAutonomousAreaList
		 * @request GET:/metrics/organizations/total-autonomous-area
		 */
		organizationsTotalAutonomousAreaList: (
			query: {
				orgIds?: string[];
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/organizations/total-autonomous-area`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TotalAutonomousAcresList
		 * @request GET:/metrics/{machineId}/total-autonomous-acres
		 */
		totalAutonomousAcresList: (
			machineId: string,
			query: {
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/${machineId}/total-autonomous-acres`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TotalAutonomousAcresList2
		 * @request GET:/metrics/total-autonomous-acres
		 * @originalName totalAutonomousAcresList
		 * @duplicate
		 */
		totalAutonomousAcresList2: (
			query: {
				/** @format uuid */
				machineId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/total-autonomous-acres`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TotalAutonomousAcresList3
		 * @request GET:/metrics/{machineId}/{missionId}/total-autonomous-acres
		 * @originalName totalAutonomousAcresList
		 * @duplicate
		 */
		totalAutonomousAcresList3: (
			machineId: string,
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<number, void>({
				path: `/metrics/${machineId}/${missionId}/total-autonomous-acres`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MissionsTotalAutonomousAcresList
		 * @request GET:/metrics/missions/{missionId}/total-autonomous-acres
		 */
		missionsTotalAutonomousAcresList: (
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<number, void>({
				path: `/metrics/missions/${missionId}/total-autonomous-acres`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsTotalAutonomousAcresList
		 * @request GET:/metrics/organizations/total-autonomous-acres
		 */
		organizationsTotalAutonomousAcresList: (
			query: {
				orgIds?: string[];
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/organizations/total-autonomous-acres`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name InterruptionsPerAreaList
		 * @request GET:/metrics/{machineId}/interruptions-per-area
		 */
		interruptionsPerAreaList: (
			machineId: string,
			query: {
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<InterruptionsPerAreaResult, ProblemDetails | void>({
				path: `/metrics/${machineId}/interruptions-per-area`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name InterruptionsPerAreaList2
		 * @request GET:/metrics/interruptions-per-area
		 * @originalName interruptionsPerAreaList
		 * @duplicate
		 */
		interruptionsPerAreaList2: (
			query: {
				/** @format uuid */
				machineId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<InterruptionsPerAreaResult, ProblemDetails | void>({
				path: `/metrics/interruptions-per-area`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name InterruptionsPer100AcresList
		 * @request GET:/metrics/{machineId}/interruptions-per-100-acres
		 */
		interruptionsPer100AcresList: (
			machineId: string,
			query: {
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<InterruptionsPer100AcresResult, ProblemDetails | void>(
				{
					path: `/metrics/${machineId}/interruptions-per-100-acres`,
					method: "GET",
					query: query,
					format: "json",
					...params,
				},
			),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name InterruptionsPer100AcresList2
		 * @request GET:/metrics/interruptions-per-100-acres
		 * @originalName interruptionsPer100AcresList
		 * @duplicate
		 */
		interruptionsPer100AcresList2: (
			query: {
				/** @format uuid */
				machineId?: string;
				/** @format date-time */
				startTime: string;
				/** @format date-time */
				endTime: string;
				missionType: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<InterruptionsPer100AcresResult, ProblemDetails | void>(
				{
					path: `/metrics/interruptions-per-100-acres`,
					method: "GET",
					query: query,
					format: "json",
					...params,
				},
			),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name AutoDistanceTravelledList
		 * @request GET:/metrics/{machineId}/auto-distance-travelled
		 */
		autoDistanceTravelledList: (
			machineId: string,
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/${machineId}/auto-distance-travelled`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name AutoDistanceTravelledList2
		 * @request GET:/metrics/auto-distance-travelled
		 * @originalName autoDistanceTravelledList
		 * @duplicate
		 */
		autoDistanceTravelledList2: (
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				missionId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/auto-distance-travelled`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name OrganizationsAutoDistanceTravelledList
		 * @request GET:/metrics/organizations/auto-distance-travelled
		 */
		organizationsAutoDistanceTravelledList: (
			query?: {
				orgIds?: string[];
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				missionType?: MissionType;
			},
			params: RequestParams = {},
		) =>
			this.request<number, ProblemDetails | void>({
				path: `/metrics/organizations/auto-distance-travelled`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name PathList
		 * @request GET:/metrics/{machineId}/{missionId}/path
		 */
		pathList: (
			machineId: string,
			missionId: string,
			query?: {
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MultiLineString, ProblemDetails | void>({
				path: `/metrics/${machineId}/${missionId}/path`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name PathList2
		 * @request GET:/metrics/{missionId}/path
		 * @originalName pathList
		 * @duplicate
		 */
		pathList2: (
			missionId: string,
			query?: {
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				Record<string, MultiLineString>,
				ProblemDetails | void
			>({
				path: `/metrics/${missionId}/path`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TaskMetricsList
		 * @request GET:/metrics/{machineId}/{missionId}/task-metrics
		 */
		taskMetricsList: (
			machineId: string,
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<TaskMetrics[], void>({
				path: `/metrics/${machineId}/${missionId}/task-metrics`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TaskMetricsList2
		 * @request GET:/metrics/{missionId}/task-metrics
		 * @originalName taskMetricsList
		 * @duplicate
		 */
		taskMetricsList2: (missionId: string, params: RequestParams = {}) =>
			this.request<Record<string, TaskMetrics[]>, void>({
				path: `/metrics/${missionId}/task-metrics`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TaskPathsList
		 * @request GET:/metrics/{machineId}/{missionId}/task-paths
		 */
		taskPathsList: (
			machineId: string,
			missionId: string,
			query?: {
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<TaskPath[], void>({
				path: `/metrics/${machineId}/${missionId}/task-paths`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name TaskPathsList2
		 * @request GET:/metrics/{missionId}/task-paths
		 * @originalName taskPathsList
		 * @duplicate
		 */
		taskPathsList2: (
			missionId: string,
			query?: {
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<Record<string, TaskPath[]>, void>({
				path: `/metrics/${missionId}/task-paths`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MissionSegmentsDetail
		 * @request GET:/metrics/mission-segments/{missionId}
		 */
		missionSegmentsDetail: (
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<TimeSegment[], void>({
				path: `/metrics/mission-segments/${missionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name MissionSegmentsByMachineList
		 * @request GET:/metrics/mission-segments/{missionId}/by-machine
		 */
		missionSegmentsByMachineList: (
			missionId: string,
			params: RequestParams = {},
		) =>
			this.request<Record<string, TimeSegment[]>, void>({
				path: `/metrics/mission-segments/${missionId}/by-machine`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name RosStateEventsList
		 * @request GET:/metrics/{machineId}/{missionId}/ros-state-events
		 */
		rosStateEventsList: (
			machineId: string,
			missionId: string,
			query?: {
				/** @default false */
				includeLocation?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<RosStateEvent[], void>({
				path: `/metrics/${machineId}/${missionId}/ros-state-events`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Metrics
		 * @name RosStateEventsList2
		 * @request GET:/metrics/{missionId}/ros-state-events
		 * @originalName rosStateEventsList
		 * @duplicate
		 */
		rosStateEventsList2: (
			missionId: string,
			query?: {
				/** @default false */
				includeLocation?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<Record<string, RosStateEvent[]>, void>({
				path: `/metrics/${missionId}/ros-state-events`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	multiMachineMissions = {
		/**
		 * No description
		 *
		 * @tags Missions
		 * @name MultiMachineMissionsCreate
		 * @request POST:/multi-machine-missions
		 */
		multiMachineMissionsCreate: (
			data: NewMission,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/multi-machine-missions`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	johndeereIntegration = {
		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetFields
		 * @request GET:/johndeere-integration/Organizations/{organizationId}/farms/{farmId}/fields
		 */
		getFields: (
			organizationId: string,
			farmId: string,
			params: RequestParams = {},
		) =>
			this.request<FieldDto[], ProblemDetails | void>({
				path: `/johndeere-integration/Organizations/${organizationId}/farms/${farmId}/fields`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetFieldBoundaries
		 * @request GET:/johndeere-integration/Organizations/{organizationId}/farms/{farmId}/fields/{fieldId}/boundaries
		 */
		getFieldBoundaries: (
			organizationId: string,
			farmId: string,
			fieldId: string,
			params: RequestParams = {},
		) =>
			this.request<FieldBoundaryDto, ProblemDetails | void>({
				path: `/johndeere-integration/Organizations/${organizationId}/farms/${farmId}/fields/${fieldId}/boundaries`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetFullFieldBoundaries
		 * @request GET:/johndeere-integration/Organizations/{organizationId}/farms/{farmId}/fields/{fieldId}/full-boundaries
		 */
		getFullFieldBoundaries: (
			organizationId: string,
			farmId: string,
			fieldId: string,
			params: RequestParams = {},
		) =>
			this.request<JohnDeereBoundaryListDto, ProblemDetails | void>({
				path: `/johndeere-integration/Organizations/${organizationId}/farms/${farmId}/fields/${fieldId}/full-boundaries`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetListFieldBoundaries
		 * @request GET:/johndeere-integration/Organizations/{organizationId}/farms/{farmId}/fields/boundaries
		 */
		getListFieldBoundaries: (
			organizationId: string,
			farmId: string,
			query?: {
				fieldIds?: string[];
			},
			params: RequestParams = {},
		) =>
			this.request<FieldBoundaryDto[], ProblemDetails | void>({
				path: `/johndeere-integration/Organizations/${organizationId}/farms/${farmId}/fields/boundaries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetOrganizations
		 * @request GET:/johndeere-integration/Organizations
		 */
		getOrganizations: (params: RequestParams = {}) =>
			this.request<OrganizationDto[], ProblemDetails | void>({
				path: `/johndeere-integration/Organizations`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetOrganization
		 * @request GET:/johndeere-integration/Organizations/{organizationId}
		 */
		getOrganization: (organizationId: string, params: RequestParams = {}) =>
			this.request<OrganizationDto, ProblemDetails | void>({
				path: `/johndeere-integration/Organizations/${organizationId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetFarms
		 * @request GET:/johndeere-integration/Organizations/{organizationId}/farms
		 */
		getFarms: (organizationId: string, params: RequestParams = {}) =>
			this.request<FarmDto[], ProblemDetails | void>({
				path: `/johndeere-integration/Organizations/${organizationId}/farms`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetFarm
		 * @request GET:/johndeere-integration/Organizations/{organizationId}/farms/{farmId}
		 */
		getFarm: (
			organizationId: string,
			farmId: string,
			params: RequestParams = {},
		) =>
			this.request<FarmDto, ProblemDetails | void>({
				path: `/johndeere-integration/Organizations/${organizationId}/farms/${farmId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetGuidanceLines
		 * @request GET:/johndeere-integration/Organizations/{organizationId}/fields/{fieldId}/guidancelines
		 */
		getGuidanceLines: (
			organizationId: string,
			fieldId: string,
			params: RequestParams = {},
		) =>
			this.request<
				(
					| JohnDeereAbLineDto
					| JohnDeereCircleTrackDto
					| JohnDeereAbCurveDto
				)[],
				ProblemDetails | void
			>({
				path: `/johndeere-integration/Organizations/${organizationId}/fields/${fieldId}/guidancelines`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Organizations
		 * @name GetGuidanceLine
		 * @request GET:/johndeere-integration/Organizations/{organizationId}/fields/{fieldId}/guidancelines/{guidanceLineId}
		 */
		getGuidanceLine: (
			organizationId: string,
			fieldId: string,
			guidanceLineId: string,
			query?: {
				embed?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				| JohnDeereAbLineDto
				| JohnDeereCircleTrackDto
				| JohnDeereAbCurveDto,
				ProblemDetails | void
			>({
				path: `/johndeere-integration/Organizations/${organizationId}/fields/${fieldId}/guidancelines/${guidanceLineId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags WellKnown
		 * @name WellKnownList
		 * @request GET:/johndeere-integration/WellKnown
		 */
		wellKnownList: (params: RequestParams = {}) =>
			this.request<WellKnownDto, any>({
				path: `/johndeere-integration/WellKnown`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	recordingSession = {
		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name RecordingSessionDetail
		 * @request GET:/recording-session/{sessionId}
		 * @deprecated
		 */
		recordingSessionDetail: (
			sessionId: string,
			params: RequestParams = {},
		) =>
			this.request<PathRecordingSession, void>({
				path: `/recording-session/${sessionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name FromPointsList
		 * @request GET:/recording-session/{sessionId}/from-points
		 */
		fromPointsList: (sessionId: string, params: RequestParams = {}) =>
			this.request<PathRecordingSession, void>({
				path: `/recording-session/${sessionId}/from-points`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name EventsList
		 * @request GET:/recording-session/{sessionId}/events
		 */
		eventsList: (sessionId: string, params: RequestParams = {}) =>
			this.request<PathRecordingEvent[], void>({
				path: `/recording-session/${sessionId}/events`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name EventsCreate
		 * @request POST:/recording-session/{sessionId}/events
		 */
		eventsCreate: (
			sessionId: string,
			data: CreatePathRecordingEventRequest,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/recording-session/${sessionId}/events`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name EventsDelete
		 * @request DELETE:/recording-session/{sessionId}/events
		 */
		eventsDelete: (
			sessionId: string,
			data: DeletePathRecordingEventsRequest,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/recording-session/${sessionId}/events`,
				method: "DELETE",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name ObstacleCreate
		 * @request POST:/recording-session/{sessionId}/obstacle
		 */
		obstacleCreate: (
			sessionId: string,
			data: CreateObstacleRequest,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/recording-session/${sessionId}/obstacle`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name ObstaclesList
		 * @request GET:/recording-session/{sessionId}/obstacles
		 */
		obstaclesList: (sessionId: string, params: RequestParams = {}) =>
			this.request<PathRecordingPolygon[], void>({
				path: `/recording-session/${sessionId}/obstacles`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name ObstaclesDelete
		 * @request DELETE:/recording-session/{sessionId}/obstacles/{obstacleId}
		 */
		obstaclesDelete: (
			sessionId: string,
			obstacleId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/recording-session/${sessionId}/obstacles/${obstacleId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name ObstaclesApplyToFieldCreate
		 * @request POST:/recording-session/{sessionId}/obstacles/apply-to-field/{fieldId}
		 */
		obstaclesApplyToFieldCreate: (
			sessionId: string,
			fieldId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/recording-session/${sessionId}/obstacles/apply-to-field/${fieldId}`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name ProcessedList
		 * @request GET:/recording-session/{sessionId}/processed
		 */
		processedList: (sessionId: string, params: RequestParams = {}) =>
			this.request<ProcessedPathRecordingResponse, ProblemDetails | void>(
				{
					path: `/recording-session/${sessionId}/processed`,
					method: "GET",
					format: "json",
					...params,
				},
			),

		/**
		 * No description
		 *
		 * @tags PathRecording
		 * @name ProcessedFromPointsList
		 * @request GET:/recording-session/{sessionId}/processed-from-points
		 */
		processedFromPointsList: (
			sessionId: string,
			params: RequestParams = {},
		) =>
			this.request<ProcessedPathRecordingResponse, ProblemDetails | void>(
				{
					path: `/recording-session/${sessionId}/processed-from-points`,
					method: "GET",
					format: "json",
					...params,
				},
			),
	};
	paths = {
		/**
		 * No description
		 *
		 * @tags Paths
		 * @name PathsCreate
		 * @request POST:/paths
		 */
		pathsCreate: (
			data: SimplePoint[],
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				implementId?: string;
				/** @format double */
				turningRadiusMeters?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails>({
				path: `/paths`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Paths
		 * @name PostPaths
		 * @request POST:/paths/v2
		 */
		postPaths: (
			data: CreatePlannedPathRequest,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails>({
				path: `/paths/v2`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Paths
		 * @name ClothoidCreate
		 * @request POST:/paths/clothoid/{pathId}
		 */
		clothoidCreate: (
			pathId: string,
			data: ClothoidPath,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails>({
				path: `/paths/clothoid/${pathId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Paths
		 * @name LinkToMissionCreate
		 * @request POST:/paths/{plannedPathId}/link-to-mission/{missionId}
		 */
		linkToMissionCreate: (
			missionId: string,
			plannedPathId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails>({
				path: `/paths/${plannedPathId}/link-to-mission/${missionId}`,
				method: "POST",
				...params,
			}),
	};
	ping = {
		/**
		 * No description
		 *
		 * @tags Ping
		 * @name PingList
		 * @request GET:/Ping
		 */
		pingList: (params: RequestParams = {}) =>
			this.request<ContentResult, ProblemDetails>({
				path: `/Ping`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	pointsOfInterest = {
		/**
		 * No description
		 *
		 * @tags PointsOfInterest
		 * @name GetPointOfInterest
		 * @request GET:/points-of-interest/{pointOfInterestId}
		 */
		getPointOfInterest: (
			pointOfInterestId: string,
			params: RequestParams = {},
		) =>
			this.request<PointOfInterest, ProblemDetails | void>({
				path: `/points-of-interest/${pointOfInterestId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PointsOfInterest
		 * @name PointsOfInterestDelete
		 * @request DELETE:/points-of-interest/{pointOfInterestId}
		 */
		pointsOfInterestDelete: (
			pointOfInterestId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/points-of-interest/${pointOfInterestId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PointsOfInterest
		 * @name PointsOfInterestCreate
		 * @request POST:/points-of-interest
		 */
		pointsOfInterestCreate: (
			data: NewPointOfInterest,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/points-of-interest`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PointsOfInterest
		 * @name PointsOfInterestUpdate
		 * @request PUT:/points-of-interest
		 */
		pointsOfInterestUpdate: (
			data: PointOfInterestUpdate,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/points-of-interest`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),
	};
	pushNotifications = {
		/**
		 * No description
		 *
		 * @tags PushNotifications
		 * @name RegisterCreate
		 * @request POST:/push-notifications/register
		 */
		registerCreate: (data: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/push-notifications/register`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PushNotifications
		 * @name RegisterDelete
		 * @request DELETE:/push-notifications/register
		 */
		registerDelete: (data: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/push-notifications/register`,
				method: "DELETE",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PushNotifications
		 * @name PushNotificationsList
		 * @request GET:/push-notifications
		 */
		pushNotificationsList: (params: RequestParams = {}) =>
			this.request<PushNotificationConfig, void>({
				path: `/push-notifications`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PushNotifications
		 * @name PushNotificationsCreate
		 * @request POST:/push-notifications
		 */
		pushNotificationsCreate: (
			data: PushNotificationConfig,
			params: RequestParams = {},
		) =>
			this.request<number, void>({
				path: `/push-notifications`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PushNotifications
		 * @name PushNotificationsDelete
		 * @request DELETE:/push-notifications
		 */
		pushNotificationsDelete: (params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/push-notifications`,
				method: "DELETE",
				...params,
			}),
	};
	ros = {
		/**
		 * No description
		 *
		 * @tags RosCalibration
		 * @name CalibrationSteeringMachineDetail
		 * @request GET:/ros/calibration/steering/machine/{machineId}
		 */
		calibrationSteeringMachineDetail: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<RosSteeringCalibration, ProblemDetails | void>({
				path: `/ros/calibration/steering/machine/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosCalibration
		 * @name CalibrationSteeringMachineUpdate
		 * @request PUT:/ros/calibration/steering/machine/{machineId}
		 */
		calibrationSteeringMachineUpdate: (
			machineId: string,
			data: UpdateRosSteeringCalibration,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/ros/calibration/steering/machine/${machineId}`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosCalibration
		 * @name CalibrationSteeringMachineDelete
		 * @request DELETE:/ros/calibration/steering/machine/{machineId}
		 */
		calibrationSteeringMachineDelete: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/ros/calibration/steering/machine/${machineId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags RosCalibration
		 * @name CalibrationSteeringCreate
		 * @request POST:/ros/calibration/steering
		 */
		calibrationSteeringCreate: (
			machineId: string,
			data: NewRosSteeringCalibration,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/ros/calibration/steering`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	simulator = {
		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name StartEc2Create
		 * @request POST:/simulator/{instanceId}/start-ec2
		 */
		startEc2Create: (instanceId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/start-ec2`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name StopEc2Create
		 * @request POST:/simulator/{instanceId}/stop-ec2
		 */
		stopEc2Create: (instanceId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/stop-ec2`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name StatusList
		 * @request GET:/simulator/status
		 */
		statusList: (params: RequestParams = {}) =>
			this.request<SimulatorInstanceStatus[], void>({
				path: `/simulator/status`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name StartCreate
		 * @request POST:/simulator/{instanceId}/start
		 */
		startCreate: (instanceId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/start`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageStartCreate
		 * @request POST:/simulator/{instanceId}/tillage/start
		 */
		tillageStartCreate: (instanceId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/tillage/start`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name StopCreate
		 * @request POST:/simulator/{instanceId}/stop
		 */
		stopCreate: (instanceId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/stop`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageStopCreate
		 * @request POST:/simulator/{instanceId}/tillage/stop
		 */
		tillageStopCreate: (instanceId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/tillage/stop`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageLocationUpdate
		 * @request PUT:/simulator/{instanceId}/tillage/location
		 */
		tillageLocationUpdate: (
			instanceId: string,
			data: SetLocationRequest,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/tillage/location`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageStageList
		 * @request GET:/simulator/{instanceId}/tillage/stage
		 */
		tillageStageList: (instanceId: string, params: RequestParams = {}) =>
			this.request<GetStageResponse, void>({
				path: `/simulator/${instanceId}/tillage/stage`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageStageUpdate
		 * @request PUT:/simulator/{instanceId}/tillage/stage
		 */
		tillageStageUpdate: (
			instanceId: string,
			data: SetStageRequest,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/tillage/stage`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageVersionsPartialUpdate
		 * @request PATCH:/simulator/{instanceId}/tillage/versions
		 */
		tillageVersionsPartialUpdate: (
			instanceId: string,
			data: ImageVersions,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/simulator/${instanceId}/tillage/versions`,
				method: "PATCH",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageVersionsList
		 * @request GET:/simulator/{instanceId}/tillage/versions
		 */
		tillageVersionsList: (instanceId: string, params: RequestParams = {}) =>
			this.request<ImageVersions, void>({
				path: `/simulator/${instanceId}/tillage/versions`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageCertCreate
		 * @request POST:/simulator/{instanceId}/tillage/cert
		 */
		tillageCertCreate: (
			instanceId: string,
			data: SetTillageCertRequest,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/simulator/${instanceId}/tillage/cert`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageCertList
		 * @request GET:/simulator/{instanceId}/tillage/cert
		 */
		tillageCertList: (instanceId: string, params: RequestParams = {}) =>
			this.request<TillageCertResponse, void>({
				path: `/simulator/${instanceId}/tillage/cert`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageCertDelete
		 * @request DELETE:/simulator/{instanceId}/tillage/cert
		 */
		tillageCertDelete: (instanceId: string, params: RequestParams = {}) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/tillage/cert`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageLogsList
		 * @request GET:/simulator/{instanceId}/tillage/logs
		 */
		tillageLogsList: (instanceId: string, params: RequestParams = {}) =>
			this.request<string, void>({
				path: `/simulator/${instanceId}/tillage/logs`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestStartCreate
		 * @request POST:/simulator/{instanceId}/harvest/start
		 */
		harvestStartCreate: (instanceId: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/simulator/${instanceId}/harvest/start`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestStopCreate
		 * @request POST:/simulator/{instanceId}/harvest/stop
		 */
		harvestStopCreate: (instanceId: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/simulator/${instanceId}/harvest/stop`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestLocationUpdate
		 * @request PUT:/simulator/{instanceId}/harvest/location
		 */
		harvestLocationUpdate: (
			instanceId: string,
			data: SetLocationRequest,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/harvest/location`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestStageList
		 * @request GET:/simulator/{instanceId}/harvest/stage
		 */
		harvestStageList: (instanceId: string, params: RequestParams = {}) =>
			this.request<GetStageResponse, void>({
				path: `/simulator/${instanceId}/harvest/stage`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestStageUpdate
		 * @request PUT:/simulator/{instanceId}/harvest/stage
		 */
		harvestStageUpdate: (
			instanceId: string,
			data: SetStageRequest,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/harvest/stage`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestCertsCreate
		 * @request POST:/simulator/{instanceId}/harvest/certs
		 */
		harvestCertsCreate: (
			instanceId: string,
			data: SetHarvestCertsRequest,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/simulator/${instanceId}/harvest/certs`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestCertsList
		 * @request GET:/simulator/{instanceId}/harvest/certs
		 */
		harvestCertsList: (instanceId: string, params: RequestParams = {}) =>
			this.request<ListCertsResponse, void>({
				path: `/simulator/${instanceId}/harvest/certs`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestCertsDelete
		 * @request DELETE:/simulator/{instanceId}/harvest/certs/{name}
		 */
		harvestCertsDelete: (
			instanceId: string,
			name: string,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/harvest/certs/${name}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestVersionsPartialUpdate
		 * @request PATCH:/simulator/{instanceId}/harvest/versions
		 */
		harvestVersionsPartialUpdate: (
			instanceId: string,
			data: ImageVersions,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/simulator/${instanceId}/harvest/versions`,
				method: "PATCH",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestVersionsList
		 * @request GET:/simulator/{instanceId}/harvest/versions
		 */
		harvestVersionsList: (instanceId: string, params: RequestParams = {}) =>
			this.request<ImageVersions, void>({
				path: `/simulator/${instanceId}/harvest/versions`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestLogsList
		 * @request GET:/simulator/{instanceId}/harvest/logs
		 */
		harvestLogsList: (instanceId: string, params: RequestParams = {}) =>
			this.request<string, void>({
				path: `/simulator/${instanceId}/harvest/logs`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestAutoharvestList
		 * @request GET:/simulator/{instanceId}/harvest/autoharvest
		 */
		harvestAutoharvestList: (
			instanceId: string,
			params: RequestParams = {},
		) =>
			this.request<boolean, void>({
				path: `/simulator/${instanceId}/harvest/autoharvest`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestAutoharvestCreate
		 * @request POST:/simulator/{instanceId}/harvest/autoharvest
		 */
		harvestAutoharvestCreate: (
			instanceId: string,
			data: boolean,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/simulator/${instanceId}/harvest/autoharvest`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestAutoharvestFileList
		 * @request GET:/simulator/{instanceId}/harvest/autoharvest_file
		 */
		harvestAutoharvestFileList: (
			instanceId: string,
			params: RequestParams = {},
		) =>
			this.request<string, void>({
				path: `/simulator/${instanceId}/harvest/autoharvest_file`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestAutoharvestFileCreate
		 * @request POST:/simulator/{instanceId}/harvest/autoharvest_file
		 */
		harvestAutoharvestFileCreate: (
			instanceId: string,
			data: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/simulator/${instanceId}/harvest/autoharvest_file`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestAutoharvestFileAvailableList
		 * @request GET:/simulator/{instanceId}/harvest/autoharvest_file/available
		 */
		harvestAutoharvestFileAvailableList: (
			instanceId: string,
			params: RequestParams = {},
		) =>
			this.request<string[], void>({
				path: `/simulator/${instanceId}/harvest/autoharvest_file/available`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestAutoharvestFilePathDetail
		 * @request GET:/simulator/{instanceId}/harvest/autoharvest_file/path/{fileName}
		 */
		harvestAutoharvestFilePathDetail: (
			instanceId: string,
			fileName: string,
			query?: {
				/** @format double */
				simplificationThreshold?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<LineString, ProblemDetails | void>({
				path: `/simulator/${instanceId}/harvest/autoharvest_file/path/${fileName}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestAutoharvestFilePathCreate
		 * @request POST:/simulator/{instanceId}/harvest/autoharvest_file/path/{fileName}
		 */
		harvestAutoharvestFilePathCreate: (
			instanceId: string,
			fileName: string,
			data: AddAutoHarvestPathFileRequest,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/simulator/${instanceId}/harvest/autoharvest_file/path/${fileName}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageRosLogsList
		 * @request GET:/simulator/{instanceId}/tillage/ros_logs
		 */
		tillageRosLogsList: (instanceId: string, params: RequestParams = {}) =>
			this.request<RosLogFile[], void>({
				path: `/simulator/${instanceId}/tillage/ros_logs`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name TillageRosLogsDetail
		 * @request GET:/simulator/{instanceId}/tillage/ros_logs/{fileName}
		 */
		tillageRosLogsDetail: (
			instanceId: string,
			fileName: string,
			params: RequestParams = {},
		) =>
			this.request<RosLogUploadResponse, void>({
				path: `/simulator/${instanceId}/tillage/ros_logs/${fileName}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestRosLogsList
		 * @request GET:/simulator/{instanceId}/harvest/ros_logs
		 */
		harvestRosLogsList: (instanceId: string, params: RequestParams = {}) =>
			this.request<RosLogFile[], void>({
				path: `/simulator/${instanceId}/harvest/ros_logs`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Simulator
		 * @name HarvestRosLogsDetail
		 * @request GET:/simulator/{instanceId}/harvest/ros_logs/{fileName}
		 */
		harvestRosLogsDetail: (
			instanceId: string,
			fileName: string,
			params: RequestParams = {},
		) =>
			this.request<RosLogUploadResponse, void>({
				path: `/simulator/${instanceId}/harvest/ros_logs/${fileName}`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	stillImages = {
		/**
		 * No description
		 *
		 * @tags StillImage
		 * @name StillImagesSnapshotsDetail
		 * @request GET:/still-images/still-images/snapshots/{jobId}
		 * @deprecated
		 */
		stillImagesSnapshotsDetail: (
			jobId: string,
			params: RequestParams = {},
		) =>
			this.request<Record<string, StillImage[]>, ProblemDetails | void>({
				path: `/still-images/still-images/snapshots/${jobId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags StillImage
		 * @name StillImagesDetail
		 * @request GET:/still-images/{jobId}
		 * @deprecated
		 */
		stillImagesDetail: (
			jobId: string,
			query?: {
				cameraNames?: string[];
				/** @default false */
				latest?: boolean;
				/** @format int32 */
				limit?: number;
				/** @format int32 */
				offset?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<Record<string, StillImage[]>, ProblemDetails | void>({
				path: `/still-images/${jobId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	subscriptions = {
		/**
		 * No description
		 *
		 * @tags Subscriptions
		 * @name GetSubscriptions
		 * @request GET:/Subscriptions
		 */
		getSubscriptions: (
			query?: {
				/** @format uuid */
				organizationId?: string;
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				subscriptionId?: string;
				/** @format date-time */
				expiredBy?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<SubscriptionDto[], ProblemDetails | void>({
				path: `/Subscriptions`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Subscriptions
		 * @name SubscriptionsCreate
		 * @request POST:/Subscriptions
		 */
		subscriptionsCreate: (
			data: SubscriptionDto,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/Subscriptions`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Subscriptions
		 * @name SubscriptionsUpdate
		 * @request PUT:/Subscriptions
		 */
		subscriptionsUpdate: (
			data: SubscriptionDto,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/Subscriptions`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Subscriptions
		 * @name GetSubscription
		 * @request GET:/Subscriptions/{subscriptionId}
		 */
		getSubscription: (subscriptionId: string, params: RequestParams = {}) =>
			this.request<SubscriptionDto, ProblemDetails | void>({
				path: `/Subscriptions/${subscriptionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Subscriptions
		 * @name GetSubscriptionValidity
		 * @request GET:/Subscriptions/organizations/{organizationId}/machines/{machineId}
		 */
		getSubscriptionValidity: (
			organizationId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<SubscriptionValidityDto, ProblemDetails | void>({
				path: `/Subscriptions/organizations/${organizationId}/machines/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Subscriptions
		 * @name CancelSubscription
		 * @request POST:/Subscriptions/{subscriptionId}/cancel
		 */
		cancelSubscription: (
			subscriptionId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/Subscriptions/${subscriptionId}/cancel`,
				method: "POST",
				...params,
			}),
	};
	telemetries = {
		/**
		 * No description
		 *
		 * @tags Telemetries
		 * @name GetTelemetry
		 * @request GET:/telemetries/{telemetryId}
		 */
		getTelemetry: (telemetryId: string, params: RequestParams = {}) =>
			this.request<SystemSoftwareUpdaterTelemetry, ProblemDetails | void>(
				{
					path: `/telemetries/${telemetryId}`,
					method: "GET",
					format: "json",
					...params,
				},
			),

		/**
		 * No description
		 *
		 * @tags Telemetries
		 * @name TelemetriesList
		 * @request GET:/telemetries
		 */
		telemetriesList: (
			query?: {
				/** @format uuid */
				accountId?: string;
				/** @format uuid */
				machineId?: string;
				logType?: TelemetryLogType;
				serialNumber?: string;
				systemVersion?: string;
				/** @format date-time */
				startDate?: string;
				/** @format date-time */
				endDate?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				SystemSoftwareUpdaterTelemetry[],
				ProblemDetails | void
			>({
				path: `/telemetries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Telemetries
		 * @name GetLatestTelemetries
		 * @request GET:/telemetries/{accountId}/latest
		 */
		getLatestTelemetries: (
			accountId: string,
			query?: {
				/** @format uuid */
				machineId?: string;
				logType?: TelemetryLogType;
				serialNumber?: string;
				systemVersion?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				SystemSoftwareUpdaterTelemetry[],
				ProblemDetails | void
			>({
				path: `/telemetries/${accountId}/latest`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	unloadTarget = {
		/**
		 * No description
		 *
		 * @tags UnloadTarget
		 * @name GetUnloadTargetsByHarvesterAndCart
		 * @request GET:/unload-target
		 */
		getUnloadTargetsByHarvesterAndCart: (
			query?: {
				/** @format uuid */
				harvesterId?: string;
				/** @format uuid */
				cartId?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<UnloadTarget[], void>({
				path: `/unload-target`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UnloadTarget
		 * @name CreateOrUpdateUnloadTarget
		 * @request POST:/unload-target
		 */
		createOrUpdateUnloadTarget: (
			data: UnloadTarget,
			params: RequestParams = {},
		) =>
			this.request<void, void>({
				path: `/unload-target`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),
	};
	unloadTargets = {
		/**
		 * No description
		 *
		 * @tags UnloadTarget
		 * @name GetAllUnloadTargetsForCart
		 * @request GET:/unload-targets/{machineId}
		 */
		getAllUnloadTargetsForCart: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<UnloadTarget[], void>({
				path: `/unload-targets/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UnloadTarget
		 * @name GetAllUnloadTargetsForHarvester
		 * @request GET:/unload-targets/harvester/{machineId}
		 */
		getAllUnloadTargetsForHarvester: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<UnloadTarget[], void>({
				path: `/unload-targets/harvester/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
}
